(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3ec4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3ec4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
Object.defineProperty({}, "ClipboardCopy", {
    get: function() {
        return $0da3d504155236c3$export$ea3b71af1761ff40;
    },
    set: void 0,
    enumerable: !0,
    configurable: !0
});
let $0da3d504155236c3$var$t = "clipboard-copy", $0da3d504155236c3$var$e = "success", $0da3d504155236c3$var$o = "error", $0da3d504155236c3$var$s = document.createElement("template");
$0da3d504155236c3$var$s.innerHTML = `
  <style>
    :host([hidden]),
    [hidden],
    ::slotted([hidden]) {
      display: none !important;
    }
  </style>

  <button type="button" part="button">
    <slot name="copy">Copy</slot>
    <slot name="success" hidden>Copied!</slot>
    <slot name="error" hidden>Error</slot>
  </button>
`;
class $0da3d504155236c3$export$ea3b71af1761ff40 extends HTMLElement {
    #t = null;
    #e;
    #o;
    #s;
    #i;
    constructor(){
        super(), this.shadowRoot || (this.attachShadow({
            mode: "open"
        }), this.shadowRoot.appendChild($0da3d504155236c3$var$s.content.cloneNode(!0))), this.#e = this.shadowRoot.querySelector("button"), this.#o = this.shadowRoot.querySelector('slot[name="copy"]'), this.#s = this.shadowRoot.querySelector('slot[name="success"]'), this.#i = this.shadowRoot.querySelector('slot[name="error"]');
    }
    static get observedAttributes() {
        return [
            "disabled"
        ];
    }
    connectedCallback() {
        this.#r("value"), this.#r("from"), this.#r("disabled"), this.#r("feedbackDuration"), this.#e.addEventListener("click", this.#n);
    }
    disconnectedCallback() {
        this.#e.removeEventListener("click", this.#n), this.#a();
    }
    attributeChangedCallback(t) {
        "disabled" === t && (this.#e.disabled = this.disabled, this.#e.setAttribute("aria-disabled", this.disabled.toString()), this.#e.part.contains("button") && this.#e.part.toggle("button--disabled", this.disabled));
    }
    get value() {
        return this.getAttribute("value");
    }
    set value(t) {
        this.setAttribute("value", t);
    }
    get from() {
        return this.getAttribute("from");
    }
    set from(t) {
        this.setAttribute("from", t);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(t) {
        t ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
    }
    get feedbackDuration() {
        return Number(this.getAttribute("feedback-duration")) || 1e3;
    }
    set feedbackDuration(t) {
        this.setAttribute("feedback-duration", t);
    }
    async #l() {
        if (this.value || this.from) try {
            let o = "";
            if (this.value) o = this.value;
            else if (this.from) {
                let t = "getRootNode" in Element.prototype ? this.#e.getRootNode({
                    composed: !0
                }) : this.#e.ownerDocument;
                if (!t || !(t instanceof Document || t instanceof ShadowRoot)) return;
                let e = t.querySelector(this.from);
                if (!e) return;
                o = e instanceof HTMLInputElement || e instanceof HTMLTextAreaElement ? e.value : e instanceof HTMLAnchorElement && e.hasAttribute("href") ? e.href : e.textContent;
            }
            await navigator.clipboard.writeText(o), this.#d($0da3d504155236c3$var$e), this.dispatchEvent(new CustomEvent(`${$0da3d504155236c3$var$t}-success`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    value: o
                }
            }));
        } catch (e) {
            this.#d($0da3d504155236c3$var$o), this.dispatchEvent(new CustomEvent(`${$0da3d504155236c3$var$t}-error`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: e
                }
            }));
        }
    }
    #n = (t)=>{
        t.preventDefault(), this.disabled || this.#t || this.#l();
    };
    #d(t) {
        this.#o.hidden = !0, this.#s.hidden = t !== $0da3d504155236c3$var$e, this.#i.hidden = t !== $0da3d504155236c3$var$o, this.#e.part.remove("button--success"), this.#e.part.remove("button--error"), this.#e.part.add(`button--${t}`), this.#t && clearTimeout(this.#t), this.#t = setTimeout(()=>{
            this.#o.hidden = !1, this.#s.hidden = !0, this.#i.hidden = !0, this.#e.part.remove(`button--${t}`), this.#t = null;
        }, this.feedbackDuration);
    }
    #a() {
        this.#t && clearTimeout(this.#t), this.#t = null, this.#o.hidden = !1, this.#s.hidden = !0, this.#i.hidden = !0, this.#e.part.remove("button--success"), this.#e.part.remove("button--error");
    }
    #r(t) {
        if (Object.prototype.hasOwnProperty.call(this, t)) {
            let e = this[t];
            delete this[t], this[t] = e;
        }
    }
    static defineCustomElement(e = $0da3d504155236c3$var$t) {
        "undefined" == typeof window || window.customElements.get(e) || window.customElements.define(e, $0da3d504155236c3$export$ea3b71af1761ff40);
    }
}
$0da3d504155236c3$export$ea3b71af1761ff40.defineCustomElement();


Object.defineProperty({}, "WebShare", {
    get: function() {
        return $4f74a8126e204146$export$30b344bef3e55b67;
    },
    set: void 0,
    enumerable: !0,
    configurable: !0
});
let $4f74a8126e204146$var$t = `
  :host {
    display: inline-block;
  }
`, $4f74a8126e204146$var$e = document.createElement("template");
$4f74a8126e204146$var$e.innerHTML = `
  <style>${$4f74a8126e204146$var$t}</style>
  <slot name="button"><button type="button" part="button"><slot name="button-content">Share</slot></button></slot>
`;
class $4f74a8126e204146$export$30b344bef3e55b67 extends HTMLElement {
    #t;
    #e;
    #s = [];
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open",
            delegatesFocus: !0
        }).appendChild($4f74a8126e204146$var$e.content.cloneNode(!0)), this.#t = this.shadowRoot?.querySelector('slot[name="button"]') || null, this.#e = this.#i();
    }
    static get observedAttributes() {
        return [
            "disabled"
        ];
    }
    attributeChangedCallback(t, e, s) {
        "disabled" === t && e !== s && this.#e && (this.#e.toggleAttribute("disabled", this.disabled), this.#e.setAttribute("aria-disabled", this.disabled.toString()), this.#e.part && this.#e.part.contains("button") && this.#e.part.toggle("button--disabled", this.disabled));
    }
    connectedCallback() {
        this.#r("shareUrl"), this.#r("shareTitle"), this.#r("shareText"), this.#r("shareFiles"), this.#r("disabled"), this.#t?.addEventListener("slotchange", this.#a), this.#e?.addEventListener("click", this.#n);
    }
    disconnectedCallback() {
        this.#t?.removeEventListener("slotchange", this.#a), this.#e?.removeEventListener("click", this.#n);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(t) {
        this.toggleAttribute("disabled", !!t);
    }
    get shareUrl() {
        return this.getAttribute("share-url") || "";
    }
    set shareUrl(t) {
        this.setAttribute("share-url", t);
    }
    get shareTitle() {
        return this.getAttribute("share-title") || "";
    }
    set shareTitle(t) {
        this.setAttribute("share-title", t);
    }
    get shareText() {
        return this.getAttribute("share-text") || "";
    }
    set shareText(t) {
        this.setAttribute("share-text", t);
    }
    get shareFiles() {
        return this.#s;
    }
    set shareFiles(t) {
        Array.isArray(t) && t.length > 0 && (this.#s = t);
    }
    async share() {
        if (!this.disabled) try {
            let t = {};
            this.shareUrl && (t.url = this.shareUrl), this.shareTitle && (t.title = this.shareTitle), this.shareText && (t.text = this.shareText), Array.isArray(this.shareFiles) && this.shareFiles.length > 0 && navigator.canShare && navigator.canShare({
                files: this.shareFiles
            }) && (t.files = this.shareFiles), await navigator.share(t), this.dispatchEvent(new CustomEvent("web-share:success", {
                bubbles: !0,
                composed: !0,
                detail: {
                    shareData: t
                }
            }));
        } catch (t) {
            if (t instanceof Error && "AbortError" === t.name) {
                this.dispatchEvent(new CustomEvent("web-share:abort", {
                    bubbles: !0,
                    composed: !0,
                    detail: {
                        error: t
                    }
                }));
                return;
            }
            this.dispatchEvent(new CustomEvent("web-share:error", {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: t
                }
            }));
        }
    }
    #n = (t)=>{
        t.preventDefault(), this.disabled || this.share();
    };
    #a = (t)=>{
        t.target && "button" === t.target.name && (this.#e?.removeEventListener("click", this.#n), this.#e = this.#i(), this.#e && (this.#e.addEventListener("click", this.#n), "BUTTON" === this.#e.nodeName || this.#e.hasAttribute("role") || this.#e.setAttribute("role", "button")));
    };
    #i() {
        return this.#t && this.#t.assignedElements({
            flatten: !0
        }).find((t)=>"BUTTON" === t.nodeName || "button" === t.getAttribute("slot")) || null;
    }
    #r(t) {
        if (Object.prototype.hasOwnProperty.call(this, t)) {
            let e = this[t];
            delete this[t], this[t] = e;
        }
    }
    static defineCustomElement(t = "web-share") {
        "undefined" == typeof window || window.customElements.get(t) || window.customElements.define(t, $4f74a8126e204146$export$30b344bef3e55b67);
    }
}
$4f74a8126e204146$export$30b344bef3e55b67.defineCustomElement();


Object.defineProperty({}, "FilesDropzone", {
    get: function() {
        return $7aad62ebc3d6fae8$export$6ccd1735166caad9;
    },
    set: void 0,
    enumerable: !0,
    configurable: !0
});
let $7aad62ebc3d6fae8$var$e = new Map([
    [
        "aac",
        "audio/aac"
    ],
    [
        "abw",
        "application/x-abiword"
    ],
    [
        "arc",
        "application/x-freearc"
    ],
    [
        "avif",
        "image/avif"
    ],
    [
        "avi",
        "video/x-msvideo"
    ],
    [
        "azw",
        "application/vnd.amazon.ebook"
    ],
    [
        "bin",
        "application/octet-stream"
    ],
    [
        "bmp",
        "image/bmp"
    ],
    [
        "bz",
        "application/x-bzip"
    ],
    [
        "bz2",
        "application/x-bzip2"
    ],
    [
        "cda",
        "application/x-cdf"
    ],
    [
        "csh",
        "application/x-csh"
    ],
    [
        "css",
        "text/css"
    ],
    [
        "csv",
        "text/csv"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    [
        "eot",
        "application/vnd.ms-fontobject"
    ],
    [
        "epub",
        "application/epub+zip"
    ],
    [
        "gz",
        "application/gzip"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "heic",
        "image/heic"
    ],
    [
        "heif",
        "image/heif"
    ],
    [
        "htm",
        "text/html"
    ],
    [
        "html",
        "text/html"
    ],
    [
        "ico",
        "image/vnd.microsoft.icon"
    ],
    [
        "ics",
        "text/calendar"
    ],
    [
        "jar",
        "application/java-archive"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "jxl",
        "image/jxl"
    ],
    [
        "js",
        "text/javascript"
    ],
    [
        "json",
        "application/json"
    ],
    [
        "jsonld",
        "application/ld+json"
    ],
    [
        "markdown",
        "text/markdown"
    ],
    [
        "md",
        "text/markdown"
    ],
    [
        "mid",
        "audio/midi"
    ],
    [
        "midi",
        "audio/midi"
    ],
    [
        "mjs",
        "text/javascript"
    ],
    [
        "mp3",
        "audio/mpeg"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "mpeg",
        "video/mpeg"
    ],
    [
        "mpkg",
        "application/vnd.apple.installer+xml"
    ],
    [
        "odp",
        "application/vnd.oasis.opendocument.presentation"
    ],
    [
        "ods",
        "application/vnd.oasis.opendocument.spreadsheet"
    ],
    [
        "odt",
        "application/vnd.oasis.opendocument.text"
    ],
    [
        "oga",
        "audio/ogg"
    ],
    [
        "ogv",
        "video/ogg"
    ],
    [
        "ogx",
        "application/ogg"
    ],
    [
        "opus",
        "audio/opus"
    ],
    [
        "otf",
        "font/otf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "php",
        "application/x-httpd-php"
    ],
    [
        "ppt",
        "application/vnd.ms-powerpoint"
    ],
    [
        "pptx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    [
        "rar",
        "application/vnd.rar"
    ],
    [
        "rtf",
        "application/rtf"
    ],
    [
        "sh",
        "application/x-sh"
    ],
    [
        "svg",
        "image/svg+xml"
    ],
    [
        "swf",
        "application/x-shockwave-flash"
    ],
    [
        "tar",
        "application/x-tar"
    ],
    [
        "tif",
        "image/tiff"
    ],
    [
        "tiff",
        "image/tiff"
    ],
    [
        "ts",
        "video/mp2t"
    ],
    [
        "ttf",
        "font/ttf"
    ],
    [
        "txt",
        "text/plain"
    ],
    [
        "vsd",
        "application/vnd.visio"
    ],
    [
        "wav",
        "audio/wav"
    ],
    [
        "weba",
        "audio/webm"
    ],
    [
        "webm",
        "video/webm"
    ],
    [
        "webp",
        "image/webp"
    ],
    [
        "woff",
        "font/woff"
    ],
    [
        "woff2",
        "font/woff2"
    ],
    [
        "xhtml",
        "application/xhtml+xml"
    ],
    [
        "xls",
        "application/vnd.ms-excel"
    ],
    [
        "xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    [
        "xml",
        "application/xml"
    ],
    [
        "xul",
        "application/vnd.mozilla.xul+xml"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "7z",
        "application/x-7z-compressed"
    ],
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "msg",
        "application/vnd.ms-outlook"
    ]
]), $7aad62ebc3d6fae8$var$t = [
    ".DS_Store",
    "Thumbs.db"
], $7aad62ebc3d6fae8$var$o = (t)=>{
    let { name: o } = t;
    if (o && -1 !== o.lastIndexOf(".") && !t.type) {
        let i = (o.split(".").pop() || "").toLowerCase(), r = $7aad62ebc3d6fae8$var$e.get(i);
        r && Object.defineProperty(t, "type", {
            value: r,
            writable: !1,
            configurable: !1,
            enumerable: !0
        });
    }
    return t;
}, $7aad62ebc3d6fae8$var$i = (e, t)=>{
    let i = $7aad62ebc3d6fae8$var$o(e);
    if ("string" != typeof i.path) {
        let { webkitRelativePath: o } = e;
        Object.defineProperty(i, "path", {
            value: "string" == typeof t ? t : o || e.name,
            writable: !1,
            configurable: !1,
            enumerable: !0
        });
    }
    return i;
}, $7aad62ebc3d6fae8$var$r = async (e)=>await new Promise((t, o)=>{
        e.readEntries(t, o);
    }), $7aad62ebc3d6fae8$var$a = async (e)=>{
    let t = [], o = await $7aad62ebc3d6fae8$var$r(e);
    for(; o.length > 0;)t.push(...o), o = await $7aad62ebc3d6fae8$var$r(e);
    return t;
}, $7aad62ebc3d6fae8$var$n = (e)=>new Promise((t, o)=>{
        e.file((o)=>t($7aad62ebc3d6fae8$var$i(o, e.fullPath)), o);
    }), $7aad62ebc3d6fae8$var$s = async (e)=>{
    let o = [], i = [];
    for (let t of e){
        if ("file" !== t.kind) continue;
        let e = t.getAsEntry ? t.getAsEntry() : t.webkitGetAsEntry();
        i.push(e);
    }
    for(; i.length > 0;){
        let e = i.shift();
        if (e) {
            if (e.isFile) {
                let i = await $7aad62ebc3d6fae8$var$n(e);
                -1 === $7aad62ebc3d6fae8$var$t.indexOf(i.name) && o.push(i);
            } else e.isDirectory && i.push(...await $7aad62ebc3d6fae8$var$a(e.createReader()));
        }
    }
    return o;
}, $7aad62ebc3d6fae8$var$d = async (e)=>{
    let o = [];
    for (let r of e)-1 === $7aad62ebc3d6fae8$var$t.indexOf(r.name) && o.push($7aad62ebc3d6fae8$var$i(r));
    return o;
}, $7aad62ebc3d6fae8$var$l = async (e)=>e.dataTransfer ? e.dataTransfer.items ? await $7aad62ebc3d6fae8$var$s(e.dataTransfer.items) : await $7aad62ebc3d6fae8$var$d(e.dataTransfer.files) : await $7aad62ebc3d6fae8$var$d(e.target.files), $7aad62ebc3d6fae8$var$p = "files-dropzone", $7aad62ebc3d6fae8$var$c = "TOO_MANY_FILES", $7aad62ebc3d6fae8$var$h = document.createElement("template"), $7aad62ebc3d6fae8$var$u = `
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  :host {
    --dropzone-border-width: 2px;
    --dropzone-border-style: dashed;
    --dropzone-border-radius: 0.25rem;
    --dropzone-border-color: #6c757d;
    --dropzone-border-color-dragover: #0d6efd;
    --dropzone-border-color-hover: var(--dropzone-border-color-dragover);
    --dropzone-background-color: #ffffff;
    --dropzone-background-color-dragover: #f4f4f5;
    --dropzone-background-color-hover: var(--dropzone-background-color-dragover);
    --dropzone-body-color: #3f3f46;
    --dropzone-body-color-dragover: var(--dropzone-body-color);
    --dropzone-body-color-hover: var(--dropzone-body-color-dragover);
    --dropzone-focus-shadow-rgb: 49,132,253;
    --dropzone-focus-box-shadow: 0 0 0 0.25rem rgba(var(--dropzone-focus-shadow-rgb), 0.5);
    --transition-duration: 0.2s; /* for backwards compatibility */
    --dropzone-transition-duration: var(--transition-duration);

    display: block;
  }

  :host(:not([no-style])) .dropzone {
    border: var(--dropzone-border-width) var(--dropzone-border-style) var(--dropzone-border-color);
    border-radius: var(--dropzone-border-radius);
    padding: 3rem 1rem;
    overflow: hidden;
    background-color: var(--dropzone-background-color);
    color: var(--dropzone-body-color);
    text-align: center;
    cursor: pointer;
    transition: border var(--dropzone-transition-duration) ease-in-out, background-color var(--dropzone-transition-duration) ease-in-out, color var(--dropzone-transition-duration) ease-in-out, box-shadow var(--dropzone-transition-duration) ease-in-out;
  }

  :host(:not([no-style])[disabled]) .dropzone {
    opacity: 0.8;
    cursor: not-allowed;
    user-select: none;
  }

  :host(:not([no-style]):not([disabled])) .dropzone--dragover {
    border-color: var(--dropzone-border-color-dragover);
    background-color: var(--dropzone-background-color-dragover);
    color: var(--dropzone-body-color-dragover);
  }

  :host(:not([no-style]):not([disabled])) .dropzone:focus-visible {
    outline: none;
    box-shadow: var(--dropzone-focus-box-shadow);
  }

  @media (hover: hover) {
    :host(:not([no-style]):not([disabled])) .dropzone:not(.dropzone--dragover):hover {
      border-color: var(--dropzone-border-color-hover);
      background-color: var(--dropzone-background-color-hover);
      color: var(--dropzone-body-color-hover);
    }
  }
`;
$7aad62ebc3d6fae8$var$h.innerHTML = `
  <style>
    ${$7aad62ebc3d6fae8$var$u}
  </style>

  <input type="file" id="file-input" hidden>

  <div part="dropzone" class="dropzone" id="dropzone" tabindex="0" role="button" aria-disabled="false">
    <slot>Drag 'n' drop files here, or click to select files</slot>
  </div>
`;
class $7aad62ebc3d6fae8$export$6ccd1735166caad9 extends HTMLElement {
    #e = null;
    #t = null;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open",
            delegatesFocus: !0
        }).appendChild($7aad62ebc3d6fae8$var$h.content.cloneNode(!0)), this.shadowRoot && (this.#e = this.shadowRoot.getElementById("file-input"), this.#t = this.shadowRoot.getElementById("dropzone"));
    }
    static get observedAttributes() {
        return [
            "accept",
            "disabled",
            "multiple"
        ];
    }
    attributeChangedCallback(e, t, o) {
        "accept" === e && t !== o && this.#e && (this.#e.accept = this.accept), "disabled" === e && t !== o && this.#e && (this.#e.disabled = this.disabled, this.disabled ? (this.#t?.removeAttribute("tabindex"), this.#t?.setAttribute("aria-disabled", "true")) : (this.#t?.setAttribute("tabindex", "0"), this.#t?.setAttribute("aria-disabled", "false"))), "multiple" === e && t !== o && this.#e && (this.#e.multiple = this.multiple);
    }
    connectedCallback() {
        this.#o("accept"), this.#o("disabled"), this.#o("maxFiles"), this.#o("maxSize"), this.#o("minSize"), this.#o("multiple"), this.#o("autoFocus"), this.#o("noStyle"), this.#e?.addEventListener("change", this.#i), this.#t?.addEventListener("dragenter", this.#r), this.#t?.addEventListener("dragover", this.#a), this.#t?.addEventListener("dragleave", this.#n), this.#t?.addEventListener("drop", this.#s), this.#t?.addEventListener("click", this.#d), this.#t?.addEventListener("keyup", this.#l), this.autoFocus && this.#t?.focus();
    }
    disconnectedCallback() {
        this.#e?.removeEventListener("change", this.#i), this.#t?.removeEventListener("dragenter", this.#r), this.#t?.removeEventListener("dragover", this.#a), this.#t?.removeEventListener("dragleave", this.#n), this.#t?.removeEventListener("drop", this.#s), this.#t?.removeEventListener("click", this.#d), this.#t?.removeEventListener("keyup", this.#l);
    }
    get accept() {
        return this.getAttribute("accept") || "";
    }
    set accept(e) {
        this.setAttribute("accept", null != e ? e.toString() : e);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(e) {
        this.toggleAttribute("disabled", !!e);
    }
    get maxFiles() {
        let e = Number(this.getAttribute("max-files")) || 0;
        return e <= 0 ? 1 / 0 : Math.floor(Math.abs(e));
    }
    set maxFiles(e) {
        this.setAttribute("max-files", null != e ? e.toString() : e);
    }
    get maxSize() {
        let e = this.getAttribute("max-size");
        if (null === e) return 1 / 0;
        let t = Number(e);
        return Number.isNaN(t) ? 1 / 0 : t;
    }
    set maxSize(e) {
        this.setAttribute("max-size", null != e ? e.toString() : e);
    }
    get minSize() {
        let e = this.getAttribute("min-size");
        if (null === e) return 0;
        let t = Number(e);
        return Number.isNaN(t) ? 0 : t;
    }
    set minSize(e) {
        this.setAttribute("min-size", null != e ? e.toString() : e);
    }
    get multiple() {
        return this.hasAttribute("multiple");
    }
    set multiple(e) {
        this.toggleAttribute("multiple", !!e);
    }
    get autoFocus() {
        return this.hasAttribute("auto-focus");
    }
    set autoFocus(e) {
        this.toggleAttribute("auto-focus", !!e);
    }
    get noStyle() {
        return this.hasAttribute("no-style");
    }
    set noStyle(e) {
        this.toggleAttribute("no-style", !!e);
    }
    #i = async (e)=>{
        try {
            this.#p(await $7aad62ebc3d6fae8$var$l(e));
        } catch (e) {
            this.dispatchEvent(new CustomEvent(`${$7aad62ebc3d6fae8$var$p}-error`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: e
                }
            }));
        }
    };
    #r = ()=>{
        this.disabled || this.dispatchEvent(new Event(`${$7aad62ebc3d6fae8$var$p}-dragenter`, {
            bubbles: !0,
            composed: !0
        }));
    };
    #a = (e)=>{
        if (e.preventDefault(), this.disabled) {
            e.dataTransfer.dropEffect = "none";
            return;
        }
        e.dataTransfer.dropEffect = "copy", this.#t && (this.#t.classList.add("dropzone--dragover"), this.#t.part.add("dropzone--dragover")), this.dispatchEvent(new Event(`${$7aad62ebc3d6fae8$var$p}-dragover`, {
            bubbles: !0,
            composed: !0
        }));
    };
    #n = ()=>{
        this.disabled || (this.#t && (this.#t.classList.remove("dropzone--dragover"), this.#t.part.remove("dropzone--dragover")), this.dispatchEvent(new Event(`${$7aad62ebc3d6fae8$var$p}-dragleave`, {
            bubbles: !0,
            composed: !0
        })));
    };
    #s = async (e)=>{
        if (!this.disabled) {
            e.preventDefault(), this.#t && (this.#t.classList.remove("dropzone--dragover"), this.#t.part.remove("dropzone--dragover"));
            try {
                this.#p(await $7aad62ebc3d6fae8$var$l(e));
            } catch (e) {
                this.dispatchEvent(new CustomEvent(`${$7aad62ebc3d6fae8$var$p}-error`, {
                    bubbles: !0,
                    composed: !0,
                    detail: {
                        error: e
                    }
                }));
            }
        }
    };
    #d = ()=>{
        this.disabled || this.#e?.click();
    };
    #l = (e)=>{
        this.disabled || " " !== e.key && "Enter" !== e.key || this.#e?.click();
    };
    #p(e) {
        if (!Array.isArray(e) || !e.length) return;
        let t = [], o = [], i = e.length;
        if (!this.multiple && i > 1) for (let t of e)o.push({
            file: t,
            errors: [
                {
                    code: $7aad62ebc3d6fae8$var$c,
                    message: "Too many files selected. Only 1 file is allowed."
                }
            ]
        });
        else if (this.multiple && i > this.maxFiles) for (let t of e)o.push({
            file: t,
            errors: [
                {
                    code: $7aad62ebc3d6fae8$var$c,
                    message: `Too many files selected. Only ${this.maxFiles} ${this.maxFiles > 1 ? "files are" : "file is"} allowed.`
                }
            ]
        });
        else for (let i of e){
            let e = function(e, t = "") {
                if (!t) return !0;
                let o = [
                    ...new Set(t.split(",").map((e)=>e.trim()).filter(Boolean))
                ], i = e.type, r = i.replace(/\/.*$/, "");
                for (let t of o)if ("." === t.charAt(0)) {
                    if (-1 !== e.name.toLowerCase().indexOf(t.toLowerCase(), e.name.length - t.length)) return !0;
                } else if (/\/\*$/.test(t)) {
                    if (r === t.replace(/\/.*$/, "")) return !0;
                } else if (i === t) return !0;
                return !1;
            }(i, this.accept), r = i.size > this.maxSize, a = i.size < this.minSize;
            if (!e || r || a) {
                let t = [];
                e || t.push({
                    code: "INVALID_MIME_TYPE",
                    message: `File type "${i.type}" is not accepted.`
                }), r && t.push({
                    code: "FILE_TOO_LARGE",
                    message: `File size ${i.size} exceeds the maximum size of ${this.maxSize}.`
                }), a && t.push({
                    code: "FILE_TOO_SMALL",
                    message: `File size ${i.size} is smaller than the minimum size of ${this.minSize}.`
                }), o.push({
                    file: i,
                    errors: t
                });
            } else t.push(i);
        }
        this.dispatchEvent(new CustomEvent(`${$7aad62ebc3d6fae8$var$p}-drop`, {
            bubbles: !0,
            composed: !0,
            detail: {
                acceptedFiles: t,
                rejectedFiles: o
            }
        })), t.length > 0 && this.dispatchEvent(new CustomEvent(`${$7aad62ebc3d6fae8$var$p}-drop-accepted`, {
            bubbles: !0,
            composed: !0,
            detail: {
                acceptedFiles: t
            }
        })), o.length > 0 && this.dispatchEvent(new CustomEvent(`${$7aad62ebc3d6fae8$var$p}-drop-rejected`, {
            bubbles: !0,
            composed: !0,
            detail: {
                rejectedFiles: o
            }
        })), this.#e && (this.#e.value = this.#e.defaultValue);
    }
    openFileDialog() {
        this.disabled || this.#e?.click();
    }
    #o(e) {
        if (Object.prototype.hasOwnProperty.call(this, e)) {
            let t = this[e];
            delete this[e], this[e] = t;
        }
    }
    static defineCustomElement(e = $7aad62ebc3d6fae8$var$p) {
        "undefined" == typeof window || window.customElements.get(e) || window.customElements.define(e, $7aad62ebc3d6fae8$export$6ccd1735166caad9);
    }
}
$7aad62ebc3d6fae8$export$6ccd1735166caad9.defineCustomElement();


let $c172d40c323f9126$var$t = (t = "", e = "")=>{
    let s = Math.random().toString(36).substring(2, 8);
    return `${"string" == typeof t && "" !== t ? t + "-" : ""}${s}${"string" == typeof e && "" !== e ? "-" + e : ""}`;
}, $c172d40c323f9126$var$e = (t, e)=>{
    if (Object.prototype.hasOwnProperty.call(e, t)) {
        let s = e[t];
        delete e[t], e[t] = s;
    }
}, $c172d40c323f9126$var$s = 0, $c172d40c323f9126$var$a = `
  :host {
    box-sizing: border-box;
    display: inline-block;
    contain: content;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  .tab {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.375rem 0.75rem;
    white-space: nowrap;
    cursor: pointer;
  }

  :host([disabled]) .tab {
    opacity: 0.7;
    cursor: not-allowed;
  }

  :host([selected]) .tab {
    color: var(--selected-tab-color);
    background-color: var(--selected-tab-bg-color);
  }

  .tab__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem;
    font-size: inherit;
    cursor: pointer;
  }
`, $c172d40c323f9126$var$o = document.createElement("template");
$c172d40c323f9126$var$o.innerHTML = `
  <style>
    ${$c172d40c323f9126$var$a}
  </style>

  <div part="base" class="tab">
    <slot></slot>
  </div>
`;
class $c172d40c323f9126$export$6824c350c20eab3a extends HTMLElement {
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($c172d40c323f9126$var$o.content.cloneNode(!0));
    }
    static get observedAttributes() {
        return [
            "selected",
            "disabled",
            "closable"
        ];
    }
    attributeChangedCallback(t, e, s) {
        if ("selected" === t && e !== s && this.setAttribute("aria-selected", this.selected.toString()), "disabled" === t && e !== s && (this.setAttribute("aria-disabled", this.disabled.toString()), this.setAttribute("tabindex", this.disabled ? "-1" : "0")), "closable" === t && e !== s) {
            if (this.closable) {
                let t = document.createElement("span");
                t.className = "tab__close", t.setAttribute("part", "close-tab"), t.innerHTML = '<svg part="close-tab-icon" xmlns="http://www.w3.org/2000/svg" width="0.875em" height="0.875em" fill="currentColor" viewBox="0 0 16 16"><path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/></svg>', this.shadowRoot?.querySelector(".tab")?.appendChild(t), t.addEventListener("click", this.#t);
            } else {
                let t = this.shadowRoot?.querySelector(".tab__close");
                t?.removeEventListener("click", this.#t), t?.remove();
            }
        }
    }
    connectedCallback() {
        this.#e("selected"), this.#e("disabled"), this.#e("closable"), this.id || (this.id = $c172d40c323f9126$var$t("tab", (++$c172d40c323f9126$var$s).toString())), this.setAttribute("slot", "tab"), this.setAttribute("role", "tab"), this.setAttribute("aria-selected", "false"), this.setAttribute("tabindex", this.disabled ? "-1" : "0");
    }
    disconnectedCallback() {
        let t = this.shadowRoot?.querySelector(".tab__close");
        t?.removeEventListener("click", this.#t);
    }
    get selected() {
        return this.hasAttribute("selected");
    }
    set selected(t) {
        this.toggleAttribute("selected", !!t);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(t) {
        this.toggleAttribute("disabled", !!t);
    }
    get closable() {
        return this.hasAttribute("closable");
    }
    set closable(t) {
        this.toggleAttribute("closable", !!t);
    }
    #t = (t)=>{
        t.stopPropagation(), this.dispatchEvent(new CustomEvent("a-tab-close", {
            bubbles: !0,
            composed: !0,
            detail: {
                tabId: this.id
            }
        }));
    };
    #e(t) {
        return $c172d40c323f9126$var$e(t, this);
    }
    static defineCustomElement(t = "a-tab") {
        "undefined" == typeof window || window.customElements.get(t) || window.customElements.define(t, $c172d40c323f9126$export$6824c350c20eab3a);
    }
}
$c172d40c323f9126$export$6824c350c20eab3a.defineCustomElement();
let $c172d40c323f9126$var$i = 0, $c172d40c323f9126$var$r = `
  :host {
    box-sizing: border-box;
    display: block;
    contain: content;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }
`, $c172d40c323f9126$var$n = document.createElement("template");
$c172d40c323f9126$var$n.innerHTML = `
  <style>
    ${$c172d40c323f9126$var$r}
  </style>

  <div part="base" class="tab-panel">
    <slot></slot>
  </div>
`;
class $c172d40c323f9126$export$185adf5fa2c760b1 extends HTMLElement {
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($c172d40c323f9126$var$n.content.cloneNode(!0));
    }
    connectedCallback() {
        this.setAttribute("slot", "panel"), this.setAttribute("role", "tabpanel"), this.setAttribute("hidden", ""), this.id || (this.id = $c172d40c323f9126$var$t("panel", (++$c172d40c323f9126$var$i).toString()));
    }
    static defineCustomElement(t = "a-tab-panel") {
        "undefined" == typeof window || window.customElements.get(t) || window.customElements.define(t, $c172d40c323f9126$export$185adf5fa2c760b1);
    }
}
$c172d40c323f9126$export$185adf5fa2c760b1.defineCustomElement();
let $c172d40c323f9126$var$d = {
    TOP: "top",
    BOTTOM: "bottom",
    START: "start",
    END: "end"
}, $c172d40c323f9126$var$h = Object.entries($c172d40c323f9126$var$d).map(([, t])=>t), $c172d40c323f9126$var$b = {
    AUTO: "auto",
    MANUAL: "manual"
}, $c172d40c323f9126$var$u = {
    DOWN: "ArrowDown",
    LEFT: "ArrowLeft",
    RIGHT: "ArrowRight",
    UP: "ArrowUp",
    HOME: "Home",
    END: "End",
    ENTER: "Enter",
    SPACE: " "
}, $c172d40c323f9126$var$p = `
  :host {
    --selected-tab-color: #005fcc;
    --selected-tab-bg-color: transparent;
    --tabs-scroll-behavior: smooth;
    --scroll-button-width: 2.125em;
    --scroll-button-height: 2.125em;
    --scroll-button-inline-offset: 0rem;

    box-sizing: border-box;
    display: block;
    contain: content;
  }

  @media (prefers-reduced-motion: reduce) {
    :host {
      --tabs-scroll-behavior: auto;
    }
  }

  :host([hidden]),
  [hidden],
  ::slotted([hidden]) {
    display: none !important;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  .tab-group {
    display: flex;
    width: 100%;
  }

  .tab-group__nav {
    position: relative;
  }

  .tab-group__nav--has-scroll-controls {
    padding: 0 calc(var(--scroll-button-width) + var(--scroll-button-inline-offset));
  }

  .tab-group__scroll-button {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: var(--scroll-button-width);
    height: var(--scroll-button-height);
    padding: 0; /* Required for iOS, otherwise the svg is not visible: https://stackoverflow.com/questions/66532071/flex-svg-behaving-strange-in-ios-safari-14-0-3 */
    border: 0;
    z-index: 1;
    background-color: transparent;
    font-size: inherit;
    cursor: pointer;
    color: currentColor;
  }

  .tab-group__scroll-button--start {
    left: var(--scroll-button-inline-offset);
  }

  .tab-group__scroll-button--end {
    right: var(--scroll-button-inline-offset);
  }

  .tab-group__tabs {
    display: flex;
    padding: 0.25rem;
    overflow-x: auto;
    scroll-behavior: var(--tabs-scroll-behavior);
    scrollbar-width: none;
  }

  .tab-group__tabs::-webkit-scrollbar {
    display: none;
  }

  .tab-group__panels {
    padding: 1rem 0;
  }

  /* placement="top" */
  .tab-group,
  :host([placement="${$c172d40c323f9126$var$d.TOP}"]) .tab-group {
    flex-direction: column;
  }

  /* placement="bottom" */
  :host([placement="${$c172d40c323f9126$var$d.BOTTOM}"]) .tab-group {
    flex-direction: column;
  }

  :host([placement="${$c172d40c323f9126$var$d.BOTTOM}"]) .tab-group__nav {
    order: 1;
  }

  /* placement="start" */
  :host([placement="${$c172d40c323f9126$var$d.START}"]) .tab-group {
    flex-direction: row;
  }

  :host([placement="${$c172d40c323f9126$var$d.START}"]) .tab-group__tabs {
    flex-direction: column;
    align-items: flex-start;
  }

  :host([placement="${$c172d40c323f9126$var$d.START}"]) .tab-group__panels {
    flex: 1;
    padding: 0 1rem;
  }

  /* placement="end" */
  :host([placement="${$c172d40c323f9126$var$d.END}"]) .tab-group {
    flex-direction: row;
  }

  :host([placement="${$c172d40c323f9126$var$d.END}"]) .tab-group__nav {
    order: 1;
  }

  :host([placement="${$c172d40c323f9126$var$d.END}"]) .tab-group__tabs {
    flex-direction: column;
    align-items: flex-start;
  }

  :host([placement="${$c172d40c323f9126$var$d.END}"]) .tab-group__panels {
    flex: 1;
    padding: 0 1rem;
  }
`, $c172d40c323f9126$var$g = document.createElement("template");
$c172d40c323f9126$var$g.innerHTML = `
  <style>
    ${$c172d40c323f9126$var$p}
  </style>

  <div part="base" class="tab-group">
    <div part="nav" class="tab-group__nav">
      <button type="button" part="scroll-button scroll-button--start" class="tab-group__scroll-button tab-group__scroll-button--start" aria-label="Scroll to start" tabindex="-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" part="scroll-button-icon">
          <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
        </svg>
      </button>

      <div part="tabs" class="tab-group__tabs" role="tablist" tabindex="-1">
        <slot name="tab"></slot>
      </div>

      <button type="button" part="scroll-button scroll-button--end" class="tab-group__scroll-button tab-group__scroll-button--end" aria-label="Scroll to end" tabindex="-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1em" fill="currentColor" viewBox="0 0 16 16" part="scroll-button-icon">
          <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
        </svg>
      </button>
    </div>

    <div part="panels" class="tab-group__panels">
      <slot name="panel"></slot>
    </div>
  </div>
`;
class $c172d40c323f9126$export$4ac05a649254e913 extends HTMLElement {
    #s = null;
    #a = null;
    #o = !1;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($c172d40c323f9126$var$g.content.cloneNode(!0));
    }
    static get observedAttributes() {
        return [
            "placement",
            "no-scroll-controls"
        ];
    }
    attributeChangedCallback(t, e, s) {
        "placement" === t && e !== s && this.#l(), "no-scroll-controls" === t && e !== s && this.#l();
    }
    get placement() {
        return this.getAttribute("placement") || $c172d40c323f9126$var$d.TOP;
    }
    set placement(t) {
        null != t && this.setAttribute("placement", t);
    }
    get noScrollControls() {
        return this.hasAttribute("no-scroll-controls");
    }
    set noScrollControls(t) {
        this.toggleAttribute("no-scroll-controls", !!t);
    }
    get scrollDistance() {
        return Math.abs(Number(this.getAttribute("scroll-distance"))) || 200;
    }
    set scrollDistance(t) {
        this.setAttribute("scroll-distance", Math.abs(t).toString() || "200");
    }
    get activation() {
        return this.getAttribute("activation") || $c172d40c323f9126$var$b.AUTO;
    }
    set activation(t) {
        this.setAttribute("activation", t || $c172d40c323f9126$var$b.AUTO);
    }
    get noTabCycling() {
        return this.hasAttribute("no-tab-cycling");
    }
    set noTabCycling(t) {
        this.toggleAttribute("no-tab-cycling", !!t);
    }
    connectedCallback() {
        this.#e("placement"), this.#e("noScrollControls"), this.#e("scrollDistance"), this.#e("activation"), this.#e("noTabCycling");
        let t = this.shadowRoot?.querySelector("slot[name=tab]"), e = this.shadowRoot?.querySelector("slot[name=panel]"), s = this.shadowRoot?.querySelector(".tab-group__tabs"), a = this.shadowRoot?.querySelector(".tab-group__nav"), o = Array.from(this.shadowRoot?.querySelectorAll(".tab-group__scroll-button") || []);
        t?.addEventListener("slotchange", this.#i), e?.addEventListener("slotchange", this.#i), s?.addEventListener("click", this.#r), s?.addEventListener("keydown", this.#n), o.forEach((t)=>t.addEventListener("click", this.#c)), this.addEventListener("a-tab-close", this.#d), "ResizeObserver" in window && (this.#s = new ResizeObserver((t)=>{
            this.#a = window.requestAnimationFrame(()=>{
                let e = t?.[0], s = e?.target, l = s?.scrollWidth > s?.clientWidth;
                o.forEach((t)=>t.toggleAttribute("hidden", !l)), a?.part.toggle("nav--has-scroll-controls", l), a?.classList.toggle("tab-group__nav--has-scroll-controls", l);
            });
        })), this.#h(), this.#l();
    }
    disconnectedCallback() {
        let t = this.shadowRoot?.querySelector("slot[name=tab]"), e = this.shadowRoot?.querySelector("slot[name=panel]"), s = this.shadowRoot?.querySelector(".tab-group__tabs"), a = Array.from(this.shadowRoot?.querySelectorAll(".tab-group__scroll-button") || []);
        t?.removeEventListener("slotchange", this.#i), e?.removeEventListener("slotchange", this.#i), s?.removeEventListener("click", this.#r), s?.removeEventListener("keydown", this.#n), a.forEach((t)=>t.removeEventListener("click", this.#c)), this.removeEventListener("a-tab-close", this.#d), this.#b();
    }
    #u() {
        if (!this.#s) return;
        let t = this.shadowRoot?.querySelector(".tab-group__tabs");
        t && (this.#s.unobserve(t), this.#s.observe(t));
    }
    #b() {
        this.#s && (this.#s.disconnect(), null !== this.#a && (window.cancelAnimationFrame(this.#a), this.#a = null));
    }
    #p() {
        return getComputedStyle(this).direction || "ltr";
    }
    #h() {
        this.hidden = 0 === this.#g().length;
    }
    #m() {
        let t = this.#g();
        this.#h(), t.forEach((t)=>{
            let e = t.nextElementSibling;
            if (!e || "a-tab-panel" !== e.tagName.toLowerCase()) return console.error(`Tab #${t.id} is not a sibling of a <a-tab-panel>`);
            t.setAttribute("aria-controls", e.id), e.setAttribute("aria-labelledby", t.id);
        });
    }
    #v() {
        return Array.from(this.querySelectorAll("a-tab-panel"));
    }
    #g() {
        return Array.from(this.querySelectorAll("a-tab"));
    }
    #f(t) {
        let e = t.getAttribute("aria-controls");
        return this.querySelector(`#${e}`);
    }
    #w() {
        return this.#g().find((t)=>!t.disabled) || null;
    }
    #T() {
        let t = this.#g();
        for(let e = t.length - 1; e >= 0; e--)if (!t[e].disabled) return t[e];
        return null;
    }
    #y() {
        let t = this.#g(), e = this.activation === $c172d40c323f9126$var$b.MANUAL ? t.findIndex((t)=>t.matches(":focus")) - 1 : t.findIndex((t)=>t.selected) - 1;
        for(; t[(e + t.length) % t.length].disabled;)e--;
        return this.noTabCycling && e < 0 ? null : t[(e + t.length) % t.length];
    }
    #A() {
        let t = this.#g(), e = this.activation === $c172d40c323f9126$var$b.MANUAL ? t.findIndex((t)=>t.matches(":focus")) + 1 : t.findIndex((t)=>t.selected) + 1;
        for(; t[e % t.length].disabled;)e++;
        return this.noTabCycling && e >= t.length ? null : t[e % t.length];
    }
    #_() {
        let t = this.#g(), e = this.#v();
        t.forEach((t)=>t.selected = !1), e.forEach((t)=>t.hidden = !0);
    }
    #l() {
        let t = this.shadowRoot?.querySelector(".tab-group__nav"), e = Array.from(this.shadowRoot?.querySelectorAll(".tab-group__scroll-button") || []);
        this.noScrollControls || this.placement === $c172d40c323f9126$var$d.START || this.placement === $c172d40c323f9126$var$d.END ? (this.#b(), e.forEach((t)=>t.hidden = !0), t?.part.remove("nav--has-scroll-controls"), t?.classList.remove("tab-group__nav--has-scroll-controls")) : (this.#u(), e.forEach((t)=>t.hidden = !1));
    }
    #E() {
        let t = this.#g(), e = t.find((t)=>t.selected && !t.disabled) || t.find((t)=>!t.disabled);
        e && (this.#o && !e.selected && this.dispatchEvent(new CustomEvent("a-tab-show", {
            bubbles: !0,
            composed: !0,
            detail: {
                tabId: e.id
            }
        })), this.#C(e));
    }
    #C(t) {
        this.#_(), t && (t.selected = !0);
        let e = this.#f(t);
        e && (e.hidden = !1);
    }
    #i = (t)=>{
        this.#m(), this.#l(), this.#E(), "tab" === t.target.name && (this.#o = !0);
    };
    #n = (t)=>{
        if ("a-tab" !== t.target.tagName.toLowerCase() || t.altKey) return;
        let e = $c172d40c323f9126$var$h.includes(this.placement || "") ? this.placement : $c172d40c323f9126$var$d.TOP, s = [
            $c172d40c323f9126$var$d.TOP,
            $c172d40c323f9126$var$d.BOTTOM
        ].includes(e || "") ? "horizontal" : "vertical", a = this.#p(), o = null;
        switch(t.key){
            case $c172d40c323f9126$var$u.LEFT:
                "horizontal" === s && (o = "ltr" === a ? this.#y() : this.#A()) && (this.activation === $c172d40c323f9126$var$b.MANUAL ? o.focus() : this.selectTab(o));
                break;
            case $c172d40c323f9126$var$u.RIGHT:
                "horizontal" === s && (o = "ltr" === a ? this.#A() : this.#y()) && (this.activation === $c172d40c323f9126$var$b.MANUAL ? o.focus() : this.selectTab(o));
                break;
            case $c172d40c323f9126$var$u.UP:
                "vertical" === s && (o = this.#y()) && (this.activation === $c172d40c323f9126$var$b.MANUAL ? o.focus() : this.selectTab(o));
                break;
            case $c172d40c323f9126$var$u.DOWN:
                "vertical" === s && (o = this.#A()) && (this.activation === $c172d40c323f9126$var$b.MANUAL ? o.focus() : this.selectTab(o));
                break;
            case $c172d40c323f9126$var$u.HOME:
                (o = this.#w()) && (this.activation === $c172d40c323f9126$var$b.MANUAL ? o.focus() : this.selectTab(o));
                break;
            case $c172d40c323f9126$var$u.END:
                (o = this.#T()) && (this.activation === $c172d40c323f9126$var$b.MANUAL ? o.focus() : this.selectTab(o));
                break;
            case $c172d40c323f9126$var$u.ENTER:
            case $c172d40c323f9126$var$u.SPACE:
                (o = t.target) && this.selectTab(o);
                break;
            default:
                return;
        }
        t.preventDefault();
    };
    #r = (t)=>{
        let e = t.target.closest("a-tab");
        e && this.selectTab(e);
    };
    #c = (t)=>{
        let e = t.target.closest(".tab-group__scroll-button"), s = this.shadowRoot?.querySelector(".tab-group__tabs");
        if (!e || !s) return;
        let a = e.classList.contains("tab-group__scroll-button--start") ? -1 : 1, o = s.scrollLeft;
        s.scrollTo({
            left: o + a * this.scrollDistance
        });
    };
    #d = (t)=>{
        let e = t.target, s = this.#f(e);
        e && (e.remove(), e.selected && this.dispatchEvent(new CustomEvent("a-tab-hide", {
            bubbles: !0,
            composed: !0,
            detail: {
                tabId: e.id
            }
        }))), s && "a-tab-panel" === s.tagName.toLowerCase() && s.remove();
    };
    #e(t) {
        return $c172d40c323f9126$var$e(t, this);
    }
    selectTabByIndex(t) {
        let e = this.#g()[t];
        e && this.selectTab(e);
    }
    selectTabById(t) {
        let e = this.#g().find((e)=>e.id === t);
        e && this.selectTab(e);
    }
    selectTab(t) {
        let e = this.#g().find((t)=>t.selected);
        !t || t.disabled || t.selected || "a-tab" !== t.tagName.toLowerCase() || (this.#C(t), window.requestAnimationFrame(()=>{
            t.scrollIntoView({
                inline: "nearest",
                block: "nearest"
            }), t.focus();
        }), e && this.dispatchEvent(new CustomEvent("a-tab-hide", {
            bubbles: !0,
            composed: !0,
            detail: {
                tabId: e.id
            }
        })), this.dispatchEvent(new CustomEvent("a-tab-show", {
            bubbles: !0,
            composed: !0,
            detail: {
                tabId: t.id
            }
        })));
    }
    static defineCustomElement(t = "a-tab-group") {
        "undefined" == typeof window || window.customElements.get(t) || window.customElements.define(t, $c172d40c323f9126$export$4ac05a649254e913);
    }
}
$c172d40c323f9126$export$4ac05a649254e913.defineCustomElement();


Object.defineProperty({}, "ModalElement", {
    get: function() {
        return $4da30046ce6d9325$export$32589115725b904b;
    },
    set: void 0,
    enumerable: !0,
    configurable: !0
});
let $4da30046ce6d9325$var$e = document.createElement("template"), $4da30046ce6d9325$var$t = /* css */ `
  :host {
    --me-width: 32rem;
    --me-height: fit-content;
    --me-border-color: initial;
    --me-border-style: solid;
    --me-border-width: initial;
    --me-border-radius: 0;
    --me-box-shadow: none;
    --me-background-color: canvas;
    --me-header-spacing: 1rem;
    --me-body-spacing: 1rem;
    --me-footer-spacing: 1rem;
    --me-header-background-color: transparent;
    --me-body-background-color: transparent;
    --me-footer-background-color: transparent;
    --me-close-border-radius: 0;
    --me-close-background-color: transparent;
    --me-backdrop-background: rgba(0, 0, 0, 0.5);
    --me-backdrop-filter: none;

    display: contents;
    box-sizing: border-box;
  }

  :host *,
  :host *:after,
  :host *:before {
    box-sizing: inherit;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  /* Dialog */
  .dialog {
    --dialog-placement-margin: calc((2em + 6px) / 2);

    width: var(--me-width);
    height: var(--me-height);
    padding: 0;
    border-color: var(--me-border-color);
    border-style: var(--me-border-style);
    border-width: var(--me-border-width);
    border-radius: var(--me-border-radius);
    box-shadow: var(--me-box-shadow);
    background-color: var(--me-background-color);
  }

  .dialog[open] {
    display: flex;
  }

  :host([fullscreen]) .dialog {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
  }

  .dialog::backdrop {
    background: var(--me-backdrop-background, rgba(0, 0, 0, 0.5));
    backdrop-filter: var(--me-backdrop-filter, none);
    opacity: 0;
  }

  .dialog[open]::backdrop {
    opacity: 1;
  }

  /* Dialog placement */
  :host(:not([fullscreen])[placement="top-start"]) .dialog {
    margin-block-start: var(--dialog-placement-margin);
    margin-inline-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="top-center"]) .dialog {
    margin-block-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="top-end"]) .dialog {
    margin-block-start: var(--dialog-placement-margin);
    margin-inline-end: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="center-start"]) .dialog {
    margin-inline-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="center"]) .dialog {
    margin: auto;
  }

  :host(:not([fullscreen])[placement="center-end"]) .dialog {
    margin-inline-end: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="bottom-start"]) .dialog {
    margin-block-end: var(--dialog-placement-margin);
    margin-inline-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="bottom-center"]) .dialog {
    margin-block-end: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="bottom-end"]) .dialog {
    margin-block-end: var(--dialog-placement-margin);
    margin-inline-end: var(--dialog-placement-margin);
  }

  /* Dialog animations */
  @media (prefers-reduced-motion: no-preference) {
    .dialog:not(.dialog--no-animations),
    .dialog:not(.dialog--no-animations)::backdrop {
      transition: transform 0.3s, opacity 0.3s, display 0.3s allow-discrete, overlay 0.3s allow-discrete;
    }

    /* 1. IS-OPEN STATE */
    .dialog[open] {
      transform: scale(1);
      opacity: 1;
    }

    /* 2. EXIT STATE */
    .dialog {
      transform: scale(0.95);
      opacity: 0;
    }

    /* 0. BEFORE-OPEN STATE */
    @starting-style {
      .dialog[open] {
        transform: scale(0.95);
        opacity: 0;
      }

      .dialog[open]::backdrop {
        opacity: 0;
      }
    }

    .dialog--pulse:not(.dialog--no-animations) {
      animation-name: pulse;
      animation-duration: 300ms;
      animation-timing-function: cubic-bezier(0.2, 0, 0.38, 0.9);
    }

    @keyframes pulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.02); }
      100% { transform: scale(1); }
    }
  }

  /* Dialog panel, header, body, footer */
  .dialog__panel {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    width: 100%;
  }

  .dialog__header {
    display: flex;
    align-items: center;
    padding: var(--me-header-spacing);
    column-gap: 0.5rem;
    background-color: var(--me-header-background-color);
  }

  :host([no-close-button]) .dialog__header {
    column-gap: 0;
  }

  .dialog__title {
    display: block;
    flex: 1 1 auto;
    padding: 0;
    margin: 0;
  }

  .dialog__body {
    display: block;
    flex: 1 1 auto;
    padding: var(--me-body-spacing);
    overflow: auto;
    background-color: var(--me-body-background-color);
    overscroll-behavior: contain;
  }

  .dialog__footer {
    flex: 0 0 auto;
    text-align: end;

    padding: var(--me-footer-spacing);
    background-color: var(--me-footer-background-color);
  }

  .dialog__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.4375rem;
    border: none;
    background-color: transparent;
  }

  .dialog__close:not(:disabled) {
    cursor: pointer;
  }

  .dialog__close:disabled {
    cursor: not-allowed;
  }
`;
$4da30046ce6d9325$var$e.innerHTML = /* html */ `
  <style>${$4da30046ce6d9325$var$t}</style>

  <dialog part="base" class="dialog">
    <div part="panel" class="dialog__panel" aria-labelledby="title">
      <header part="header" class="dialog__header">
        <slot name="header" part="title" class="dialog__title" id="title"></slot>

        <form method="dialog">
          <button type="submit" part="close" class="dialog__close" aria-label="Close">
            <slot name="close">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </slot>
          </button>
        </form>
      </header>

      <slot part="body" class="dialog__body"></slot>

      <footer part="footer" class="dialog__footer" hidden>
        <slot name="footer"></slot>
      </footer>
    </div>
  </dialog>
`; /**
 * @summary A custom element that renders a modal dialog.
 * @documentation https://github.com/georapbox/modal-element
 *
 * @tagname modal-element - This is the default tag name, unless overridden by the `defineCustomElement` method.
 * @extends HTMLElement
 *
 * @property {boolean} open - Determines whether the modal is open or not.
 * @property {boolean} staticBackdrop - Determines whether the modal should close when the backdrop is clicked.
 * @property {boolean} noHeader - Determines whether the modal should have a header or not.
 * @property {boolean} noAnimations - Determines whether the modal should have animations or not when opening and closing.
 * @property {boolean} noCloseButton - Determines whether the modal should have a default close button or not.
 * @property {boolean} fullscreen - Determines whether the modal should be fullscreen or not.
 * @property {boolean} preserveOverflow - Determines whether the overflow of the body should be preserved when the modal is open.
 * @property {string} placement - Determines the placement of the modal.
 * @property {string} closeLabel - The label of the default close button, used as the aria-label attribute of the close button.
 *
 * @attribute {boolean} open - Reflects the open property.
 * @attribute {boolean} static-backdrop - Reflects the staticBackdrop property.
 * @attribute {boolean} no-header - Reflects the noHeader property.
 * @attribute {boolean} no-animations - Reflects the noAnimations property.
 * @attribute {boolean} no-close-button - Reflects the noCloseButton property.
 * @attribute {boolean} fullscreen - Reflects the fullscreen property.
 * @attribute {boolean} preserve-overflow - Reflects the preserveOverflow property.
 * @attribute {string} placement - Reflects the placement property.
 * @attribute {string} close-label - Reflects the closeLabel property.
 *
 * @slot - The modal's main content (default/unnamed slot).
 * @slot header - The modal's header content, usually a title.
 * @slot footer - The modals' footer content. Usually used for buttons or other actions.
 * @slot close - The content of the close button that appears in the modal's header.
 *
 * @cssproperty --me-width - The width of the modal. Default is 32rem.
 * @cssproperty --me-height - The height of the modal. Default is fit-content.
 * @cssproperty --me-border-color - The border color of the modal. Default is initial.
 * @cssproperty --me-border-style - The border style of the modal. Default is solid.
 * @cssproperty --me-border-width - The border width of the modal. Default is initial.
 * @cssproperty --me-border-radius - The border radius of the modal. Default is 0.
 * @cssproperty --me-box-shadow - The box shadow of the modal. Default is none.
 * @cssproperty --me-background-color - The background color of the modal. Default is canvas.
 * @cssproperty --me-header-spacing - The spacing of the header. Default is 1rem.
 * @cssproperty --me-body-spacing - The spacing of the body. Default is 1rem.
 * @cssproperty --me-footer-spacing - The spacing of the footer. Default is 1rem.
 * @cssproperty --me-header-background-color - The background color of the header. Default is transparent.
 * @cssproperty --me-body-background-color - The background color of the body. Default is transparent.
 * @cssproperty --me-footer-background-color - The background color of the footer. Default is transparent.
 * @cssproperty --me-close-border-radius - The border radius of the close button. Default is 0.
 * @cssproperty --me-close-background-color - The background color of the close button. Default is transparent.
 * @cssproperty --me-backdrop-background - The background shorthand property of the backdrop. Default is rgba(0, 0, 0, 0.5).
 * @cssproperty --me-backdrop-filter - The backdrop filter property of the backdrop. Default is none.
 *
 * @csspart base - The base wrapper of the modal.
 * @csspart panel - The panel wrapper of the modal.
 * @csspart header - The header wrapper of the modal.
 * @csspart title - The title wrapper of the modal.
 * @csspart body - The body wrapper of the modal.
 * @csspart footer - The footer wrapper of the modal.
 * @csspart close - The close button of the modal.
 *
 * @fires me-open - Dispatched when the modal is opened.
 * @fires me-close - Dispatched when the modal is closed.
 * @fires me-request-close - Dispatched when the modal is about to close.
 *
 * @method defineCustomElement - Static method. Defines a custom element with the given name.
 * @method show - Instance method. Opens the modal if it is closed, otherwise does nothing.
 * @method hide - Instance method. Closes the modal if it is open, otherwise does nothing.
 */ 
class $4da30046ce6d9325$export$32589115725b904b extends HTMLElement {
    #e = null;
    #t = null;
    #o = null;
    #l = void 0;
    constructor(){
        if (super(), !this.shadowRoot) {
            let t = this.attachShadow({
                mode: "open"
            });
            t.appendChild($4da30046ce6d9325$var$e.content.cloneNode(!0));
        }
        this.shadowRoot && (this.#e = this.shadowRoot.querySelector("dialog"), this.#t = this.shadowRoot.querySelector('slot[name="footer"]'), this.#o = this.shadowRoot.querySelector('slot[name="close"]'));
    }
    static get observedAttributes() {
        return [
            "open",
            "no-header",
            "no-animations",
            "no-close-button",
            "close-label"
        ];
    }
    attributeChangedCallback(e, t, o) {
        if (null !== this.#e) {
            if ("open" === e && t !== o && (this.open ? (this.#e.showModal(), this.dispatchEvent(new CustomEvent("me-open", {
                bubbles: !0,
                composed: !0,
                detail: {
                    element: this
                }
            })), document.body && !this.preserveOverflow && (document.body.style.overflow = "hidden")) : this.#e.close()), "no-header" === e && t !== o) {
                let e = this.#e.querySelector(".dialog__header");
                null !== e && (e.hidden = this.noHeader);
            }
            if ("no-animations" === e && t !== o && this.#e.classList.toggle("dialog--no-animations", this.noAnimations), "no-close-button" === e && t !== o) {
                let e = this.#e.querySelector(".dialog__close");
                null !== e && (e.hidden = this.noCloseButton);
            }
            "close-label" === e && t !== o && this.#a();
        }
    }
    connectedCallback() {
        this.#i("open"), this.#i("staticBackdrop"), this.#i("noHeader"), this.#i("noAnimations"), this.#i("noCloseButton"), this.#i("fullscreen"), this.#i("preserveOverflow"), this.#i("placement"), this.#i("closeLabel"), this.#e?.addEventListener("click", this.#n), this.#e?.addEventListener("close", this.#r), this.#e?.addEventListener("cancel", this.#s), this.#e?.querySelector('form[method="dialog"]')?.addEventListener("submit", this.#d), this.#t?.addEventListener("slotchange", this.#c), this.#o?.addEventListener("slotchange", this.#h);
    }
    disconnectedCallback() {
        this.#l && clearTimeout(this.#l), this.#e?.addEventListener("click", this.#n), this.#e?.removeEventListener("close", this.#r), this.#e?.removeEventListener("cancel", this.#s), this.#e?.querySelector('form[method="dialog"]')?.removeEventListener("submit", this.#d), this.#t?.removeEventListener("slotchange", this.#c), this.#o?.removeEventListener("slotchange", this.#h);
    }
    get open() {
        return this.hasAttribute("open");
    }
    set open(e) {
        this.toggleAttribute("open", !!e);
    }
    get staticBackdrop() {
        return this.hasAttribute("static-backdrop");
    }
    set staticBackdrop(e) {
        this.toggleAttribute("static-backdrop", !!e);
    }
    get noHeader() {
        return this.hasAttribute("no-header");
    }
    set noHeader(e) {
        this.toggleAttribute("no-header", !!e);
    }
    get noAnimations() {
        return this.hasAttribute("no-animations");
    }
    set noAnimations(e) {
        this.toggleAttribute("no-animations", !!e);
    }
    get noCloseButton() {
        return this.hasAttribute("no-close-button");
    }
    set noCloseButton(e) {
        this.toggleAttribute("no-close-button", !!e);
    }
    get fullscreen() {
        return this.hasAttribute("fullscreen");
    }
    set fullscreen(e) {
        this.toggleAttribute("fullscreen", !!e);
    }
    get preserveOverflow() {
        return this.hasAttribute("preserve-overflow");
    }
    set preserveOverflow(e) {
        this.toggleAttribute("preserve-overflow", !!e);
    }
    get placement() {
        return this.getAttribute("placement") || "center";
    }
    set placement(e) {
        this.setAttribute("placement", null != e ? e.toString() : e);
    }
    get closeLabel() {
        return this.getAttribute("close-label") || "Close";
    }
    set closeLabel(e) {
        this.setAttribute("close-label", null != e ? e.toString() : e);
    }
    #a() {
        if (null === this.#e) return;
        let e = this.#e.querySelector(".dialog__close");
        if (null === e) return;
        let t = this.#o?.assignedElements() || [], o = t?.some((e)=>e.textContent?.replace(/\s/g, "") !== "");
        o ? e.removeAttribute("aria-label") : e.setAttribute("aria-label", this.closeLabel);
    }
    #g() {
        this.#l || (this.#e?.classList.add("dialog--pulse"), this.#l = setTimeout(()=>{
            this.#e?.classList.remove("dialog--pulse"), clearTimeout(this.#l), this.#l = void 0;
        }, 300));
    }
    #r = ()=>{
        // the open property when the dialog is closed by the user.
        this.open = !1, this.dispatchEvent(new CustomEvent("me-close", {
            bubbles: !0,
            composed: !0,
            detail: {
                element: this
            }
        })), document.body && !this.preserveOverflow && (document.body.style.overflow = "");
    };
    #s = (e)=>{
        let t = this.#m("escape-key");
        this.dispatchEvent(t), t.defaultPrevented && (e.preventDefault(), this.noAnimations || this.#g());
    };
    #d = (e)=>{
        let t = this.#m("close-button");
        this.dispatchEvent(t), t.defaultPrevented && (e.preventDefault(), this.noAnimations || this.#g());
    };
    #n = (e)=>{
        let t = e.target, o = e.currentTarget; // Close the dialog when the backdrop is clicked.
        if (t === o) {
            let e = this.#m("backdrop-click");
            this.dispatchEvent(e), e.defaultPrevented || this.staticBackdrop ? this.noAnimations || this.#g() : this.hide();
        } // Close the dialog when external invoker is clicked.
        if (t instanceof HTMLElement && null !== t.closest("[data-me-close]")) {
            let e = this.#m("external-invoker");
            this.dispatchEvent(e), e.defaultPrevented ? this.noAnimations || this.#g() : this.hide();
        }
    };
    #c = ()=>{
        if (null === this.#e) return; /** @type {Nullable<HTMLElement>} */ 
        let e = this.#e.querySelector(".dialog__footer");
        if (null === e) return;
        let t = this.#t?.assignedNodes(), o = !!t && t.length > 0;
        e.hidden = !o;
    };
    #h = ()=>{
        this.#a();
    };
    #m(e) {
        return new CustomEvent("me-request-close", {
            bubbles: !0,
            composed: !0,
            cancelable: !0,
            detail: {
                reason: e,
                element: this
            }
        });
    }
    #i(e) {
        if (Object.prototype.hasOwnProperty.call(this, e)) {
            let t = this[e];
            delete this[e], this[e] = t;
        }
    }
    show() {
        this.open || (this.open = !0);
    }
    hide() {
        this.open && (this.open = !1);
    }
    static defineCustomElement(e = "modal-element") {
        "undefined" == typeof window || window.customElements.get(e) || window.customElements.define(e, $4da30046ce6d9325$export$32589115725b904b);
    }
}
$4da30046ce6d9325$export$32589115725b904b.defineCustomElement();
 //# sourceMappingURL=modal-element-defined.js.map


(function() {
    "use strict";
    if (typeof document === "undefined" || "adoptedStyleSheets" in document) return;
    var hasShadyCss = "ShadyCSS" in window && !ShadyCSS.nativeShadow;
    var bootstrapper = document.implementation.createHTMLDocument("");
    var closedShadowRootRegistry = new WeakMap();
    var _DOMException = typeof DOMException === "object" ? Error : DOMException;
    var defineProperty = Object.defineProperty;
    var forEach = Array.prototype.forEach;
    var importPattern = /@import.+?;?$/gm;
    function rejectImports(contents) {
        var _contents = contents.replace(importPattern, "");
        if (_contents !== contents) console.warn("@import rules are not allowed here. See https://github.com/WICG/construct-stylesheets/issues/119#issuecomment-588352418");
        return _contents.trim();
    }
    function isElementConnected(element) {
        return "isConnected" in element ? element.isConnected : document.contains(element);
    }
    function unique(arr) {
        return arr.filter(function(value, index) {
            return arr.indexOf(value) === index;
        });
    }
    function diff(arr1, arr2) {
        return arr1.filter(function(value) {
            return arr2.indexOf(value) === -1;
        });
    }
    function removeNode(node) {
        node.parentNode.removeChild(node);
    }
    function getShadowRoot(element) {
        return element.shadowRoot || closedShadowRootRegistry.get(element);
    }
    var cssStyleSheetMethods = [
        "addRule",
        "deleteRule",
        "insertRule",
        "removeRule"
    ];
    var NonConstructedStyleSheet = CSSStyleSheet;
    var nonConstructedProto = NonConstructedStyleSheet.prototype;
    nonConstructedProto.replace = function() {
        return Promise.reject(new _DOMException("Can't call replace on non-constructed CSSStyleSheets."));
    };
    nonConstructedProto.replaceSync = function() {
        throw new _DOMException("Failed to execute 'replaceSync' on 'CSSStyleSheet': Can't call replaceSync on non-constructed CSSStyleSheets.");
    };
    function isCSSStyleSheetInstance(instance) {
        return typeof instance === "object" ? proto$1.isPrototypeOf(instance) || nonConstructedProto.isPrototypeOf(instance) : false;
    }
    function isNonConstructedStyleSheetInstance(instance) {
        return typeof instance === "object" ? nonConstructedProto.isPrototypeOf(instance) : false;
    }
    var $basicStyleElement = new WeakMap();
    var $locations = new WeakMap();
    var $adoptersByLocation = new WeakMap();
    var $appliedMethods = new WeakMap();
    function addAdopterLocation(sheet, location) {
        var adopter = document.createElement("style");
        $adoptersByLocation.get(sheet).set(location, adopter);
        $locations.get(sheet).push(location);
        return adopter;
    }
    function getAdopterByLocation(sheet, location) {
        return $adoptersByLocation.get(sheet).get(location);
    }
    function removeAdopterLocation(sheet, location) {
        $adoptersByLocation.get(sheet).delete(location);
        $locations.set(sheet, $locations.get(sheet).filter(function(_location) {
            return _location !== location;
        }));
    }
    function restyleAdopter(sheet, adopter) {
        requestAnimationFrame(function() {
            adopter.textContent = $basicStyleElement.get(sheet).textContent;
            $appliedMethods.get(sheet).forEach(function(command) {
                return adopter.sheet[command.method].apply(adopter.sheet, command.args);
            });
        });
    }
    function checkInvocationCorrectness(self) {
        if (!$basicStyleElement.has(self)) throw new TypeError("Illegal invocation");
    }
    function ConstructedStyleSheet() {
        var self = this;
        var style = document.createElement("style");
        bootstrapper.body.appendChild(style);
        $basicStyleElement.set(self, style);
        $locations.set(self, []);
        $adoptersByLocation.set(self, new WeakMap());
        $appliedMethods.set(self, []);
    }
    var proto$1 = ConstructedStyleSheet.prototype;
    proto$1.replace = function replace(contents) {
        try {
            this.replaceSync(contents);
            return Promise.resolve(this);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    proto$1.replaceSync = function replaceSync(contents) {
        checkInvocationCorrectness(this);
        if (typeof contents === "string") {
            var self_1 = this;
            $basicStyleElement.get(self_1).textContent = rejectImports(contents);
            $appliedMethods.set(self_1, []);
            $locations.get(self_1).forEach(function(location) {
                if (location.isConnected()) restyleAdopter(self_1, getAdopterByLocation(self_1, location));
            });
        }
    };
    defineProperty(proto$1, "cssRules", {
        configurable: true,
        enumerable: true,
        get: function cssRules() {
            checkInvocationCorrectness(this);
            return $basicStyleElement.get(this).sheet.cssRules;
        }
    });
    defineProperty(proto$1, "media", {
        configurable: true,
        enumerable: true,
        get: function media() {
            checkInvocationCorrectness(this);
            return $basicStyleElement.get(this).sheet.media;
        }
    });
    cssStyleSheetMethods.forEach(function(method) {
        proto$1[method] = function() {
            var self = this;
            checkInvocationCorrectness(self);
            var args = arguments;
            $appliedMethods.get(self).push({
                method: method,
                args: args
            });
            $locations.get(self).forEach(function(location) {
                if (location.isConnected()) {
                    var sheet = getAdopterByLocation(self, location).sheet;
                    sheet[method].apply(sheet, args);
                }
            });
            var basicSheet = $basicStyleElement.get(self).sheet;
            return basicSheet[method].apply(basicSheet, args);
        };
    });
    defineProperty(ConstructedStyleSheet, Symbol.hasInstance, {
        configurable: true,
        value: isCSSStyleSheetInstance
    });
    var defaultObserverOptions = {
        childList: true,
        subtree: true
    };
    var locations = new WeakMap();
    function getAssociatedLocation(element) {
        var location = locations.get(element);
        if (!location) {
            location = new Location(element);
            locations.set(element, location);
        }
        return location;
    }
    function attachAdoptedStyleSheetProperty(constructor) {
        defineProperty(constructor.prototype, "adoptedStyleSheets", {
            configurable: true,
            enumerable: true,
            get: function() {
                return getAssociatedLocation(this).sheets;
            },
            set: function(sheets) {
                getAssociatedLocation(this).update(sheets);
            }
        });
    }
    function traverseWebComponents(node, callback) {
        var iter = document.createNodeIterator(node, NodeFilter.SHOW_ELEMENT, function(foundNode) {
            return getShadowRoot(foundNode) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }, null, false);
        for(var next = void 0; next = iter.nextNode();)callback(getShadowRoot(next));
    }
    var $element = new WeakMap();
    var $uniqueSheets = new WeakMap();
    var $observer = new WeakMap();
    function isExistingAdopter(self, element) {
        return element instanceof HTMLStyleElement && $uniqueSheets.get(self).some(function(sheet) {
            return getAdopterByLocation(sheet, self);
        });
    }
    function getAdopterContainer(self) {
        var element = $element.get(self);
        return element instanceof Document ? element.body : element;
    }
    function adopt(self) {
        var styleList = document.createDocumentFragment();
        var sheets = $uniqueSheets.get(self);
        var observer = $observer.get(self);
        var container = getAdopterContainer(self);
        observer.disconnect();
        sheets.forEach(function(sheet) {
            styleList.appendChild(getAdopterByLocation(sheet, self) || addAdopterLocation(sheet, self));
        });
        container.insertBefore(styleList, null);
        observer.observe(container, defaultObserverOptions);
        sheets.forEach(function(sheet) {
            restyleAdopter(sheet, getAdopterByLocation(sheet, self));
        });
    }
    function Location(element) {
        var self = this;
        self.sheets = [];
        $element.set(self, element);
        $uniqueSheets.set(self, []);
        $observer.set(self, new MutationObserver(function(mutations, observer) {
            if (!document) {
                observer.disconnect();
                return;
            }
            mutations.forEach(function(mutation) {
                if (!hasShadyCss) forEach.call(mutation.addedNodes, function(node) {
                    if (!(node instanceof Element)) return;
                    traverseWebComponents(node, function(root) {
                        getAssociatedLocation(root).connect();
                    });
                });
                forEach.call(mutation.removedNodes, function(node) {
                    if (!(node instanceof Element)) return;
                    if (isExistingAdopter(self, node)) adopt(self);
                    if (!hasShadyCss) traverseWebComponents(node, function(root) {
                        getAssociatedLocation(root).disconnect();
                    });
                });
            });
        }));
    }
    Location.prototype = {
        isConnected: function() {
            var element = $element.get(this);
            return element instanceof Document ? element.readyState !== "loading" : isElementConnected(element.host);
        },
        connect: function() {
            var container = getAdopterContainer(this);
            $observer.get(this).observe(container, defaultObserverOptions);
            if ($uniqueSheets.get(this).length > 0) adopt(this);
            traverseWebComponents(container, function(root) {
                getAssociatedLocation(root).connect();
            });
        },
        disconnect: function() {
            $observer.get(this).disconnect();
        },
        update: function(sheets) {
            var self = this;
            var locationType = $element.get(self) === document ? "Document" : "ShadowRoot";
            if (!Array.isArray(sheets)) throw new TypeError("Failed to set the 'adoptedStyleSheets' property on " + locationType + ": Iterator getter is not callable.");
            if (!sheets.every(isCSSStyleSheetInstance)) throw new TypeError("Failed to set the 'adoptedStyleSheets' property on " + locationType + ": Failed to convert value to 'CSSStyleSheet'");
            if (sheets.some(isNonConstructedStyleSheetInstance)) throw new TypeError("Failed to set the 'adoptedStyleSheets' property on " + locationType + ": Can't adopt non-constructed stylesheets");
            self.sheets = sheets;
            var oldUniqueSheets = $uniqueSheets.get(self);
            var uniqueSheets = unique(sheets);
            var removedSheets = diff(oldUniqueSheets, uniqueSheets);
            removedSheets.forEach(function(sheet) {
                removeNode(getAdopterByLocation(sheet, self));
                removeAdopterLocation(sheet, self);
            });
            $uniqueSheets.set(self, uniqueSheets);
            if (self.isConnected() && uniqueSheets.length > 0) adopt(self);
        }
    };
    window.CSSStyleSheet = ConstructedStyleSheet;
    attachAdoptedStyleSheetProperty(Document);
    if ("ShadowRoot" in window) {
        attachAdoptedStyleSheetProperty(ShadowRoot);
        var proto = Element.prototype;
        var attach_1 = proto.attachShadow;
        proto.attachShadow = function attachShadow(init) {
            var root = attach_1.call(this, init);
            if (init.mode === "closed") closedShadowRootRegistry.set(this, root);
            return root;
        };
    }
    var documentLocation = getAssociatedLocation(document);
    if (documentLocation.isConnected()) documentLocation.connect();
    else document.addEventListener("DOMContentLoaded", documentLocation.connect.bind(documentLocation));
})();


var $4bfdd2b5b37e20f8$exports = {};

$4bfdd2b5b37e20f8$exports = (parcelRequire("aNJCr")).getBundleURL("itQ15") + "bootstrap.d6688811.css";


var $79568454f9fde2bc$exports = {};

$79568454f9fde2bc$exports = (parcelRequire("aNJCr")).getBundleURL("itQ15") + "main.86f0dde0.css";


const $053c683f8862b85c$var$styleURLs = [
    $4bfdd2b5b37e20f8$exports,
    $79568454f9fde2bc$exports
];
const $053c683f8862b85c$export$4b9cd30c41328fdd = [];
for(let i = 0; i < $053c683f8862b85c$var$styleURLs.length; i += 1)$053c683f8862b85c$export$4b9cd30c41328fdd.push(new CSSStyleSheet());
(async function() {
    const styles = await Promise.all($053c683f8862b85c$var$styleURLs.map(async (styleURL)=>{
        const res = await fetch(styleURL);
        return res.text();
    }));
    for(let i = 0; i < styles.length; i += 1)await $053c683f8862b85c$export$4b9cd30c41328fdd[i].replace(styles[i]);
    document.body.style.visibility = "visible";
})();



function $e92a13782f6c06ba$var$_slicedToArray(arr, i) {
    return $e92a13782f6c06ba$var$_arrayWithHoles(arr) || $e92a13782f6c06ba$var$_iterableToArrayLimit(arr, i) || $e92a13782f6c06ba$var$_unsupportedIterableToArray(arr, i) || $e92a13782f6c06ba$var$_nonIterableRest();
}
function $e92a13782f6c06ba$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e92a13782f6c06ba$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e92a13782f6c06ba$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e92a13782f6c06ba$var$_arrayLikeToArray(o, minLen);
}
function $e92a13782f6c06ba$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e92a13782f6c06ba$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e92a13782f6c06ba$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e92a13782f6c06ba$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        }; // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $e92a13782f6c06ba$export$f51a9068ac82ea43(dbName, storeName) {
    var request = indexedDB.open(dbName);
    request.onupgradeneeded = function() {
        return request.result.createObjectStore(storeName);
    };
    var dbp = $e92a13782f6c06ba$export$b327150396135fe7(request);
    return function(txMode, callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $e92a13782f6c06ba$var$defaultGetStoreFunc;
function $e92a13782f6c06ba$var$defaultGetStore() {
    if (!$e92a13782f6c06ba$var$defaultGetStoreFunc) $e92a13782f6c06ba$var$defaultGetStoreFunc = $e92a13782f6c06ba$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $e92a13782f6c06ba$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return $e92a13782f6c06ba$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.put(value, key);
        return $e92a13782f6c06ba$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $e92a13782f6c06ba$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return Promise.all(keys.map(function(key) {
            return $e92a13782f6c06ba$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        return(// If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($e92a13782f6c06ba$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.delete(key);
        return $e92a13782f6c06ba$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $e92a13782f6c06ba$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.clear();
        return $e92a13782f6c06ba$export$b327150396135fe7(store.transaction);
    });
}
function $e92a13782f6c06ba$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $e92a13782f6c06ba$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $e92a13782f6c06ba$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $e92a13782f6c06ba$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $e92a13782f6c06ba$export$b327150396135fe7(store.getAll());
        var items = [];
        return $e92a13782f6c06ba$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e92a13782f6c06ba$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e92a13782f6c06ba$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $e92a13782f6c06ba$export$b327150396135fe7(store.getAllKeys()),
            $e92a13782f6c06ba$export$b327150396135fe7(store.getAll())
        ]).then(function(_ref) {
            var _ref2 = $e92a13782f6c06ba$var$_slicedToArray(_ref, 2), keys = _ref2[0], values = _ref2[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore("readonly", function(store) {
            return $e92a13782f6c06ba$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}


const $b36f6cb20f27a9a6$var$STORAGE_PREFIX = "rss-reader/";
const $b36f6cb20f27a9a6$var$STORAGE_FEEDS_KEY = $b36f6cb20f27a9a6$var$STORAGE_PREFIX + "feeds";
const $b36f6cb20f27a9a6$var$getItem = async (key)=>{
    try {
        return {
            value: await (0, $e92a13782f6c06ba$export$3988ae62b71be9a3)(key),
            error: void 0
        };
    } catch (error) {
        return {
            value: void 0,
            error: error
        };
    }
};
const $b36f6cb20f27a9a6$var$setItem = async (key, data)=>{
    try {
        await (0, $e92a13782f6c06ba$export$adaa4cf7ef1b65be)(key, data);
        return {
            error: void 0
        };
    } catch (error) {
        return {
            error: error
        };
    }
};
const $b36f6cb20f27a9a6$export$4890c08c4ffbd57b = async ()=>{
    return $b36f6cb20f27a9a6$var$getItem($b36f6cb20f27a9a6$var$STORAGE_FEEDS_KEY);
};
const $b36f6cb20f27a9a6$export$a8ce8a4ec117f05e = async (feeds, shouldDispatchEvent = true)=>{
    if (!Array.isArray(feeds)) return;
    const { error: error } = await $b36f6cb20f27a9a6$var$setItem($b36f6cb20f27a9a6$var$STORAGE_FEEDS_KEY, feeds);
    if (!error && shouldDispatchEvent) document.dispatchEvent(new CustomEvent("feeds-updated", {
        bubbles: true,
        detail: {
            action: "set",
            feeds: feeds
        }
    }));
    return {
        error: error
    };
};
const $b36f6cb20f27a9a6$export$4b77448646caf424 = async (feed, shouldDispatchEvent = true)=>{
    const { value: feeds = [] } = await $b36f6cb20f27a9a6$export$4890c08c4ffbd57b();
    const foundFeed = feeds.find((f)=>f.url === feed.url);
    let action = "";
    if (foundFeed) {
        foundFeed.url = feed.url;
        foundFeed.title = feed.title;
        action = "update";
    } else {
        feeds.push(feed);
        action = "create";
    }
    const { error: error } = await $b36f6cb20f27a9a6$var$setItem($b36f6cb20f27a9a6$var$STORAGE_FEEDS_KEY, feeds);
    if (!error && shouldDispatchEvent) document.dispatchEvent(new CustomEvent("feeds-updated", {
        bubbles: true,
        detail: {
            action: action,
            feed: feed
        }
    }));
    return {
        error: error
    };
};
const $b36f6cb20f27a9a6$export$4e54c6fd9fa8b09b = async (feedUrl, shouldDispatchEvent = true)=>{
    const { value: feeds = [] } = await $b36f6cb20f27a9a6$export$4890c08c4ffbd57b();
    const filteredFeeds = feeds.filter((f)=>f.url !== feedUrl);
    const { error: error } = await $b36f6cb20f27a9a6$var$setItem($b36f6cb20f27a9a6$var$STORAGE_FEEDS_KEY, filteredFeeds);
    if (!error && shouldDispatchEvent) {
        if (filteredFeeds.length === 0) await (0, $e92a13782f6c06ba$export$1d2f21e549771e67)($b36f6cb20f27a9a6$var$STORAGE_FEEDS_KEY);
        document.dispatchEvent(new CustomEvent("feeds-updated", {
            bubbles: true,
            detail: {
                action: "delete",
                feed: {
                    url: feedUrl
                }
            }
        }));
    }
    return {
        error: error
    };
};


/**
 * Checks if a URL can be parsed.
 *
 * @param {string} url The URL to be parsed.
 * @returns {boolean} True if the URL can be parsed, false otherwise.
 */ const $8ca5c59aef5015ba$export$981c5d1bd3894713 = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};


const $0c951fb6e39d40f6$var$styles = /* css */ `
  :host {
    --input-height: 42px;
    display: block;
  }
`;
const $0c951fb6e39d40f6$var$template = document.createElement("template");
$0c951fb6e39d40f6$var$template.innerHTML = /* html */ `
  <style>${$0c951fb6e39d40f6$var$styles}</style>

  <form name="addFeedForm" autocomplete="off" class="d-flex">
    <div class="form-group" style="flex: 1;">
      <label for="feedUrl" class="visually-hidden">Enter a feed URL in XML format</label>
      <input id="feedUrl" type="url" name="feed-url" class="form-control" style="height: var(--input-height);" placeholder="Enter a feed URL in XML format" autocapitalize="off" autocorrect="off" required>
    </div>
    <div class="ms-2">
      <input type="submit" value="Add feed" class="btn btn-primary" style="height: var(--input-height);">
    </div>
  </form>
`;
class $0c951fb6e39d40f6$var$AddFeed extends HTMLElement {
    #formEl = null;
    constructor(){
        super();
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: "open"
            });
            this.shadowRoot.appendChild($0c951fb6e39d40f6$var$template.content.cloneNode(true));
        }
        this.shadowRoot.adoptedStyleSheets = (0, $053c683f8862b85c$export$4b9cd30c41328fdd);
        this.#formEl = this.shadowRoot.querySelector('form[name="addFeedForm"]');
    }
    connectedCallback() {
        this.#formEl.addEventListener("submit", this.#handleFormSubmission);
    }
    disconnectedCallback() {
        this.#formEl.addEventListener("submit", this.#handleFormSubmission);
    }
    async #handleFormSubmission(evt) {
        evt.preventDefault();
        const input = evt.target["feed-url"];
        const url = input.value.trim();
        const { value: feeds = [] } = await (0, $b36f6cb20f27a9a6$export$4890c08c4ffbd57b)();
        const urlExists = Boolean(feeds.find((feed)=>feed.url === url));
        const isValidURL = (0, $8ca5c59aef5015ba$export$981c5d1bd3894713)(url);
        if (!urlExists && isValidURL) await (0, $b36f6cb20f27a9a6$export$4b77448646caf424)({
            url: url,
            title: "" // Title is not available at this point; it will be fetched later.
        });
        input.value = "";
    }
}
if (!window.customElements.get("add-feed")) window.customElements.define("add-feed", $0c951fb6e39d40f6$var$AddFeed);


/**!
 * Sortable 1.15.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $da1f6dc1cffd4cb1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $da1f6dc1cffd4cb1$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $da1f6dc1cffd4cb1$var$ownKeys(Object(source), true).forEach(function(key) {
            $da1f6dc1cffd4cb1$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $da1f6dc1cffd4cb1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $da1f6dc1cffd4cb1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $da1f6dc1cffd4cb1$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $da1f6dc1cffd4cb1$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $da1f6dc1cffd4cb1$var$_typeof(obj);
}
function $da1f6dc1cffd4cb1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $da1f6dc1cffd4cb1$var$_extends() {
    $da1f6dc1cffd4cb1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $da1f6dc1cffd4cb1$var$_extends.apply(this, arguments);
}
function $da1f6dc1cffd4cb1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $da1f6dc1cffd4cb1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $da1f6dc1cffd4cb1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $da1f6dc1cffd4cb1$var$_toConsumableArray(arr) {
    return $da1f6dc1cffd4cb1$var$_arrayWithoutHoles(arr) || $da1f6dc1cffd4cb1$var$_iterableToArray(arr) || $da1f6dc1cffd4cb1$var$_unsupportedIterableToArray(arr) || $da1f6dc1cffd4cb1$var$_nonIterableSpread();
}
function $da1f6dc1cffd4cb1$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $da1f6dc1cffd4cb1$var$_arrayLikeToArray(arr);
}
function $da1f6dc1cffd4cb1$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $da1f6dc1cffd4cb1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $da1f6dc1cffd4cb1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $da1f6dc1cffd4cb1$var$_arrayLikeToArray(o, minLen);
}
function $da1f6dc1cffd4cb1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $da1f6dc1cffd4cb1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $da1f6dc1cffd4cb1$var$version = "1.15.2";
function $da1f6dc1cffd4cb1$var$userAgent(pattern) {
    if (typeof window !== "undefined" && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $da1f6dc1cffd4cb1$var$IE11OrLess = $da1f6dc1cffd4cb1$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $da1f6dc1cffd4cb1$var$Edge = $da1f6dc1cffd4cb1$var$userAgent(/Edge/i);
var $da1f6dc1cffd4cb1$var$FireFox = $da1f6dc1cffd4cb1$var$userAgent(/firefox/i);
var $da1f6dc1cffd4cb1$var$Safari = $da1f6dc1cffd4cb1$var$userAgent(/safari/i) && !$da1f6dc1cffd4cb1$var$userAgent(/chrome/i) && !$da1f6dc1cffd4cb1$var$userAgent(/android/i);
var $da1f6dc1cffd4cb1$var$IOS = $da1f6dc1cffd4cb1$var$userAgent(/iP(ad|od|hone)/i);
var $da1f6dc1cffd4cb1$var$ChromeForAndroid = $da1f6dc1cffd4cb1$var$userAgent(/chrome/i) && $da1f6dc1cffd4cb1$var$userAgent(/android/i);
var $da1f6dc1cffd4cb1$var$captureMode = {
    capture: false,
    passive: false
};
function $da1f6dc1cffd4cb1$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$da1f6dc1cffd4cb1$var$IE11OrLess && $da1f6dc1cffd4cb1$var$captureMode);
}
function $da1f6dc1cffd4cb1$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$da1f6dc1cffd4cb1$var$IE11OrLess && $da1f6dc1cffd4cb1$var$captureMode);
}
function $da1f6dc1cffd4cb1$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === ">" && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $da1f6dc1cffd4cb1$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $da1f6dc1cffd4cb1$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && $da1f6dc1cffd4cb1$var$matches(el, selector) : $da1f6dc1cffd4cb1$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $da1f6dc1cffd4cb1$var$getParentOrHost(el));
    }
    return null;
}
var $da1f6dc1cffd4cb1$var$R_SPACE = /\s+/g;
function $da1f6dc1cffd4cb1$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? "add" : "remove"](name);
        else {
            var className = (" " + el.className + " ").replace($da1f6dc1cffd4cb1$var$R_SPACE, " ").replace(" " + name + " ", " ");
            el.className = (className + (state ? " " + name : "")).replace($da1f6dc1cffd4cb1$var$R_SPACE, " ");
        }
    }
}
function $da1f6dc1cffd4cb1$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, "");
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf("webkit") === -1) prop = "-webkit-" + prop;
            style[prop] = val + (typeof val === "string" ? "" : "px");
        }
    }
}
function $da1f6dc1cffd4cb1$var$matrix(el, selfOnly) {
    var appliedTransforms = "";
    if (typeof el === "string") appliedTransforms = el;
    else do {
        var transform = $da1f6dc1cffd4cb1$var$css(el, "transform");
        if (transform && transform !== "none") appliedTransforms = transform + " " + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $da1f6dc1cffd4cb1$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $da1f6dc1cffd4cb1$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $da1f6dc1cffd4cb1$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $da1f6dc1cffd4cb1$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode;
        // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$da1f6dc1cffd4cb1$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($da1f6dc1cffd4cb1$var$css(container, "transform") !== "none" || relativeToNonStaticParent && $da1f6dc1cffd4cb1$var$css(container, "position") !== "static")) {
                var containerRect = container.getBoundingClientRect();
                // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($da1f6dc1cffd4cb1$var$css(container, "border-top-width"));
                left -= containerRect.left + parseInt($da1f6dc1cffd4cb1$var$css(container, "border-left-width"));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $da1f6dc1cffd4cb1$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $da1f6dc1cffd4cb1$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $da1f6dc1cffd4cb1$var$getParentAutoScrollElement(el, true), elSideVal = $da1f6dc1cffd4cb1$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $da1f6dc1cffd4cb1$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === "top" || parentSide === "left") visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $da1f6dc1cffd4cb1$var$getWindowScrollingElement()) break;
        parent = $da1f6dc1cffd4cb1$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $da1f6dc1cffd4cb1$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== "none" && children[i] !== $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.dragged) && $da1f6dc1cffd4cb1$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $da1f6dc1cffd4cb1$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.ghost || $da1f6dc1cffd4cb1$var$css(last, "display") === "none" || selector && !$da1f6dc1cffd4cb1$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $da1f6dc1cffd4cb1$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.clone && (!selector || $da1f6dc1cffd4cb1$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $da1f6dc1cffd4cb1$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $da1f6dc1cffd4cb1$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $da1f6dc1cffd4cb1$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $da1f6dc1cffd4cb1$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $da1f6dc1cffd4cb1$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $da1f6dc1cffd4cb1$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $da1f6dc1cffd4cb1$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
            if (!elem.getBoundingClientRect || elem === document.body) return $da1f6dc1cffd4cb1$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $da1f6dc1cffd4cb1$var$getWindowScrollingElement();
}
function $da1f6dc1cffd4cb1$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $da1f6dc1cffd4cb1$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $da1f6dc1cffd4cb1$var$_throttleTimeout;
function $da1f6dc1cffd4cb1$var$throttle(callback, ms) {
    return function() {
        if (!$da1f6dc1cffd4cb1$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $da1f6dc1cffd4cb1$var$_throttleTimeout = setTimeout(function() {
                $da1f6dc1cffd4cb1$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $da1f6dc1cffd4cb1$var$cancelThrottle() {
    clearTimeout($da1f6dc1cffd4cb1$var$_throttleTimeout);
    $da1f6dc1cffd4cb1$var$_throttleTimeout = void 0;
}
function $da1f6dc1cffd4cb1$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $da1f6dc1cffd4cb1$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $da1f6dc1cffd4cb1$var$setRect(el, rect) {
    $da1f6dc1cffd4cb1$var$css(el, "position", "absolute");
    $da1f6dc1cffd4cb1$var$css(el, "top", rect.top);
    $da1f6dc1cffd4cb1$var$css(el, "left", rect.left);
    $da1f6dc1cffd4cb1$var$css(el, "width", rect.width);
    $da1f6dc1cffd4cb1$var$css(el, "height", rect.height);
}
function $da1f6dc1cffd4cb1$var$unsetRect(el) {
    $da1f6dc1cffd4cb1$var$css(el, "position", "");
    $da1f6dc1cffd4cb1$var$css(el, "top", "");
    $da1f6dc1cffd4cb1$var$css(el, "left", "");
    $da1f6dc1cffd4cb1$var$css(el, "width", "");
    $da1f6dc1cffd4cb1$var$css(el, "height", "");
}
function $da1f6dc1cffd4cb1$var$getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!$da1f6dc1cffd4cb1$var$closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
        var childRect = $da1f6dc1cffd4cb1$var$getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var $da1f6dc1cffd4cb1$var$expando = "Sortable" + new Date().getTime();
function $da1f6dc1cffd4cb1$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($da1f6dc1cffd4cb1$var$css(child, "display") === "none" || child === $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $da1f6dc1cffd4cb1$var$getRect(child)
                });
                var fromRect = $da1f6dc1cffd4cb1$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect);
                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $da1f6dc1cffd4cb1$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($da1f6dc1cffd4cb1$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === "function") callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $da1f6dc1cffd4cb1$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $da1f6dc1cffd4cb1$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($da1f6dc1cffd4cb1$var$isRectEqual(prevFromRect, toRect) && !$da1f6dc1cffd4cb1$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $da1f6dc1cffd4cb1$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                // if fromRect != toRect: animate
                if (!$da1f6dc1cffd4cb1$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === "function") callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === "function") callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $da1f6dc1cffd4cb1$var$css(target, "transition", "");
                $da1f6dc1cffd4cb1$var$css(target, "transform", "");
                var elMatrix = $da1f6dc1cffd4cb1$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $da1f6dc1cffd4cb1$var$css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
                this.forRepaintDummy = $da1f6dc1cffd4cb1$var$repaint(target); // repaint
                $da1f6dc1cffd4cb1$var$css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
                $da1f6dc1cffd4cb1$var$css(target, "transform", "translate3d(0,0,0)");
                typeof target.animated === "number" && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $da1f6dc1cffd4cb1$var$css(target, "transition", "");
                    $da1f6dc1cffd4cb1$var$css(target, "transform", "");
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $da1f6dc1cffd4cb1$var$repaint(target) {
    return target.offsetWidth;
}
function $da1f6dc1cffd4cb1$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $da1f6dc1cffd4cb1$var$plugins = [];
var $da1f6dc1cffd4cb1$var$defaults = {
    initializeByDefault: true
};
var $da1f6dc1cffd4cb1$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $da1f6dc1cffd4cb1$var$defaults)if ($da1f6dc1cffd4cb1$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $da1f6dc1cffd4cb1$var$defaults[option];
        $da1f6dc1cffd4cb1$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $da1f6dc1cffd4cb1$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + "Global";
        $da1f6dc1cffd4cb1$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($da1f6dc1cffd4cb1$var$_objectSpread2({
                sortable: sortable
            }, evt));
            // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($da1f6dc1cffd4cb1$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $da1f6dc1cffd4cb1$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            // Add default options from plugin
            $da1f6dc1cffd4cb1$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== "undefined") sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $da1f6dc1cffd4cb1$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== "function") return;
            $da1f6dc1cffd4cb1$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $da1f6dc1cffd4cb1$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return;
            // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $da1f6dc1cffd4cb1$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$da1f6dc1cffd4cb1$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$da1f6dc1cffd4cb1$var$IE11OrLess && !$da1f6dc1cffd4cb1$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $da1f6dc1cffd4cb1$var$_objectSpread2($da1f6dc1cffd4cb1$var$_objectSpread2({}, extraEventProperties), $da1f6dc1cffd4cb1$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $da1f6dc1cffd4cb1$var$_excluded = [
    "evt"
];
var $da1f6dc1cffd4cb1$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $da1f6dc1cffd4cb1$var$_objectWithoutProperties(_ref, $da1f6dc1cffd4cb1$var$_excluded);
    $da1f6dc1cffd4cb1$var$PluginManager.pluginEvent.bind($da1f6dc1cffd4cb1$export$31b3ca70d8f57423)(eventName, sortable, $da1f6dc1cffd4cb1$var$_objectSpread2({
        dragEl: $da1f6dc1cffd4cb1$var$dragEl,
        parentEl: $da1f6dc1cffd4cb1$var$parentEl,
        ghostEl: $da1f6dc1cffd4cb1$var$ghostEl,
        rootEl: $da1f6dc1cffd4cb1$var$rootEl,
        nextEl: $da1f6dc1cffd4cb1$var$nextEl,
        lastDownEl: $da1f6dc1cffd4cb1$var$lastDownEl,
        cloneEl: $da1f6dc1cffd4cb1$var$cloneEl,
        cloneHidden: $da1f6dc1cffd4cb1$var$cloneHidden,
        dragStarted: $da1f6dc1cffd4cb1$var$moved,
        putSortable: $da1f6dc1cffd4cb1$var$putSortable,
        activeSortable: $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $da1f6dc1cffd4cb1$var$oldIndex,
        oldDraggableIndex: $da1f6dc1cffd4cb1$var$oldDraggableIndex,
        newIndex: $da1f6dc1cffd4cb1$var$newIndex,
        newDraggableIndex: $da1f6dc1cffd4cb1$var$newDraggableIndex,
        hideGhostForTarget: $da1f6dc1cffd4cb1$var$_hideGhostForTarget,
        unhideGhostForTarget: $da1f6dc1cffd4cb1$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $da1f6dc1cffd4cb1$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $da1f6dc1cffd4cb1$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $da1f6dc1cffd4cb1$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $da1f6dc1cffd4cb1$var$_dispatchEvent(info) {
    $da1f6dc1cffd4cb1$var$dispatchEvent($da1f6dc1cffd4cb1$var$_objectSpread2({
        putSortable: $da1f6dc1cffd4cb1$var$putSortable,
        cloneEl: $da1f6dc1cffd4cb1$var$cloneEl,
        targetEl: $da1f6dc1cffd4cb1$var$dragEl,
        rootEl: $da1f6dc1cffd4cb1$var$rootEl,
        oldIndex: $da1f6dc1cffd4cb1$var$oldIndex,
        oldDraggableIndex: $da1f6dc1cffd4cb1$var$oldDraggableIndex,
        newIndex: $da1f6dc1cffd4cb1$var$newIndex,
        newDraggableIndex: $da1f6dc1cffd4cb1$var$newDraggableIndex
    }, info));
}
var $da1f6dc1cffd4cb1$var$dragEl, $da1f6dc1cffd4cb1$var$parentEl, $da1f6dc1cffd4cb1$var$ghostEl, $da1f6dc1cffd4cb1$var$rootEl, $da1f6dc1cffd4cb1$var$nextEl, $da1f6dc1cffd4cb1$var$lastDownEl, $da1f6dc1cffd4cb1$var$cloneEl, $da1f6dc1cffd4cb1$var$cloneHidden, $da1f6dc1cffd4cb1$var$oldIndex, $da1f6dc1cffd4cb1$var$newIndex, $da1f6dc1cffd4cb1$var$oldDraggableIndex, $da1f6dc1cffd4cb1$var$newDraggableIndex, $da1f6dc1cffd4cb1$var$activeGroup, $da1f6dc1cffd4cb1$var$putSortable, $da1f6dc1cffd4cb1$var$awaitingDragStarted = false, $da1f6dc1cffd4cb1$var$ignoreNextClick = false, $da1f6dc1cffd4cb1$var$sortables = [], $da1f6dc1cffd4cb1$var$tapEvt, $da1f6dc1cffd4cb1$var$touchEvt, $da1f6dc1cffd4cb1$var$lastDx, $da1f6dc1cffd4cb1$var$lastDy, $da1f6dc1cffd4cb1$var$tapDistanceLeft, $da1f6dc1cffd4cb1$var$tapDistanceTop, $da1f6dc1cffd4cb1$var$moved, $da1f6dc1cffd4cb1$var$lastTarget, $da1f6dc1cffd4cb1$var$lastDirection, $da1f6dc1cffd4cb1$var$pastFirstInvertThresh = false, $da1f6dc1cffd4cb1$var$isCircumstantialInvert = false, $da1f6dc1cffd4cb1$var$targetMoveDistance, // For positioning ghost absolutely
$da1f6dc1cffd4cb1$var$ghostRelativeParent, $da1f6dc1cffd4cb1$var$ghostRelativeParentInitialScroll = [], // (left, top)
$da1f6dc1cffd4cb1$var$_silent = false, $da1f6dc1cffd4cb1$var$savedInputChecked = [];
/** @const */ var $da1f6dc1cffd4cb1$var$documentExists = typeof document !== "undefined", $da1f6dc1cffd4cb1$var$PositionGhostAbsolutely = $da1f6dc1cffd4cb1$var$IOS, $da1f6dc1cffd4cb1$var$CSSFloatProperty = $da1f6dc1cffd4cb1$var$Edge || $da1f6dc1cffd4cb1$var$IE11OrLess ? "cssFloat" : "float", // This will not pass for IE9, because IE9 DnD only works on anchors
$da1f6dc1cffd4cb1$var$supportDraggable = $da1f6dc1cffd4cb1$var$documentExists && !$da1f6dc1cffd4cb1$var$ChromeForAndroid && !$da1f6dc1cffd4cb1$var$IOS && "draggable" in document.createElement("div"), $da1f6dc1cffd4cb1$var$supportCssPointerEvents = function() {
    if (!$da1f6dc1cffd4cb1$var$documentExists) return;
    // false when <= IE11
    if ($da1f6dc1cffd4cb1$var$IE11OrLess) return false;
    var el = document.createElement("x");
    el.style.cssText = "pointer-events:auto";
    return el.style.pointerEvents === "auto";
}(), $da1f6dc1cffd4cb1$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $da1f6dc1cffd4cb1$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $da1f6dc1cffd4cb1$var$getChild(el, 0, options), child2 = $da1f6dc1cffd4cb1$var$getChild(el, 1, options), firstChildCSS = child1 && $da1f6dc1cffd4cb1$var$css(child1), secondChildCSS = child2 && $da1f6dc1cffd4cb1$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $da1f6dc1cffd4cb1$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $da1f6dc1cffd4cb1$var$getRect(child2).width;
    if (elCSS.display === "flex") return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
    if (elCSS.display === "grid") return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
        var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
        return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
    }
    return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[$da1f6dc1cffd4cb1$var$CSSFloatProperty] === "none" || child2 && elCSS[$da1f6dc1cffd4cb1$var$CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, $da1f6dc1cffd4cb1$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */ $da1f6dc1cffd4cb1$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $da1f6dc1cffd4cb1$var$sortables.some(function(sortable) {
        var threshold = sortable[$da1f6dc1cffd4cb1$var$expando].options.emptyInsertThreshold;
        if (!threshold || $da1f6dc1cffd4cb1$var$lastChild(sortable)) return;
        var rect = $da1f6dc1cffd4cb1$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $da1f6dc1cffd4cb1$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === "clone") return value;
            else if (typeof value === "function") return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $da1f6dc1cffd4cb1$var$_typeof(originalGroup) != "object") originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $da1f6dc1cffd4cb1$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$da1f6dc1cffd4cb1$var$supportCssPointerEvents && $da1f6dc1cffd4cb1$var$ghostEl) $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "display", "none");
}, $da1f6dc1cffd4cb1$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$da1f6dc1cffd4cb1$var$supportCssPointerEvents && $da1f6dc1cffd4cb1$var$ghostEl) $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "display", "");
};
// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($da1f6dc1cffd4cb1$var$documentExists && !$da1f6dc1cffd4cb1$var$ChromeForAndroid) document.addEventListener("click", function(evt) {
    if ($da1f6dc1cffd4cb1$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $da1f6dc1cffd4cb1$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $da1f6dc1cffd4cb1$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($da1f6dc1cffd4cb1$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $da1f6dc1cffd4cb1$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$da1f6dc1cffd4cb1$var$expando]._onDragOver(event);
        }
    }
};
var $da1f6dc1cffd4cb1$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($da1f6dc1cffd4cb1$var$dragEl) $da1f6dc1cffd4cb1$var$dragEl.parentNode[$da1f6dc1cffd4cb1$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $da1f6dc1cffd4cb1$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $da1f6dc1cffd4cb1$var$_extends({}, options);
    // Export instance
    el[$da1f6dc1cffd4cb1$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $da1f6dc1cffd4cb1$var$_detectDirection(el, this.options);
        },
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        ignore: "a, img",
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData("Text", dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: "data-id",
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: "sortable-fallback",
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        supportPointer: $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.supportPointer !== false && "PointerEvent" in window && !$da1f6dc1cffd4cb1$var$Safari,
        emptyInsertThreshold: 5
    };
    $da1f6dc1cffd4cb1$var$PluginManager.initializePlugins(this, el, defaults);
    // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $da1f6dc1cffd4cb1$var$_prepareGroup(options);
    // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $da1f6dc1cffd4cb1$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
    // Bind events
    if (options.supportPointer) $da1f6dc1cffd4cb1$var$on(el, "pointerdown", this._onTapStart);
    else {
        $da1f6dc1cffd4cb1$var$on(el, "mousedown", this._onTapStart);
        $da1f6dc1cffd4cb1$var$on(el, "touchstart", this._onTapStart);
    }
    if (this.nativeDraggable) {
        $da1f6dc1cffd4cb1$var$on(el, "dragover", this);
        $da1f6dc1cffd4cb1$var$on(el, "dragenter", this);
    }
    $da1f6dc1cffd4cb1$var$sortables.push(this.el);
    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    // Add animation state manager
    $da1f6dc1cffd4cb1$var$_extends(this, $da1f6dc1cffd4cb1$var$AnimationStateManager());
}
$da1f6dc1cffd4cb1$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $da1f6dc1cffd4cb1$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $da1f6dc1cffd4cb1$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, $da1f6dc1cffd4cb1$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $da1f6dc1cffd4cb1$var$_saveInputCheckedState(el);
        // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($da1f6dc1cffd4cb1$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
        // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
        // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $da1f6dc1cffd4cb1$var$Safari && target && target.tagName.toUpperCase() === "SELECT") return;
        target = $da1f6dc1cffd4cb1$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($da1f6dc1cffd4cb1$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
        // Get the index of the dragged element within its parent
        $da1f6dc1cffd4cb1$var$oldIndex = $da1f6dc1cffd4cb1$var$index(target);
        $da1f6dc1cffd4cb1$var$oldDraggableIndex = $da1f6dc1cffd4cb1$var$index(target, options.draggable);
        // Check filter
        if (typeof filter === "function") {
            if (filter.call(this, evt, target, this)) {
                $da1f6dc1cffd4cb1$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: "filter",
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $da1f6dc1cffd4cb1$var$pluginEvent("filter", _this, {
                    evt: evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(",").some(function(criteria) {
                criteria = $da1f6dc1cffd4cb1$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $da1f6dc1cffd4cb1$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: "filter",
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $da1f6dc1cffd4cb1$var$pluginEvent("filter", _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$da1f6dc1cffd4cb1$var$closest(originalTarget, options.handle, el, false)) return;
        // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$da1f6dc1cffd4cb1$var$dragEl && target.parentNode === el) {
            var dragRect = $da1f6dc1cffd4cb1$var$getRect(target);
            $da1f6dc1cffd4cb1$var$rootEl = el;
            $da1f6dc1cffd4cb1$var$dragEl = target;
            $da1f6dc1cffd4cb1$var$parentEl = $da1f6dc1cffd4cb1$var$dragEl.parentNode;
            $da1f6dc1cffd4cb1$var$nextEl = $da1f6dc1cffd4cb1$var$dragEl.nextSibling;
            $da1f6dc1cffd4cb1$var$lastDownEl = target;
            $da1f6dc1cffd4cb1$var$activeGroup = options.group;
            $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.dragged = $da1f6dc1cffd4cb1$var$dragEl;
            $da1f6dc1cffd4cb1$var$tapEvt = {
                target: $da1f6dc1cffd4cb1$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $da1f6dc1cffd4cb1$var$tapDistanceLeft = $da1f6dc1cffd4cb1$var$tapEvt.clientX - dragRect.left;
            $da1f6dc1cffd4cb1$var$tapDistanceTop = $da1f6dc1cffd4cb1$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $da1f6dc1cffd4cb1$var$dragEl.style["will-change"] = "all";
            dragStartFn = function dragStartFn() {
                $da1f6dc1cffd4cb1$var$pluginEvent("delayEnded", _this, {
                    evt: evt
                });
                if ($da1f6dc1cffd4cb1$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$da1f6dc1cffd4cb1$var$FireFox && _this.nativeDraggable) $da1f6dc1cffd4cb1$var$dragEl.draggable = true;
                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);
                // Drag start event
                $da1f6dc1cffd4cb1$var$_dispatchEvent({
                    sortable: _this,
                    name: "choose",
                    originalEvent: evt
                });
                // Chosen item
                $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$dragEl, options.chosenClass, true);
            };
            // Disable "draggable"
            options.ignore.split(",").forEach(function(criteria) {
                $da1f6dc1cffd4cb1$var$find($da1f6dc1cffd4cb1$var$dragEl, criteria.trim(), $da1f6dc1cffd4cb1$var$_disableDraggable);
            });
            $da1f6dc1cffd4cb1$var$on(ownerDocument, "dragover", $da1f6dc1cffd4cb1$var$nearestEmptyInsertDetectEvent);
            $da1f6dc1cffd4cb1$var$on(ownerDocument, "mousemove", $da1f6dc1cffd4cb1$var$nearestEmptyInsertDetectEvent);
            $da1f6dc1cffd4cb1$var$on(ownerDocument, "touchmove", $da1f6dc1cffd4cb1$var$nearestEmptyInsertDetectEvent);
            $da1f6dc1cffd4cb1$var$on(ownerDocument, "mouseup", _this._onDrop);
            $da1f6dc1cffd4cb1$var$on(ownerDocument, "touchend", _this._onDrop);
            $da1f6dc1cffd4cb1$var$on(ownerDocument, "touchcancel", _this._onDrop);
            // Make dragEl draggable (must be before delay for FireFox)
            if ($da1f6dc1cffd4cb1$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $da1f6dc1cffd4cb1$var$dragEl.draggable = true;
            }
            $da1f6dc1cffd4cb1$var$pluginEvent("delayStart", this, {
                evt: evt
            });
            // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($da1f6dc1cffd4cb1$var$Edge || $da1f6dc1cffd4cb1$var$IE11OrLess))) {
                if ($da1f6dc1cffd4cb1$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                $da1f6dc1cffd4cb1$var$on(ownerDocument, "mouseup", _this._disableDelayedDrag);
                $da1f6dc1cffd4cb1$var$on(ownerDocument, "touchend", _this._disableDelayedDrag);
                $da1f6dc1cffd4cb1$var$on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
                $da1f6dc1cffd4cb1$var$on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
                $da1f6dc1cffd4cb1$var$on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
                options.supportPointer && $da1f6dc1cffd4cb1$var$on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $da1f6dc1cffd4cb1$var$dragEl && $da1f6dc1cffd4cb1$var$_disableDraggable($da1f6dc1cffd4cb1$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $da1f6dc1cffd4cb1$var$off(ownerDocument, "mouseup", this._disableDelayedDrag);
        $da1f6dc1cffd4cb1$var$off(ownerDocument, "touchend", this._disableDelayedDrag);
        $da1f6dc1cffd4cb1$var$off(ownerDocument, "touchcancel", this._disableDelayedDrag);
        $da1f6dc1cffd4cb1$var$off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
        $da1f6dc1cffd4cb1$var$off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
        $da1f6dc1cffd4cb1$var$off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == "touch" && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $da1f6dc1cffd4cb1$var$on(document, "pointermove", this._onTouchMove);
            else if (touch) $da1f6dc1cffd4cb1$var$on(document, "touchmove", this._onTouchMove);
            else $da1f6dc1cffd4cb1$var$on(document, "mousemove", this._onTouchMove);
        } else {
            $da1f6dc1cffd4cb1$var$on($da1f6dc1cffd4cb1$var$dragEl, "dragend", this);
            $da1f6dc1cffd4cb1$var$on($da1f6dc1cffd4cb1$var$rootEl, "dragstart", this._onDragStart);
        }
        try {
            if (document.selection) // Timeout neccessary for IE9
            $da1f6dc1cffd4cb1$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $da1f6dc1cffd4cb1$var$awaitingDragStarted = false;
        if ($da1f6dc1cffd4cb1$var$rootEl && $da1f6dc1cffd4cb1$var$dragEl) {
            $da1f6dc1cffd4cb1$var$pluginEvent("dragStarted", this, {
                evt: evt
            });
            if (this.nativeDraggable) $da1f6dc1cffd4cb1$var$on(document, "dragover", $da1f6dc1cffd4cb1$var$_checkOutsideTargetEl);
            var options = this.options;
            // Apply effect
            !fallback && $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$dragEl, options.dragClass, false);
            $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$dragEl, options.ghostClass, true);
            $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost();
            // Drag start event
            $da1f6dc1cffd4cb1$var$_dispatchEvent({
                sortable: this,
                name: "start",
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($da1f6dc1cffd4cb1$var$touchEvt) {
            this._lastX = $da1f6dc1cffd4cb1$var$touchEvt.clientX;
            this._lastY = $da1f6dc1cffd4cb1$var$touchEvt.clientY;
            $da1f6dc1cffd4cb1$var$_hideGhostForTarget();
            var target = document.elementFromPoint($da1f6dc1cffd4cb1$var$touchEvt.clientX, $da1f6dc1cffd4cb1$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($da1f6dc1cffd4cb1$var$touchEvt.clientX, $da1f6dc1cffd4cb1$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $da1f6dc1cffd4cb1$var$dragEl.parentNode[$da1f6dc1cffd4cb1$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$da1f6dc1cffd4cb1$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$da1f6dc1cffd4cb1$var$expando]._onDragOver({
                        clientX: $da1f6dc1cffd4cb1$var$touchEvt.clientX,
                        clientY: $da1f6dc1cffd4cb1$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = parent.parentNode);
            $da1f6dc1cffd4cb1$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($da1f6dc1cffd4cb1$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $da1f6dc1cffd4cb1$var$ghostEl && $da1f6dc1cffd4cb1$var$matrix($da1f6dc1cffd4cb1$var$ghostEl, true), scaleX = $da1f6dc1cffd4cb1$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $da1f6dc1cffd4cb1$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $da1f6dc1cffd4cb1$var$PositionGhostAbsolutely && $da1f6dc1cffd4cb1$var$ghostRelativeParent && $da1f6dc1cffd4cb1$var$getRelativeScrollOffset($da1f6dc1cffd4cb1$var$ghostRelativeParent), dx = (touch.clientX - $da1f6dc1cffd4cb1$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $da1f6dc1cffd4cb1$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $da1f6dc1cffd4cb1$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $da1f6dc1cffd4cb1$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            // only set the status to dragging, when we are actually dragging
            if (!$da1f6dc1cffd4cb1$export$31b3ca70d8f57423.active && !$da1f6dc1cffd4cb1$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($da1f6dc1cffd4cb1$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($da1f6dc1cffd4cb1$var$lastDx || 0);
                    ghostMatrix.f += dy - ($da1f6dc1cffd4cb1$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "webkitTransform", cssMatrix);
                $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "mozTransform", cssMatrix);
                $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "msTransform", cssMatrix);
                $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "transform", cssMatrix);
                $da1f6dc1cffd4cb1$var$lastDx = dx;
                $da1f6dc1cffd4cb1$var$lastDy = dy;
                $da1f6dc1cffd4cb1$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$da1f6dc1cffd4cb1$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $da1f6dc1cffd4cb1$var$rootEl, rect = $da1f6dc1cffd4cb1$var$getRect($da1f6dc1cffd4cb1$var$dragEl, true, $da1f6dc1cffd4cb1$var$PositionGhostAbsolutely, true, container), options = this.options;
            // Position absolutely
            if ($da1f6dc1cffd4cb1$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $da1f6dc1cffd4cb1$var$ghostRelativeParent = container;
                while($da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostRelativeParent, "position") === "static" && $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostRelativeParent, "transform") === "none" && $da1f6dc1cffd4cb1$var$ghostRelativeParent !== document)$da1f6dc1cffd4cb1$var$ghostRelativeParent = $da1f6dc1cffd4cb1$var$ghostRelativeParent.parentNode;
                if ($da1f6dc1cffd4cb1$var$ghostRelativeParent !== document.body && $da1f6dc1cffd4cb1$var$ghostRelativeParent !== document.documentElement) {
                    if ($da1f6dc1cffd4cb1$var$ghostRelativeParent === document) $da1f6dc1cffd4cb1$var$ghostRelativeParent = $da1f6dc1cffd4cb1$var$getWindowScrollingElement();
                    rect.top += $da1f6dc1cffd4cb1$var$ghostRelativeParent.scrollTop;
                    rect.left += $da1f6dc1cffd4cb1$var$ghostRelativeParent.scrollLeft;
                } else $da1f6dc1cffd4cb1$var$ghostRelativeParent = $da1f6dc1cffd4cb1$var$getWindowScrollingElement();
                $da1f6dc1cffd4cb1$var$ghostRelativeParentInitialScroll = $da1f6dc1cffd4cb1$var$getRelativeScrollOffset($da1f6dc1cffd4cb1$var$ghostRelativeParent);
            }
            $da1f6dc1cffd4cb1$var$ghostEl = $da1f6dc1cffd4cb1$var$dragEl.cloneNode(true);
            $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$ghostEl, options.ghostClass, false);
            $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$ghostEl, options.fallbackClass, true);
            $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$ghostEl, options.dragClass, true);
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "transition", "");
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "transform", "");
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "box-sizing", "border-box");
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "margin", 0);
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "top", rect.top);
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "left", rect.left);
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "width", rect.width);
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "height", rect.height);
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "opacity", "0.8");
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "position", $da1f6dc1cffd4cb1$var$PositionGhostAbsolutely ? "absolute" : "fixed");
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "zIndex", "100000");
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "pointerEvents", "none");
            $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.ghost = $da1f6dc1cffd4cb1$var$ghostEl;
            container.appendChild($da1f6dc1cffd4cb1$var$ghostEl);
            // Set transform-origin
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$ghostEl, "transform-origin", $da1f6dc1cffd4cb1$var$tapDistanceLeft / parseInt($da1f6dc1cffd4cb1$var$ghostEl.style.width) * 100 + "% " + $da1f6dc1cffd4cb1$var$tapDistanceTop / parseInt($da1f6dc1cffd4cb1$var$ghostEl.style.height) * 100 + "%");
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $da1f6dc1cffd4cb1$var$pluginEvent("dragStart", this, {
            evt: evt
        });
        if ($da1f6dc1cffd4cb1$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $da1f6dc1cffd4cb1$var$pluginEvent("setupClone", this);
        if (!$da1f6dc1cffd4cb1$export$31b3ca70d8f57423.eventCanceled) {
            $da1f6dc1cffd4cb1$var$cloneEl = $da1f6dc1cffd4cb1$var$clone($da1f6dc1cffd4cb1$var$dragEl);
            $da1f6dc1cffd4cb1$var$cloneEl.removeAttribute("id");
            $da1f6dc1cffd4cb1$var$cloneEl.draggable = false;
            $da1f6dc1cffd4cb1$var$cloneEl.style["will-change"] = "";
            this._hideClone();
            $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$cloneEl, this.options.chosenClass, false);
            $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.clone = $da1f6dc1cffd4cb1$var$cloneEl;
        }
        // #1143: IFrame support workaround
        _this.cloneId = $da1f6dc1cffd4cb1$var$_nextTick(function() {
            $da1f6dc1cffd4cb1$var$pluginEvent("clone", _this);
            if ($da1f6dc1cffd4cb1$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $da1f6dc1cffd4cb1$var$rootEl.insertBefore($da1f6dc1cffd4cb1$var$cloneEl, $da1f6dc1cffd4cb1$var$dragEl);
            _this._hideClone();
            $da1f6dc1cffd4cb1$var$_dispatchEvent({
                sortable: _this,
                name: "clone"
            });
        });
        !fallback && $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$dragEl, options.dragClass, true);
        // Set proper drop events
        if (fallback) {
            $da1f6dc1cffd4cb1$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $da1f6dc1cffd4cb1$var$off(document, "mouseup", _this._onDrop);
            $da1f6dc1cffd4cb1$var$off(document, "touchend", _this._onDrop);
            $da1f6dc1cffd4cb1$var$off(document, "touchcancel", _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = "move";
                options.setData && options.setData.call(_this, dataTransfer, $da1f6dc1cffd4cb1$var$dragEl);
            }
            $da1f6dc1cffd4cb1$var$on(document, "drop", _this);
            // #1276 fix:
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$dragEl, "transform", "translateZ(0)");
        }
        $da1f6dc1cffd4cb1$var$awaitingDragStarted = true;
        _this._dragStartId = $da1f6dc1cffd4cb1$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $da1f6dc1cffd4cb1$var$on(document, "selectstart", _this);
        $da1f6dc1cffd4cb1$var$moved = true;
        if ($da1f6dc1cffd4cb1$var$Safari) $da1f6dc1cffd4cb1$var$css(document.body, "user-select", "none");
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.active, isOwner = $da1f6dc1cffd4cb1$var$activeGroup === group, canSort = options.sort, fromSortable = $da1f6dc1cffd4cb1$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($da1f6dc1cffd4cb1$var$_silent) return;
        function dragOverEvent(name, extra) {
            $da1f6dc1cffd4cb1$var$pluginEvent(name, _this, $da1f6dc1cffd4cb1$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? "vertical" : "horizontal",
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $da1f6dc1cffd4cb1$var$_onMove($da1f6dc1cffd4cb1$var$rootEl, el, $da1f6dc1cffd4cb1$var$dragEl, dragRect, target, $da1f6dc1cffd4cb1$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        }
        // Capture animation state
        function capture() {
            dragOverEvent("dragOverAnimationCapture");
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent("dragOverCompleted", {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$dragEl, $da1f6dc1cffd4cb1$var$putSortable ? $da1f6dc1cffd4cb1$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$dragEl, options.ghostClass, true);
                }
                if ($da1f6dc1cffd4cb1$var$putSortable !== _this && _this !== $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.active) $da1f6dc1cffd4cb1$var$putSortable = _this;
                else if (_this === $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.active && $da1f6dc1cffd4cb1$var$putSortable) $da1f6dc1cffd4cb1$var$putSortable = null;
                // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent("dragOverAnimationComplete");
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            // Null lastTarget if it is not inside a previously swapped element
            if (target === $da1f6dc1cffd4cb1$var$dragEl && !$da1f6dc1cffd4cb1$var$dragEl.animated || target === el && !target.animated) $da1f6dc1cffd4cb1$var$lastTarget = null;
            // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $da1f6dc1cffd4cb1$var$dragEl.parentNode[$da1f6dc1cffd4cb1$var$expando]._isOutsideThisEl(evt.target);
                // Do not detect for empty insert if already inserted
                !insertion && $da1f6dc1cffd4cb1$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        // Call when dragEl has been inserted
        function changed() {
            $da1f6dc1cffd4cb1$var$newIndex = $da1f6dc1cffd4cb1$var$index($da1f6dc1cffd4cb1$var$dragEl);
            $da1f6dc1cffd4cb1$var$newDraggableIndex = $da1f6dc1cffd4cb1$var$index($da1f6dc1cffd4cb1$var$dragEl, options.draggable);
            $da1f6dc1cffd4cb1$var$_dispatchEvent({
                sortable: _this,
                name: "change",
                toEl: el,
                newIndex: $da1f6dc1cffd4cb1$var$newIndex,
                newDraggableIndex: $da1f6dc1cffd4cb1$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $da1f6dc1cffd4cb1$var$closest(target, options.draggable, el, true);
        dragOverEvent("dragOver");
        if ($da1f6dc1cffd4cb1$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($da1f6dc1cffd4cb1$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $da1f6dc1cffd4cb1$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $da1f6dc1cffd4cb1$var$parentEl !== $da1f6dc1cffd4cb1$var$rootEl // Reverting item into the original list
        ) : $da1f6dc1cffd4cb1$var$putSortable === this || (this.lastPutMode = $da1f6dc1cffd4cb1$var$activeGroup.checkPull(this, activeSortable, $da1f6dc1cffd4cb1$var$dragEl, evt)) && group.checkPut(this, activeSortable, $da1f6dc1cffd4cb1$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === "vertical";
            dragRect = $da1f6dc1cffd4cb1$var$getRect($da1f6dc1cffd4cb1$var$dragEl);
            dragOverEvent("dragOverValid");
            if ($da1f6dc1cffd4cb1$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $da1f6dc1cffd4cb1$var$parentEl = $da1f6dc1cffd4cb1$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent("revert");
                if (!$da1f6dc1cffd4cb1$export$31b3ca70d8f57423.eventCanceled) {
                    if ($da1f6dc1cffd4cb1$var$nextEl) $da1f6dc1cffd4cb1$var$rootEl.insertBefore($da1f6dc1cffd4cb1$var$dragEl, $da1f6dc1cffd4cb1$var$nextEl);
                    else $da1f6dc1cffd4cb1$var$rootEl.appendChild($da1f6dc1cffd4cb1$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $da1f6dc1cffd4cb1$var$lastChild(el, options.draggable);
            if (!elLastChild || $da1f6dc1cffd4cb1$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $da1f6dc1cffd4cb1$var$dragEl) return completed(false);
                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $da1f6dc1cffd4cb1$var$getRect(target);
                if ($da1f6dc1cffd4cb1$var$_onMove($da1f6dc1cffd4cb1$var$rootEl, el, $da1f6dc1cffd4cb1$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($da1f6dc1cffd4cb1$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($da1f6dc1cffd4cb1$var$dragEl);
                    $da1f6dc1cffd4cb1$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $da1f6dc1cffd4cb1$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $da1f6dc1cffd4cb1$var$getChild(el, 0, options, true);
                if (firstChild === $da1f6dc1cffd4cb1$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $da1f6dc1cffd4cb1$var$getRect(target);
                if ($da1f6dc1cffd4cb1$var$_onMove($da1f6dc1cffd4cb1$var$rootEl, el, $da1f6dc1cffd4cb1$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($da1f6dc1cffd4cb1$var$dragEl, firstChild);
                    $da1f6dc1cffd4cb1$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $da1f6dc1cffd4cb1$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $da1f6dc1cffd4cb1$var$dragEl.parentNode !== el, differentRowCol = !$da1f6dc1cffd4cb1$var$_dragElInRowColumn($da1f6dc1cffd4cb1$var$dragEl.animated && $da1f6dc1cffd4cb1$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = $da1f6dc1cffd4cb1$var$isScrolledPast(target, "top", "top") || $da1f6dc1cffd4cb1$var$isScrolledPast($da1f6dc1cffd4cb1$var$dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($da1f6dc1cffd4cb1$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $da1f6dc1cffd4cb1$var$pastFirstInvertThresh = false;
                    $da1f6dc1cffd4cb1$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $da1f6dc1cffd4cb1$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $da1f6dc1cffd4cb1$var$isCircumstantialInvert, $da1f6dc1cffd4cb1$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $da1f6dc1cffd4cb1$var$index($da1f6dc1cffd4cb1$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $da1f6dc1cffd4cb1$var$parentEl.children[dragIndex];
                    }while (sibling && ($da1f6dc1cffd4cb1$var$css(sibling, "display") === "none" || sibling === $da1f6dc1cffd4cb1$var$ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $da1f6dc1cffd4cb1$var$lastTarget = target;
                $da1f6dc1cffd4cb1$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $da1f6dc1cffd4cb1$var$_onMove($da1f6dc1cffd4cb1$var$rootEl, el, $da1f6dc1cffd4cb1$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $da1f6dc1cffd4cb1$var$_silent = true;
                    setTimeout($da1f6dc1cffd4cb1$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($da1f6dc1cffd4cb1$var$dragEl);
                    else target.parentNode.insertBefore($da1f6dc1cffd4cb1$var$dragEl, after ? nextSibling : target);
                    // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $da1f6dc1cffd4cb1$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $da1f6dc1cffd4cb1$var$parentEl = $da1f6dc1cffd4cb1$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$da1f6dc1cffd4cb1$var$isCircumstantialInvert) $da1f6dc1cffd4cb1$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $da1f6dc1cffd4cb1$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($da1f6dc1cffd4cb1$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $da1f6dc1cffd4cb1$var$off(document, "mousemove", this._onTouchMove);
        $da1f6dc1cffd4cb1$var$off(document, "touchmove", this._onTouchMove);
        $da1f6dc1cffd4cb1$var$off(document, "pointermove", this._onTouchMove);
        $da1f6dc1cffd4cb1$var$off(document, "dragover", $da1f6dc1cffd4cb1$var$nearestEmptyInsertDetectEvent);
        $da1f6dc1cffd4cb1$var$off(document, "mousemove", $da1f6dc1cffd4cb1$var$nearestEmptyInsertDetectEvent);
        $da1f6dc1cffd4cb1$var$off(document, "touchmove", $da1f6dc1cffd4cb1$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $da1f6dc1cffd4cb1$var$off(ownerDocument, "mouseup", this._onDrop);
        $da1f6dc1cffd4cb1$var$off(ownerDocument, "touchend", this._onDrop);
        $da1f6dc1cffd4cb1$var$off(ownerDocument, "pointerup", this._onDrop);
        $da1f6dc1cffd4cb1$var$off(ownerDocument, "touchcancel", this._onDrop);
        $da1f6dc1cffd4cb1$var$off(document, "selectstart", this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options;
        // Get the index of the dragged element within its parent
        $da1f6dc1cffd4cb1$var$newIndex = $da1f6dc1cffd4cb1$var$index($da1f6dc1cffd4cb1$var$dragEl);
        $da1f6dc1cffd4cb1$var$newDraggableIndex = $da1f6dc1cffd4cb1$var$index($da1f6dc1cffd4cb1$var$dragEl, options.draggable);
        $da1f6dc1cffd4cb1$var$pluginEvent("drop", this, {
            evt: evt
        });
        $da1f6dc1cffd4cb1$var$parentEl = $da1f6dc1cffd4cb1$var$dragEl && $da1f6dc1cffd4cb1$var$dragEl.parentNode;
        // Get again after plugin event
        $da1f6dc1cffd4cb1$var$newIndex = $da1f6dc1cffd4cb1$var$index($da1f6dc1cffd4cb1$var$dragEl);
        $da1f6dc1cffd4cb1$var$newDraggableIndex = $da1f6dc1cffd4cb1$var$index($da1f6dc1cffd4cb1$var$dragEl, options.draggable);
        if ($da1f6dc1cffd4cb1$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $da1f6dc1cffd4cb1$var$awaitingDragStarted = false;
        $da1f6dc1cffd4cb1$var$isCircumstantialInvert = false;
        $da1f6dc1cffd4cb1$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $da1f6dc1cffd4cb1$var$_cancelNextTick(this.cloneId);
        $da1f6dc1cffd4cb1$var$_cancelNextTick(this._dragStartId);
        // Unbind events
        if (this.nativeDraggable) {
            $da1f6dc1cffd4cb1$var$off(document, "drop", this);
            $da1f6dc1cffd4cb1$var$off(el, "dragstart", this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($da1f6dc1cffd4cb1$var$Safari) $da1f6dc1cffd4cb1$var$css(document.body, "user-select", "");
        $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$dragEl, "transform", "");
        if (evt) {
            if ($da1f6dc1cffd4cb1$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $da1f6dc1cffd4cb1$var$ghostEl && $da1f6dc1cffd4cb1$var$ghostEl.parentNode && $da1f6dc1cffd4cb1$var$ghostEl.parentNode.removeChild($da1f6dc1cffd4cb1$var$ghostEl);
            if ($da1f6dc1cffd4cb1$var$rootEl === $da1f6dc1cffd4cb1$var$parentEl || $da1f6dc1cffd4cb1$var$putSortable && $da1f6dc1cffd4cb1$var$putSortable.lastPutMode !== "clone") // Remove clone(s)
            $da1f6dc1cffd4cb1$var$cloneEl && $da1f6dc1cffd4cb1$var$cloneEl.parentNode && $da1f6dc1cffd4cb1$var$cloneEl.parentNode.removeChild($da1f6dc1cffd4cb1$var$cloneEl);
            if ($da1f6dc1cffd4cb1$var$dragEl) {
                if (this.nativeDraggable) $da1f6dc1cffd4cb1$var$off($da1f6dc1cffd4cb1$var$dragEl, "dragend", this);
                $da1f6dc1cffd4cb1$var$_disableDraggable($da1f6dc1cffd4cb1$var$dragEl);
                $da1f6dc1cffd4cb1$var$dragEl.style["will-change"] = "";
                // Remove classes
                // ghostClass is added in dragStarted
                if ($da1f6dc1cffd4cb1$var$moved && !$da1f6dc1cffd4cb1$var$awaitingDragStarted) $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$dragEl, $da1f6dc1cffd4cb1$var$putSortable ? $da1f6dc1cffd4cb1$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$dragEl, this.options.chosenClass, false);
                // Drag stop event
                $da1f6dc1cffd4cb1$var$_dispatchEvent({
                    sortable: this,
                    name: "unchoose",
                    toEl: $da1f6dc1cffd4cb1$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($da1f6dc1cffd4cb1$var$rootEl !== $da1f6dc1cffd4cb1$var$parentEl) {
                    if ($da1f6dc1cffd4cb1$var$newIndex >= 0) {
                        // Add event
                        $da1f6dc1cffd4cb1$var$_dispatchEvent({
                            rootEl: $da1f6dc1cffd4cb1$var$parentEl,
                            name: "add",
                            toEl: $da1f6dc1cffd4cb1$var$parentEl,
                            fromEl: $da1f6dc1cffd4cb1$var$rootEl,
                            originalEvent: evt
                        });
                        // Remove event
                        $da1f6dc1cffd4cb1$var$_dispatchEvent({
                            sortable: this,
                            name: "remove",
                            toEl: $da1f6dc1cffd4cb1$var$parentEl,
                            originalEvent: evt
                        });
                        // drag from one list and drop into another
                        $da1f6dc1cffd4cb1$var$_dispatchEvent({
                            rootEl: $da1f6dc1cffd4cb1$var$parentEl,
                            name: "sort",
                            toEl: $da1f6dc1cffd4cb1$var$parentEl,
                            fromEl: $da1f6dc1cffd4cb1$var$rootEl,
                            originalEvent: evt
                        });
                        $da1f6dc1cffd4cb1$var$_dispatchEvent({
                            sortable: this,
                            name: "sort",
                            toEl: $da1f6dc1cffd4cb1$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $da1f6dc1cffd4cb1$var$putSortable && $da1f6dc1cffd4cb1$var$putSortable.save();
                } else {
                    if ($da1f6dc1cffd4cb1$var$newIndex !== $da1f6dc1cffd4cb1$var$oldIndex) {
                        if ($da1f6dc1cffd4cb1$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $da1f6dc1cffd4cb1$var$_dispatchEvent({
                                sortable: this,
                                name: "update",
                                toEl: $da1f6dc1cffd4cb1$var$parentEl,
                                originalEvent: evt
                            });
                            $da1f6dc1cffd4cb1$var$_dispatchEvent({
                                sortable: this,
                                name: "sort",
                                toEl: $da1f6dc1cffd4cb1$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($da1f6dc1cffd4cb1$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($da1f6dc1cffd4cb1$var$newIndex == null || $da1f6dc1cffd4cb1$var$newIndex === -1) {
                        $da1f6dc1cffd4cb1$var$newIndex = $da1f6dc1cffd4cb1$var$oldIndex;
                        $da1f6dc1cffd4cb1$var$newDraggableIndex = $da1f6dc1cffd4cb1$var$oldDraggableIndex;
                    }
                    $da1f6dc1cffd4cb1$var$_dispatchEvent({
                        sortable: this,
                        name: "end",
                        toEl: $da1f6dc1cffd4cb1$var$parentEl,
                        originalEvent: evt
                    });
                    // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $da1f6dc1cffd4cb1$var$pluginEvent("nulling", this);
        $da1f6dc1cffd4cb1$var$rootEl = $da1f6dc1cffd4cb1$var$dragEl = $da1f6dc1cffd4cb1$var$parentEl = $da1f6dc1cffd4cb1$var$ghostEl = $da1f6dc1cffd4cb1$var$nextEl = $da1f6dc1cffd4cb1$var$cloneEl = $da1f6dc1cffd4cb1$var$lastDownEl = $da1f6dc1cffd4cb1$var$cloneHidden = $da1f6dc1cffd4cb1$var$tapEvt = $da1f6dc1cffd4cb1$var$touchEvt = $da1f6dc1cffd4cb1$var$moved = $da1f6dc1cffd4cb1$var$newIndex = $da1f6dc1cffd4cb1$var$newDraggableIndex = $da1f6dc1cffd4cb1$var$oldIndex = $da1f6dc1cffd4cb1$var$oldDraggableIndex = $da1f6dc1cffd4cb1$var$lastTarget = $da1f6dc1cffd4cb1$var$lastDirection = $da1f6dc1cffd4cb1$var$putSortable = $da1f6dc1cffd4cb1$var$activeGroup = $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.dragged = $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.ghost = $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.clone = $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.active = null;
        $da1f6dc1cffd4cb1$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $da1f6dc1cffd4cb1$var$savedInputChecked.length = $da1f6dc1cffd4cb1$var$lastDx = $da1f6dc1cffd4cb1$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case "drop":
            case "dragend":
                this._onDrop(evt);
                break;
            case "dragenter":
            case "dragover":
                if ($da1f6dc1cffd4cb1$var$dragEl) {
                    this._onDragOver(evt);
                    $da1f6dc1cffd4cb1$var$_globalDragOver(evt);
                }
                break;
            case "selectstart":
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($da1f6dc1cffd4cb1$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $da1f6dc1cffd4cb1$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($da1f6dc1cffd4cb1$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $da1f6dc1cffd4cb1$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $da1f6dc1cffd4cb1$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== "undefined") options[name] = modifiedValue;
            else options[name] = value;
            if (name === "group") $da1f6dc1cffd4cb1$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $da1f6dc1cffd4cb1$var$pluginEvent("destroy", this);
        var el = this.el;
        el[$da1f6dc1cffd4cb1$var$expando] = null;
        $da1f6dc1cffd4cb1$var$off(el, "mousedown", this._onTapStart);
        $da1f6dc1cffd4cb1$var$off(el, "touchstart", this._onTapStart);
        $da1f6dc1cffd4cb1$var$off(el, "pointerdown", this._onTapStart);
        if (this.nativeDraggable) {
            $da1f6dc1cffd4cb1$var$off(el, "dragover", this);
            $da1f6dc1cffd4cb1$var$off(el, "dragenter", this);
        }
        // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el) {
            el.removeAttribute("draggable");
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $da1f6dc1cffd4cb1$var$sortables.splice($da1f6dc1cffd4cb1$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$da1f6dc1cffd4cb1$var$cloneHidden) {
            $da1f6dc1cffd4cb1$var$pluginEvent("hideClone", this);
            if ($da1f6dc1cffd4cb1$export$31b3ca70d8f57423.eventCanceled) return;
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$cloneEl, "display", "none");
            if (this.options.removeCloneOnHide && $da1f6dc1cffd4cb1$var$cloneEl.parentNode) $da1f6dc1cffd4cb1$var$cloneEl.parentNode.removeChild($da1f6dc1cffd4cb1$var$cloneEl);
            $da1f6dc1cffd4cb1$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== "clone") {
            this._hideClone();
            return;
        }
        if ($da1f6dc1cffd4cb1$var$cloneHidden) {
            $da1f6dc1cffd4cb1$var$pluginEvent("showClone", this);
            if ($da1f6dc1cffd4cb1$export$31b3ca70d8f57423.eventCanceled) return;
            // show clone at dragEl or original position
            if ($da1f6dc1cffd4cb1$var$dragEl.parentNode == $da1f6dc1cffd4cb1$var$rootEl && !this.options.group.revertClone) $da1f6dc1cffd4cb1$var$rootEl.insertBefore($da1f6dc1cffd4cb1$var$cloneEl, $da1f6dc1cffd4cb1$var$dragEl);
            else if ($da1f6dc1cffd4cb1$var$nextEl) $da1f6dc1cffd4cb1$var$rootEl.insertBefore($da1f6dc1cffd4cb1$var$cloneEl, $da1f6dc1cffd4cb1$var$nextEl);
            else $da1f6dc1cffd4cb1$var$rootEl.appendChild($da1f6dc1cffd4cb1$var$cloneEl);
            if (this.options.group.revertClone) this.animate($da1f6dc1cffd4cb1$var$dragEl, $da1f6dc1cffd4cb1$var$cloneEl);
            $da1f6dc1cffd4cb1$var$css($da1f6dc1cffd4cb1$var$cloneEl, "display", "");
            $da1f6dc1cffd4cb1$var$cloneHidden = false;
        }
    }
};
function $da1f6dc1cffd4cb1$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = "move";
    evt.cancelable && evt.preventDefault();
}
function $da1f6dc1cffd4cb1$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$da1f6dc1cffd4cb1$var$expando], onMoveFn = sortable.options.onMove, retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$da1f6dc1cffd4cb1$var$IE11OrLess && !$da1f6dc1cffd4cb1$var$Edge) evt = new CustomEvent("move", {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent("move", true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $da1f6dc1cffd4cb1$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $da1f6dc1cffd4cb1$var$_disableDraggable(el) {
    el.draggable = false;
}
function $da1f6dc1cffd4cb1$var$_unsilent() {
    $da1f6dc1cffd4cb1$var$_silent = false;
}
function $da1f6dc1cffd4cb1$var$_ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = $da1f6dc1cffd4cb1$var$getRect($da1f6dc1cffd4cb1$var$getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = $da1f6dc1cffd4cb1$var$getChildContainingRectFromElement(sortable.el, sortable.options, $da1f6dc1cffd4cb1$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function $da1f6dc1cffd4cb1$var$_ghostIsLast(evt, vertical, sortable) {
    var lastElRect = $da1f6dc1cffd4cb1$var$getRect($da1f6dc1cffd4cb1$var$lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = $da1f6dc1cffd4cb1$var$getChildContainingRectFromElement(sortable.el, sortable.options, $da1f6dc1cffd4cb1$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function $da1f6dc1cffd4cb1$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $da1f6dc1cffd4cb1$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$da1f6dc1cffd4cb1$var$pastFirstInvertThresh && ($da1f6dc1cffd4cb1$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $da1f6dc1cffd4cb1$var$pastFirstInvertThresh = true;
            if (!$da1f6dc1cffd4cb1$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($da1f6dc1cffd4cb1$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $da1f6dc1cffd4cb1$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $da1f6dc1cffd4cb1$var$targetMoveDistance) return -$da1f6dc1cffd4cb1$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $da1f6dc1cffd4cb1$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $da1f6dc1cffd4cb1$var$_getInsertDirection(target) {
    if ($da1f6dc1cffd4cb1$var$index($da1f6dc1cffd4cb1$var$dragEl) < $da1f6dc1cffd4cb1$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $da1f6dc1cffd4cb1$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $da1f6dc1cffd4cb1$var$_saveInputCheckedState(root) {
    $da1f6dc1cffd4cb1$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName("input");
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $da1f6dc1cffd4cb1$var$savedInputChecked.push(el);
    }
}
function $da1f6dc1cffd4cb1$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $da1f6dc1cffd4cb1$var$_cancelNextTick(id) {
    return clearTimeout(id);
}
// Fixed #973:
if ($da1f6dc1cffd4cb1$var$documentExists) $da1f6dc1cffd4cb1$var$on(document, "touchmove", function(evt) {
    if (($da1f6dc1cffd4cb1$export$31b3ca70d8f57423.active || $da1f6dc1cffd4cb1$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
// Export utils
$da1f6dc1cffd4cb1$export$31b3ca70d8f57423.utils = {
    on: $da1f6dc1cffd4cb1$var$on,
    off: $da1f6dc1cffd4cb1$var$off,
    css: $da1f6dc1cffd4cb1$var$css,
    find: $da1f6dc1cffd4cb1$var$find,
    is: function is(el, selector) {
        return !!$da1f6dc1cffd4cb1$var$closest(el, selector, el, false);
    },
    extend: $da1f6dc1cffd4cb1$var$extend,
    throttle: $da1f6dc1cffd4cb1$var$throttle,
    closest: $da1f6dc1cffd4cb1$var$closest,
    toggleClass: $da1f6dc1cffd4cb1$var$toggleClass,
    clone: $da1f6dc1cffd4cb1$var$clone,
    index: $da1f6dc1cffd4cb1$var$index,
    nextTick: $da1f6dc1cffd4cb1$var$_nextTick,
    cancelNextTick: $da1f6dc1cffd4cb1$var$_cancelNextTick,
    detectDirection: $da1f6dc1cffd4cb1$var$_detectDirection,
    getChild: $da1f6dc1cffd4cb1$var$getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.get = function(element) {
    return element[$da1f6dc1cffd4cb1$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.utils = $da1f6dc1cffd4cb1$var$_objectSpread2($da1f6dc1cffd4cb1$var$_objectSpread2({}, $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.utils), plugin.utils);
        $da1f6dc1cffd4cb1$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.create = function(el, options) {
    return new $da1f6dc1cffd4cb1$export$31b3ca70d8f57423(el, options);
};
// Export
$da1f6dc1cffd4cb1$export$31b3ca70d8f57423.version = $da1f6dc1cffd4cb1$var$version;
var $da1f6dc1cffd4cb1$var$autoScrolls = [], $da1f6dc1cffd4cb1$var$scrollEl, $da1f6dc1cffd4cb1$var$scrollRootEl, $da1f6dc1cffd4cb1$var$scrolling = false, $da1f6dc1cffd4cb1$var$lastAutoScrollX, $da1f6dc1cffd4cb1$var$lastAutoScrollY, $da1f6dc1cffd4cb1$var$touchEvt$1, $da1f6dc1cffd4cb1$var$pointerElemChangedInterval;
function $da1f6dc1cffd4cb1$export$3fb39aee5567f02e() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $da1f6dc1cffd4cb1$var$on(document, "dragover", this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $da1f6dc1cffd4cb1$var$on(document, "pointermove", this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $da1f6dc1cffd4cb1$var$on(document, "touchmove", this._handleFallbackAutoScroll);
                else $da1f6dc1cffd4cb1$var$on(document, "mousemove", this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $da1f6dc1cffd4cb1$var$off(document, "dragover", this._handleAutoScroll);
            else {
                $da1f6dc1cffd4cb1$var$off(document, "pointermove", this._handleFallbackAutoScroll);
                $da1f6dc1cffd4cb1$var$off(document, "touchmove", this._handleFallbackAutoScroll);
                $da1f6dc1cffd4cb1$var$off(document, "mousemove", this._handleFallbackAutoScroll);
            }
            $da1f6dc1cffd4cb1$var$clearPointerElemChangedInterval();
            $da1f6dc1cffd4cb1$var$clearAutoScrolls();
            $da1f6dc1cffd4cb1$var$cancelThrottle();
        },
        nulling: function nulling() {
            $da1f6dc1cffd4cb1$var$touchEvt$1 = $da1f6dc1cffd4cb1$var$scrollRootEl = $da1f6dc1cffd4cb1$var$scrollEl = $da1f6dc1cffd4cb1$var$scrolling = $da1f6dc1cffd4cb1$var$pointerElemChangedInterval = $da1f6dc1cffd4cb1$var$lastAutoScrollX = $da1f6dc1cffd4cb1$var$lastAutoScrollY = null;
            $da1f6dc1cffd4cb1$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $da1f6dc1cffd4cb1$var$touchEvt$1 = evt;
            // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $da1f6dc1cffd4cb1$var$Edge || $da1f6dc1cffd4cb1$var$IE11OrLess || $da1f6dc1cffd4cb1$var$Safari) {
                $da1f6dc1cffd4cb1$var$autoScroll(evt, this.options, elem, fallback);
                // Listener for pointer element change
                var ogElemScroller = $da1f6dc1cffd4cb1$var$getParentAutoScrollElement(elem, true);
                if ($da1f6dc1cffd4cb1$var$scrolling && (!$da1f6dc1cffd4cb1$var$pointerElemChangedInterval || x !== $da1f6dc1cffd4cb1$var$lastAutoScrollX || y !== $da1f6dc1cffd4cb1$var$lastAutoScrollY)) {
                    $da1f6dc1cffd4cb1$var$pointerElemChangedInterval && $da1f6dc1cffd4cb1$var$clearPointerElemChangedInterval();
                    // Detect for pointer elem change, emulating native DnD behaviour
                    $da1f6dc1cffd4cb1$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $da1f6dc1cffd4cb1$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $da1f6dc1cffd4cb1$var$clearAutoScrolls();
                        }
                        $da1f6dc1cffd4cb1$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $da1f6dc1cffd4cb1$var$lastAutoScrollX = x;
                    $da1f6dc1cffd4cb1$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $da1f6dc1cffd4cb1$var$getParentAutoScrollElement(elem, true) === $da1f6dc1cffd4cb1$var$getWindowScrollingElement()) {
                    $da1f6dc1cffd4cb1$var$clearAutoScrolls();
                    return;
                }
                $da1f6dc1cffd4cb1$var$autoScroll(evt, this.options, $da1f6dc1cffd4cb1$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $da1f6dc1cffd4cb1$var$_extends(AutoScroll, {
        pluginName: "scroll",
        initializeByDefault: true
    });
}
function $da1f6dc1cffd4cb1$var$clearAutoScrolls() {
    $da1f6dc1cffd4cb1$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $da1f6dc1cffd4cb1$var$autoScrolls = [];
}
function $da1f6dc1cffd4cb1$var$clearPointerElemChangedInterval() {
    clearInterval($da1f6dc1cffd4cb1$var$pointerElemChangedInterval);
}
var $da1f6dc1cffd4cb1$var$autoScroll = $da1f6dc1cffd4cb1$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $da1f6dc1cffd4cb1$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    // New scroll root, set scrollEl
    if ($da1f6dc1cffd4cb1$var$scrollRootEl !== rootEl) {
        $da1f6dc1cffd4cb1$var$scrollRootEl = rootEl;
        $da1f6dc1cffd4cb1$var$clearAutoScrolls();
        $da1f6dc1cffd4cb1$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($da1f6dc1cffd4cb1$var$scrollEl === true) $da1f6dc1cffd4cb1$var$scrollEl = $da1f6dc1cffd4cb1$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $da1f6dc1cffd4cb1$var$scrollEl;
    do {
        var el = currentParent, rect = $da1f6dc1cffd4cb1$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $da1f6dc1cffd4cb1$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$da1f6dc1cffd4cb1$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$da1f6dc1cffd4cb1$var$autoScrolls[i]) $da1f6dc1cffd4cb1$var$autoScrolls[i] = {};
        }
        if ($da1f6dc1cffd4cb1$var$autoScrolls[layersOut].vx != vx || $da1f6dc1cffd4cb1$var$autoScrolls[layersOut].vy != vy || $da1f6dc1cffd4cb1$var$autoScrolls[layersOut].el !== el) {
            $da1f6dc1cffd4cb1$var$autoScrolls[layersOut].el = el;
            $da1f6dc1cffd4cb1$var$autoScrolls[layersOut].vx = vx;
            $da1f6dc1cffd4cb1$var$autoScrolls[layersOut].vy = vy;
            clearInterval($da1f6dc1cffd4cb1$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $da1f6dc1cffd4cb1$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $da1f6dc1cffd4cb1$export$31b3ca70d8f57423.active._onTouchMove($da1f6dc1cffd4cb1$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $da1f6dc1cffd4cb1$var$autoScrolls[this.layer].vy ? $da1f6dc1cffd4cb1$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $da1f6dc1cffd4cb1$var$autoScrolls[this.layer].vx ? $da1f6dc1cffd4cb1$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === "function") {
                        if (scrollCustomFn.call($da1f6dc1cffd4cb1$export$31b3ca70d8f57423.dragged.parentNode[$da1f6dc1cffd4cb1$var$expando], scrollOffsetX, scrollOffsetY, evt, $da1f6dc1cffd4cb1$var$touchEvt$1, $da1f6dc1cffd4cb1$var$autoScrolls[this.layer].el) !== "continue") return;
                    }
                    $da1f6dc1cffd4cb1$var$scrollBy($da1f6dc1cffd4cb1$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $da1f6dc1cffd4cb1$var$getParentAutoScrollElement(currentParent, false)));
    $da1f6dc1cffd4cb1$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $da1f6dc1cffd4cb1$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent("spill");
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $da1f6dc1cffd4cb1$var$Revert() {}
$da1f6dc1cffd4cb1$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $da1f6dc1cffd4cb1$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $da1f6dc1cffd4cb1$var$drop
};
$da1f6dc1cffd4cb1$var$_extends($da1f6dc1cffd4cb1$var$Revert, {
    pluginName: "revertOnSpill"
});
function $da1f6dc1cffd4cb1$var$Remove() {}
$da1f6dc1cffd4cb1$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $da1f6dc1cffd4cb1$var$drop
};
$da1f6dc1cffd4cb1$var$_extends($da1f6dc1cffd4cb1$var$Remove, {
    pluginName: "removeOnSpill"
});
var $da1f6dc1cffd4cb1$export$55b3d9f7b2513474 = [
    $da1f6dc1cffd4cb1$var$Remove,
    $da1f6dc1cffd4cb1$var$Revert
];
var $da1f6dc1cffd4cb1$var$lastSwapEl;
function $da1f6dc1cffd4cb1$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: "sortable-swap-highlight"
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $da1f6dc1cffd4cb1$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $da1f6dc1cffd4cb1$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $da1f6dc1cffd4cb1$var$toggleClass(target, options.swapClass, true);
                    $da1f6dc1cffd4cb1$var$lastSwapEl = target;
                } else $da1f6dc1cffd4cb1$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $da1f6dc1cffd4cb1$var$lastSwapEl) $da1f6dc1cffd4cb1$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $da1f6dc1cffd4cb1$var$lastSwapEl && $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$lastSwapEl, options.swapClass, false);
            if ($da1f6dc1cffd4cb1$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $da1f6dc1cffd4cb1$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $da1f6dc1cffd4cb1$var$swapNodes(dragEl, $da1f6dc1cffd4cb1$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $da1f6dc1cffd4cb1$var$lastSwapEl = null;
        }
    };
    return $da1f6dc1cffd4cb1$var$_extends(Swap, {
        pluginName: "swap",
        eventProperties: function eventProperties() {
            return {
                swapItem: $da1f6dc1cffd4cb1$var$lastSwapEl
            };
        }
    });
}
function $da1f6dc1cffd4cb1$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $da1f6dc1cffd4cb1$var$index(n1);
    i2 = $da1f6dc1cffd4cb1$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $da1f6dc1cffd4cb1$var$multiDragElements = [], $da1f6dc1cffd4cb1$var$multiDragClones = [], $da1f6dc1cffd4cb1$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$da1f6dc1cffd4cb1$var$multiDragSortable, $da1f6dc1cffd4cb1$var$initialFolding = false, // Initial multi-drag fold when drag started
$da1f6dc1cffd4cb1$var$folding = false, // Folding any other time
$da1f6dc1cffd4cb1$var$dragStarted = false, $da1f6dc1cffd4cb1$var$dragEl$1, $da1f6dc1cffd4cb1$var$clonesFromRect, $da1f6dc1cffd4cb1$var$clonesHidden;
function $da1f6dc1cffd4cb1$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $da1f6dc1cffd4cb1$var$on(document, "pointerup", this._deselectMultiDrag);
            else {
                $da1f6dc1cffd4cb1$var$on(document, "mouseup", this._deselectMultiDrag);
                $da1f6dc1cffd4cb1$var$on(document, "touchend", this._deselectMultiDrag);
            }
        }
        $da1f6dc1cffd4cb1$var$on(document, "keydown", this._checkKeyDown);
        $da1f6dc1cffd4cb1$var$on(document, "keyup", this._checkKeyUp);
        this.defaults = {
            selectedClass: "sortable-selected",
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = "";
                if ($da1f6dc1cffd4cb1$var$multiDragElements.length && $da1f6dc1cffd4cb1$var$multiDragSortable === sortable) $da1f6dc1cffd4cb1$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? "" : ", ") + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData("Text", data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $da1f6dc1cffd4cb1$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$da1f6dc1cffd4cb1$var$multiDragElements.indexOf($da1f6dc1cffd4cb1$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $da1f6dc1cffd4cb1$var$multiDragElements.length; i++){
                $da1f6dc1cffd4cb1$var$multiDragClones.push($da1f6dc1cffd4cb1$var$clone($da1f6dc1cffd4cb1$var$multiDragElements[i]));
                $da1f6dc1cffd4cb1$var$multiDragClones[i].sortableIndex = $da1f6dc1cffd4cb1$var$multiDragElements[i].sortableIndex;
                $da1f6dc1cffd4cb1$var$multiDragClones[i].draggable = false;
                $da1f6dc1cffd4cb1$var$multiDragClones[i].style["will-change"] = "";
                $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$multiDragClones[i], this.options.selectedClass, false);
                $da1f6dc1cffd4cb1$var$multiDragElements[i] === $da1f6dc1cffd4cb1$var$dragEl$1 && $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($da1f6dc1cffd4cb1$var$multiDragElements.length && $da1f6dc1cffd4cb1$var$multiDragSortable === sortable) {
                    $da1f6dc1cffd4cb1$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent("clone");
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $da1f6dc1cffd4cb1$var$insertMultiDragClones(false, rootEl);
            $da1f6dc1cffd4cb1$var$multiDragClones.forEach(function(clone) {
                $da1f6dc1cffd4cb1$var$css(clone, "display", "");
            });
            cloneNowShown();
            $da1f6dc1cffd4cb1$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $da1f6dc1cffd4cb1$var$multiDragClones.forEach(function(clone) {
                $da1f6dc1cffd4cb1$var$css(clone, "display", "none");
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $da1f6dc1cffd4cb1$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $da1f6dc1cffd4cb1$var$multiDragSortable) $da1f6dc1cffd4cb1$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $da1f6dc1cffd4cb1$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $da1f6dc1cffd4cb1$var$index(multiDragElement);
            });
            // Sort multi-drag elements
            $da1f6dc1cffd4cb1$var$multiDragElements = $da1f6dc1cffd4cb1$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $da1f6dc1cffd4cb1$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $da1f6dc1cffd4cb1$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $da1f6dc1cffd4cb1$var$dragEl$1) return;
                        $da1f6dc1cffd4cb1$var$css(multiDragElement, "position", "absolute");
                    });
                    var dragRect = $da1f6dc1cffd4cb1$var$getRect($da1f6dc1cffd4cb1$var$dragEl$1, false, true, true);
                    $da1f6dc1cffd4cb1$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $da1f6dc1cffd4cb1$var$dragEl$1) return;
                        $da1f6dc1cffd4cb1$var$setRect(multiDragElement, dragRect);
                    });
                    $da1f6dc1cffd4cb1$var$folding = true;
                    $da1f6dc1cffd4cb1$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $da1f6dc1cffd4cb1$var$folding = false;
                $da1f6dc1cffd4cb1$var$initialFolding = false;
                if (_this2.options.animation) $da1f6dc1cffd4cb1$var$multiDragElements.forEach(function(multiDragElement) {
                    $da1f6dc1cffd4cb1$var$unsetRect(multiDragElement);
                });
                // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $da1f6dc1cffd4cb1$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($da1f6dc1cffd4cb1$var$folding && ~$da1f6dc1cffd4cb1$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($da1f6dc1cffd4cb1$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $da1f6dc1cffd4cb1$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $da1f6dc1cffd4cb1$var$folding ? $da1f6dc1cffd4cb1$var$getRect(multiDragElement) : dragRect
                    });
                    $da1f6dc1cffd4cb1$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $da1f6dc1cffd4cb1$var$folding = false;
                $da1f6dc1cffd4cb1$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $da1f6dc1cffd4cb1$var$initialFolding = false;
                // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $da1f6dc1cffd4cb1$var$multiDragElements.length > 1 && ($da1f6dc1cffd4cb1$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $da1f6dc1cffd4cb1$var$getRect($da1f6dc1cffd4cb1$var$dragEl$1, false, true, true);
                    $da1f6dc1cffd4cb1$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $da1f6dc1cffd4cb1$var$dragEl$1) return;
                        $da1f6dc1cffd4cb1$var$setRect(multiDragElement, dragRectAbsolute);
                        // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $da1f6dc1cffd4cb1$var$folding = true;
                }
                // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$da1f6dc1cffd4cb1$var$folding) $da1f6dc1cffd4cb1$var$removeMultiDragElements();
                    if ($da1f6dc1cffd4cb1$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $da1f6dc1cffd4cb1$var$clonesHidden;
                        activeSortable._showClone(sortable);
                        // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$da1f6dc1cffd4cb1$var$clonesHidden && clonesHiddenBefore) $da1f6dc1cffd4cb1$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $da1f6dc1cffd4cb1$var$clonesFromRect
                            });
                            clone.fromRect = $da1f6dc1cffd4cb1$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $da1f6dc1cffd4cb1$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $da1f6dc1cffd4cb1$var$clonesFromRect = $da1f6dc1cffd4cb1$var$_extends({}, dragRect);
                var dragMatrix = $da1f6dc1cffd4cb1$var$matrix($da1f6dc1cffd4cb1$var$dragEl$1, true);
                $da1f6dc1cffd4cb1$var$clonesFromRect.top -= dragMatrix.f;
                $da1f6dc1cffd4cb1$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($da1f6dc1cffd4cb1$var$folding) {
                $da1f6dc1cffd4cb1$var$folding = false;
                $da1f6dc1cffd4cb1$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children;
            // Multi-drag selection
            if (!$da1f6dc1cffd4cb1$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $da1f6dc1cffd4cb1$var$toggleClass($da1f6dc1cffd4cb1$var$dragEl$1, options.selectedClass, !~$da1f6dc1cffd4cb1$var$multiDragElements.indexOf($da1f6dc1cffd4cb1$var$dragEl$1));
                if (!~$da1f6dc1cffd4cb1$var$multiDragElements.indexOf($da1f6dc1cffd4cb1$var$dragEl$1)) {
                    $da1f6dc1cffd4cb1$var$multiDragElements.push($da1f6dc1cffd4cb1$var$dragEl$1);
                    $da1f6dc1cffd4cb1$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "select",
                        targetEl: $da1f6dc1cffd4cb1$var$dragEl$1,
                        originalEvent: evt
                    });
                    // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $da1f6dc1cffd4cb1$var$lastMultiDragSelect && sortable.el.contains($da1f6dc1cffd4cb1$var$lastMultiDragSelect)) {
                        var lastIndex = $da1f6dc1cffd4cb1$var$index($da1f6dc1cffd4cb1$var$lastMultiDragSelect), currentIndex = $da1f6dc1cffd4cb1$var$index($da1f6dc1cffd4cb1$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            for(; i < n; i++){
                                if (~$da1f6dc1cffd4cb1$var$multiDragElements.indexOf(children[i])) continue;
                                $da1f6dc1cffd4cb1$var$toggleClass(children[i], options.selectedClass, true);
                                $da1f6dc1cffd4cb1$var$multiDragElements.push(children[i]);
                                $da1f6dc1cffd4cb1$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: "select",
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        }
                    } else $da1f6dc1cffd4cb1$var$lastMultiDragSelect = $da1f6dc1cffd4cb1$var$dragEl$1;
                    $da1f6dc1cffd4cb1$var$multiDragSortable = toSortable;
                } else {
                    $da1f6dc1cffd4cb1$var$multiDragElements.splice($da1f6dc1cffd4cb1$var$multiDragElements.indexOf($da1f6dc1cffd4cb1$var$dragEl$1), 1);
                    $da1f6dc1cffd4cb1$var$lastMultiDragSelect = null;
                    $da1f6dc1cffd4cb1$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "deselect",
                        targetEl: $da1f6dc1cffd4cb1$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            }
            // Multi-drag drop
            if ($da1f6dc1cffd4cb1$var$dragStarted && this.isMultiDrag) {
                $da1f6dc1cffd4cb1$var$folding = false;
                // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$da1f6dc1cffd4cb1$var$expando].options.sort || parentEl !== rootEl) && $da1f6dc1cffd4cb1$var$multiDragElements.length > 1) {
                    var dragRect = $da1f6dc1cffd4cb1$var$getRect($da1f6dc1cffd4cb1$var$dragEl$1), multiDragIndex = $da1f6dc1cffd4cb1$var$index($da1f6dc1cffd4cb1$var$dragEl$1, ":not(." + this.options.selectedClass + ")");
                    if (!$da1f6dc1cffd4cb1$var$initialFolding && options.animation) $da1f6dc1cffd4cb1$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$da1f6dc1cffd4cb1$var$initialFolding) {
                        if (options.animation) {
                            $da1f6dc1cffd4cb1$var$dragEl$1.fromRect = dragRect;
                            $da1f6dc1cffd4cb1$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $da1f6dc1cffd4cb1$var$dragEl$1) {
                                    var rect = $da1f6dc1cffd4cb1$var$folding ? $da1f6dc1cffd4cb1$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect;
                                    // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        }
                        // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $da1f6dc1cffd4cb1$var$removeMultiDragElements();
                        $da1f6dc1cffd4cb1$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        });
                        // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $da1f6dc1cffd4cb1$var$index($da1f6dc1cffd4cb1$var$dragEl$1)) {
                            var update = false;
                            $da1f6dc1cffd4cb1$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $da1f6dc1cffd4cb1$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) {
                                dispatchSortableEvent("update");
                                dispatchSortableEvent("sort");
                            }
                        }
                    }
                    // Must be done after capturing individual rects (scroll bar)
                    $da1f6dc1cffd4cb1$var$multiDragElements.forEach(function(multiDragElement) {
                        $da1f6dc1cffd4cb1$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $da1f6dc1cffd4cb1$var$multiDragSortable = toSortable;
            }
            // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") $da1f6dc1cffd4cb1$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $da1f6dc1cffd4cb1$var$dragStarted = false;
            $da1f6dc1cffd4cb1$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $da1f6dc1cffd4cb1$var$off(document, "pointerup", this._deselectMultiDrag);
            $da1f6dc1cffd4cb1$var$off(document, "mouseup", this._deselectMultiDrag);
            $da1f6dc1cffd4cb1$var$off(document, "touchend", this._deselectMultiDrag);
            $da1f6dc1cffd4cb1$var$off(document, "keydown", this._checkKeyDown);
            $da1f6dc1cffd4cb1$var$off(document, "keyup", this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $da1f6dc1cffd4cb1$var$dragStarted !== "undefined" && $da1f6dc1cffd4cb1$var$dragStarted) return;
            // Only deselect if selection is in this sortable
            if ($da1f6dc1cffd4cb1$var$multiDragSortable !== this.sortable) return;
            // Only deselect if target is not item in this sortable
            if (evt && $da1f6dc1cffd4cb1$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return;
            // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($da1f6dc1cffd4cb1$var$multiDragElements.length){
                var el = $da1f6dc1cffd4cb1$var$multiDragElements[0];
                $da1f6dc1cffd4cb1$var$toggleClass(el, this.options.selectedClass, false);
                $da1f6dc1cffd4cb1$var$multiDragElements.shift();
                $da1f6dc1cffd4cb1$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: "deselect",
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $da1f6dc1cffd4cb1$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: "multiDrag",
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$da1f6dc1cffd4cb1$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$da1f6dc1cffd4cb1$var$multiDragElements.indexOf(el)) return;
                if ($da1f6dc1cffd4cb1$var$multiDragSortable && $da1f6dc1cffd4cb1$var$multiDragSortable !== sortable) {
                    $da1f6dc1cffd4cb1$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $da1f6dc1cffd4cb1$var$multiDragSortable = sortable;
                }
                $da1f6dc1cffd4cb1$var$toggleClass(el, sortable.options.selectedClass, true);
                $da1f6dc1cffd4cb1$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$da1f6dc1cffd4cb1$var$expando], index = $da1f6dc1cffd4cb1$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $da1f6dc1cffd4cb1$var$toggleClass(el, sortable.options.selectedClass, false);
                $da1f6dc1cffd4cb1$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $da1f6dc1cffd4cb1$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                });
                // multiDragElements will already be sorted if folding
                var newIndex;
                if ($da1f6dc1cffd4cb1$var$folding && multiDragElement !== $da1f6dc1cffd4cb1$var$dragEl$1) newIndex = -1;
                else if ($da1f6dc1cffd4cb1$var$folding) newIndex = $da1f6dc1cffd4cb1$var$index(multiDragElement, ":not(." + _this3.options.selectedClass + ")");
                else newIndex = $da1f6dc1cffd4cb1$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $da1f6dc1cffd4cb1$var$_toConsumableArray($da1f6dc1cffd4cb1$var$multiDragElements),
                clones: [].concat($da1f6dc1cffd4cb1$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === "ctrl") key = "Control";
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $da1f6dc1cffd4cb1$var$insertMultiDragElements(clonesInserted, rootEl) {
    $da1f6dc1cffd4cb1$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $da1f6dc1cffd4cb1$var$insertMultiDragClones(elementsInserted, rootEl) {
    $da1f6dc1cffd4cb1$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $da1f6dc1cffd4cb1$var$removeMultiDragElements() {
    $da1f6dc1cffd4cb1$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $da1f6dc1cffd4cb1$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
var $da1f6dc1cffd4cb1$export$2e2bcd8739ae039 = $da1f6dc1cffd4cb1$export$31b3ca70d8f57423;




/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * 'n' milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 *
 * @param {function} fn The function to be executed.
 * @param {Number} [wait=0] Time of delay in milliseconds. It is required if `immediate` is used.
 * @param {Boolean} [immediate=false] If true or any truthy value, triggers the function on the leading edge.
 * @throws {TypeError} If `fn` is not function.
 * @returns {function} A new debounced function.
 * @example
 *
 * const debouncedHandler = debounce(() => {
 *   // Do your thing here...
 * }, 250);
 *
 * window.addEventListener('resize', debouncedHandler, false);
 */ const $f7942db15ba0cc81$export$61fc7d43ac8f84b0 = (fn, wait = 0, immediate = false)=>{
    let timerId = null;
    if (typeof fn !== "function") throw new TypeError("Expected a function for first argument");
    return (...args)=>{
        clearTimeout(timerId);
        if (immediate && !timerId) fn(...args);
        timerId = setTimeout(()=>{
            timerId = null;
            if (!immediate) fn(...args);
        }, wait);
    };
};





const $038088370be83852$var$styles = /* css */ `
  :host {
    display: block;
    max-width: 500px;
  }

  files-dropzone {
    --dropzone-border-color: var(--bs-gray-500);
    --dropzone-border-color-dragover: var(--primary-color);
    --dropzone-body-color: var(--body-color);
    --dropzone-background-color: var(--bs-gray-100);
    --dropzone-background-color-dragover: var(--bs-gray-200);

    @media (prefers-color-scheme: dark) {
      --dropzone-border-color: var(--bs-gray-600);
      --dropzone-background-color: var(--bs-gray-800);
      --dropzone-background-color-dragover: var(--bs-gray-700);
    }
  }

  a-tab:focus-visible {
    outline: 0;
    transition: box-shadow 0.15s ease-in-out;
    box-shadow: rgb(13 110 253 / 25%) inset 0px 0px 0px 0.25rem;
  }

  a-tab-group::part(tabs) {
    display: flex;
    padding: 0;
  }

  a-tab-group a-tab {
    flex: 1;
    text-align: center;
    border-bottom: 3px solid transparent;
  }

  a-tab-group a-tab::part(base) {
    display: inline-flex;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
    text-align: center;
  }

  a-tab-group a-tab[selected] {
    border-color: var(--primary-color);
  }

  a-tab-group a-tab[selected]::part(base) {
    color: var(--body-color);
  }

  textarea {
    min-height: 93px !important;
  }
`;
const $038088370be83852$var$template = document.createElement("template");
$038088370be83852$var$template.innerHTML = /* html */ `
  <style>${$038088370be83852$var$styles}</style>

  <a-tab-group no-scroll-controls>
    <a-tab slot="tab" role="heading">From file</a-tab>
    <a-tab-panel slot="panel">
      <div class="px-3">
        <files-dropzone accept="application/json">
          Drag 'n' drop a file, or click to select file to import
          <br />
          <small><em>(Only JSON files are allowed)</em></small>
        </files-dropzone>
      </div>
    </a-tab-panel>

    <a-tab slot="tab" role="heading">From text</a-tab>
    <a-tab-panel slot="panel">
      <form name="import-form" class="px-3">
        <textarea class="form-control mb-3" id="import-data" name="import-data" cols="42" placeholder="Enter the JSON data to import" required></textarea>
        <button type="submit" class="btn btn-primary w-100">Submit</button>
      </form>
    </a-tab-panel>
  </a-tab-group>
`;
class $038088370be83852$var$ImportFeeds extends HTMLElement {
    #dropzoneEl = null;
    #importForm = null;
    constructor(){
        super();
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: "open"
            });
            this.shadowRoot.appendChild($038088370be83852$var$template.content.cloneNode(true));
        }
        this.#dropzoneEl = this.shadowRoot.querySelector("files-dropzone");
        this.#importForm = this.shadowRoot.querySelector('form[name="import-form"]');
        this.shadowRoot.adoptedStyleSheets = (0, $053c683f8862b85c$export$4b9cd30c41328fdd);
    }
    connectedCallback() {
        this.#dropzoneEl.addEventListener("files-dropzone-drop-accepted", this.#handleFilesDropzoneDropAccepted);
        this.#importForm.addEventListener("submit", this.#handleImportFormSubmit);
    }
    disconnectedCallback() {
        this.#dropzoneEl.removeEventListener("files-dropzone-drop-accepted", this.#handleFilesDropzoneDropAccepted);
        this.#importForm.removeEventListener("submit", this.#handleImportFormSubmit);
    }
    #handleFilesDropzoneDropAccepted = (evt)=>{
        const { acceptedFiles: acceptedFiles = [] } = evt.detail;
        const file = acceptedFiles[0];
        if (!file) return;
        const reader = new FileReader();
        reader.readAsText(file, "utf-8");
        reader.onload = this.#handleFileReaderLoad;
    };
    async #importFeeds(feedsToImport) {
        if (!Array.isArray(feedsToImport) || feedsToImport.length === 0) return alert("Invalid file or no feeds found.");
        const { value: feeds = [] } = await (0, $b36f6cb20f27a9a6$export$4890c08c4ffbd57b)();
        for (const feed of feedsToImport){
            const feedExists = Boolean(feeds.find((f)=>f.url === feed.url));
            const { url: url, title: title } = feed;
            const isValidURL = (0, $8ca5c59aef5015ba$export$981c5d1bd3894713)(url);
            if (!feedExists && isValidURL) await (0, $b36f6cb20f27a9a6$export$4b77448646caf424)({
                url: url,
                title: title
            });
        }
        this.dispatchEvent(new Event("feeds-imported", {
            bubbles: true,
            composed: true
        }));
    }
    #handleFileReaderLoad = async (evt)=>{
        try {
            const { result: result } = evt.target;
            this.#importFeeds(JSON.parse(result));
        } catch  {
            alert("The file is not valid.");
        }
    };
    #handleImportFormSubmit = async (evt)=>{
        evt.preventDefault();
        const formData = new FormData(evt.target);
        const data = formData.get("import-data");
        try {
            this.#importFeeds(JSON.parse(data));
        } catch  {
            alert("The data is not valid.");
        }
    };
}
if (!window.customElements.get("import-feeds")) window.customElements.define("import-feeds", $038088370be83852$var$ImportFeeds);


function $94933cc6427541bd$export$c37129e465f64ef0(a) {
    return null !== a && "object" == typeof a ? "share" in navigator && "canShare" in navigator && navigator.canShare(a) : "share" in navigator;
}



const $61303d8a14162a98$export$702e019c6853c7a = (obj, space)=>{
    let res = "";
    try {
        res = JSON.stringify(obj, null, space);
    } catch (err) {
        console.error(err);
    }
    return res;
};


const $4724280f8ebb5bb4$var$styles = /* css */ `
  :host {
    display: block;
    max-width: 500px;
  }

  #exportCode {
    display: block;
    overflow-y: auto;
    max-height: 200px;
    font-size: 0.75rem;
  }

  clipboard-copy::part(button) {
    background-color: transparent;
    border: 0;
    border-radius: 0.25rem;
    padding: 0.25rem 0.5rem;
    color: currentColor;
    cursor: pointer;
    font-family: inherit;
    font-size: 0.875rem;
    line-height: 1.5;
    transition: color 0.15s ease-in-out 0s, background-color 0.15s ease-in-out 0s, border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
  }

  clipboard-copy::part(button):focus {
    outline: 0;
    box-shadow: rgba(13,110,253,.25) 0px 0px 0px 0.25rem;
  }

  clipboard-copy span {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
  }
`;
const $4724280f8ebb5bb4$var$template = document.createElement("template");
$4724280f8ebb5bb4$var$template.innerHTML = /* html */ `
  <style>${$4724280f8ebb5bb4$var$styles}</style>

  <div class="d-flex justify-content-end">
    <clipboard-copy feedback-duration="1500">
      <span slot="copy">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard" viewBox="0 0 16 16" aria-hidden="true">
          <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
          <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
        </svg>
        Copy
      </span>
      <span slot="success">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard-check" viewBox="0 0 16 16" aria-hidden="true">
          <path fill-rule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
          <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
          <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
        </svg>
        Copied
      </span>
    </clipboard-copy>

    <web-share class="${!(0, $94933cc6427541bd$export$c37129e465f64ef0)() ? "d-none" : ""}">
      <button slot="button" class="btn btn-sm btn-default d-flex align-items-center gap-1">
        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512" width="18" height="18" aria-hidden="true">
          <circle cx="128" cy="256" r="48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/>
          <circle cx="384" cy="112" r="48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/>
          <circle cx="384" cy="400" r="48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/>
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M169.83 279.53l172.34 96.94M342.17 135.53l-172.34 96.94"/>
        </svg>
        <span class="label">Share</span>
      </button>
    </web-share>
  </div>

  <div class="card mt-2 mb-3">
    <div class="card-body">
      <pre class="m-0"><code id="exportCode"></code></pre>
    </div>
  </div>

  <button type="button" class="btn btn-primary d-inline-flex align-items-center justify-content-center gap-1 w-100" id="downloadButton">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
      <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
    </svg>
    Download
  </button>
`;
class $4724280f8ebb5bb4$var$ExportFeeds extends HTMLElement {
    #feeds = [];
    #exportCodeEl = null;
    #clipboardCopyEl = null;
    #webShareEl = null;
    #downloadButton = null;
    constructor(){
        super();
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: "open"
            });
            this.shadowRoot.appendChild($4724280f8ebb5bb4$var$template.content.cloneNode(true));
        }
        this.#exportCodeEl = this.shadowRoot.getElementById("exportCode");
        this.#clipboardCopyEl = this.shadowRoot.querySelector("clipboard-copy");
        this.#webShareEl = this.shadowRoot.querySelector("web-share");
        this.#downloadButton = this.shadowRoot.getElementById("downloadButton");
        this.shadowRoot.adoptedStyleSheets = (0, $053c683f8862b85c$export$4b9cd30c41328fdd);
    }
    static get observedAttributes() {
        return [
            "visible"
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "visible" && oldValue !== newValue) {
            const feedsToExport = (0, $61303d8a14162a98$export$702e019c6853c7a)(this.feeds, 2);
            this.#exportCodeEl.textContent = feedsToExport;
            this.#clipboardCopyEl.value = feedsToExport;
            this.#webShareEl.shareText = feedsToExport;
        }
    }
    connectedCallback() {
        this.#downloadButton.addEventListener("click", this.#handleDownloadButtonClick);
    }
    disconnectedCallback() {
        this.#downloadButton.removeEventListener("click", this.#handleDownloadButtonClick);
    }
    get feeds() {
        return this.#feeds;
    }
    set feeds(value) {
        this.#feeds = value || [];
    }
    get visible() {
        return this.hasAttribute("visible");
    }
    set visible(value) {
        this.toggleAttribute("visible", !!value);
    }
    #exportFeeds(feeds) {
        const data = (0, $61303d8a14162a98$export$702e019c6853c7a)(feeds, 2);
        const blob = new Blob([
            data
        ], {
            type: "application/json"
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `rss-feeds-export.json`;
        link.click();
        URL.revokeObjectURL(url);
    }
    #handleDownloadButtonClick = ()=>{
        this.#exportFeeds(this.feeds);
    };
}
if (!window.customElements.get("export-feeds")) window.customElements.define("export-feeds", $4724280f8ebb5bb4$var$ExportFeeds);


const $d02789f57ae99481$var$styles = /* css */ `
  :host {
    display: block;
    --list-item-height: 64px;
  }

  .actions-container {
    display: flex;
    position: sticky;
    top: 0;
    margin-bottom: 0.5rem;
    padding: 0.5rem 0;
    z-index: 1;
    background-color: var(--body-bg);
  }

  .sort-handler {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 45px;
    height: var(--list-item-height);
    cursor: grab;
  }

  .sort-handler[hidden]~.link {
    padding-inline: 1rem;
  }

  .delete-button {
    width: 45px;
    height: var(--list-item-height);
  }

  .link-content {
    line-height: 1.2;
  }

  #noFeedsDisclaimer {
    max-width: 550px;
    margin: 2rem auto 0 auto;
  }

  #importDialog {
    --me-body-spacing: 0;
  }
`;
const $d02789f57ae99481$var$template = document.createElement("template");
$d02789f57ae99481$var$template.innerHTML = /* html */ `
  <style>${$d02789f57ae99481$var$styles}</style>

  <div id="feedsContainer" class="d-none">
    <div class="actions-container">
      <div class="input-group me-2 position-relative">
        <span class="input-group-text">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
          </svg>
        </span>

        <label for="searchInput" class="visually-hidden">Search feeds...</label>
        <input type="text" id="searchInput" class="form-control rounded-end" placeholder="Search feeds..." autocapitalize="off" autocomplete="off" style="padding-right: 38px;" />

        <button type="button" class="btn btn-default btn-sm h-100 position-absolute top-0 end-0 d-flex align-items-center justify-content-center d-none" id="searchClearBtn" style="width: 38px; z-index: 5;" aria-label="Clear search">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
          </svg>
        </button>
      </div>

      <div class="btn-group">
        <button type="button" id="editBtn" class="reorder-button btn btn-outline-primary btn-sm d-flex align-items-center gap-1" aria-label="Edit feeds">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18" aria-hidden="true">
            <path d="M384 224v184a40 40 0 01-40 40H104a40 40 0 01-40-40V168a40 40 0 0140-40h167.48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/>
            <path d="M459.94 53.25a16.06 16.06 0 00-23.22-.56L424.35 65a8 8 0 000 11.31l11.34 11.32a8 8 0 0011.34 0l12.06-12c6.1-6.09 6.67-16.01.85-22.38zM399.34 90L218.82 270.2a9 9 0 00-2.31 3.93L208.16 299a3.91 3.91 0 004.86 4.86l24.85-8.35a9 9 0 003.93-2.31L422 112.66a9 9 0 000-12.66l-9.95-10a9 9 0 00-12.71 0z" fill="currentColor"/>
          </svg>
          <span class="d-none d-sm-block">Edit</span>
        </button>

        <button type="button" id="importBtn" class="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-1" aria-label="Import feeds">
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 512 512" width="20" height="20" style="transform: rotate(180deg);" aria-hidden="true">
            <path d="M336 176h40a40 40 0 0140 40v208a40 40 0 01-40 40H136a40 40 0 01-40-40V216a40 40 0 0140-40h40" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/>
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M176 272l80 80 80-80M256 48v288"/>
          </svg>
          <span class="d-none d-sm-block">Import</span>
        </button>

        <button type="button" id="exportBtn" class="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-1" aria-label="Export feeds">
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 512 512" width="20" height="20" aria-hidden="true">
            <path d="M336 176h40a40 40 0 0140 40v208a40 40 0 01-40 40H136a40 40 0 01-40-40V216a40 40 0 0140-40h40" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/>
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M176 272l80 80 80-80M256 48v288"/>
          </svg>
          <span class="d-none d-sm-block">Export</span>
        </button>
      </div>
    </div>

    <ul class="list-group" id="feedsList"></ul>
  </div>

  <div id="noFeedsDisclaimer" class="text-center d-none">
    <p>
      There are no feeds to display. Add a feed by entering a feed URL in the input above or by importing feeds using the button below.
    </p>

    <p>
      <button type="button" id="importAltBtn" class="btn btn-outline-primary d-inline-flex align-items-center justify-content-center gap-1">
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 512 512" width="18" height="18" style="transform: rotate(180deg);" aria-hidden="true">
          <path d="M336 176h40a40 40 0 0140 40v208a40 40 0 01-40 40H136a40 40 0 01-40-40V216a40 40 0 0140-40h40" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/>
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M176 272l80 80 80-80M256 48v288"/>
        </svg>
        Import feeds
      </button>
    </p>
  </div>

  <modal-element id="importDialog">
    <h2 slot="header" class="h5 m-0">Import feeds</h2>
    <import-feeds></import-feeds>
  </modal-element>

  <modal-element id="exportDialog">
    <h2 slot="header" class="h5 m-0">Export feeds</h2>
    <export-feeds></export-feeds>
  </modal-element>
`;
class $d02789f57ae99481$var$FeedsList extends HTMLElement {
    #isEditable = false;
    #feedsContainerEl = null;
    #feedsListEl = null;
    #editBtn = null;
    #importBtn = null;
    #importAltBtn = null;
    #exportBtn = null;
    #searchInput = null;
    #searchClearBtn = null;
    #importDialog = null;
    #exportDialog = null;
    #importFeedsEl = null;
    #exportFeedsEl = null;
    #noFeedsDisclaimerEl = null;
    constructor(){
        super();
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: "open"
            });
            this.shadowRoot.appendChild($d02789f57ae99481$var$template.content.cloneNode(true));
        }
        this.shadowRoot.adoptedStyleSheets = (0, $053c683f8862b85c$export$4b9cd30c41328fdd);
        this.#feedsContainerEl = this.shadowRoot.getElementById("feedsContainer");
        this.#feedsListEl = this.shadowRoot.getElementById("feedsList");
        this.#editBtn = this.shadowRoot.getElementById("editBtn");
        this.#importBtn = this.shadowRoot.getElementById("importBtn");
        this.#importAltBtn = this.shadowRoot.getElementById("importAltBtn");
        this.#exportBtn = this.shadowRoot.getElementById("exportBtn");
        this.#searchInput = this.shadowRoot.getElementById("searchInput");
        this.#searchClearBtn = this.shadowRoot.getElementById("searchClearBtn");
        this.#importDialog = this.shadowRoot.getElementById("importDialog");
        this.#exportDialog = this.shadowRoot.getElementById("exportDialog");
        this.#importFeedsEl = this.shadowRoot.querySelector("import-feeds");
        this.#exportFeedsEl = this.shadowRoot.querySelector("export-feeds");
        this.#noFeedsDisclaimerEl = this.shadowRoot.getElementById("noFeedsDisclaimer");
    }
    async connectedCallback() {
        const { value: feeds = [] } = await (0, $b36f6cb20f27a9a6$export$4890c08c4ffbd57b)();
        feeds.forEach((feed)=>this.#addFeed(feed));
        this.#toggleFeedsVisibility();
        this.#feedsListEl.addEventListener("click", this.#handleActionsClick);
        this.#editBtn.addEventListener("click", this.#handleEditRequest);
        this.#importAltBtn.addEventListener("click", this.#handleImportRequest);
        this.#importBtn.addEventListener("click", this.#handleImportRequest);
        this.#exportBtn.addEventListener("click", this.#handleExportRequest);
        this.#searchInput.addEventListener("input", this.#handleSearchInputDebounced);
        this.#searchClearBtn.addEventListener("click", this.#handleSearchClear);
        this.#importDialog.addEventListener("me-open", this.#handleImportDialogOpen);
        this.#exportDialog.addEventListener("me-open", this.#handleExportDialogOpen);
        this.#exportDialog.addEventListener("me-close", this.#handleExportDialogClose);
        this.addEventListener("feeds-imported", this.#handleFeedsImported);
        document.addEventListener("feeds-updated", this.#handleFeedsUpdateSuccess);
        new (0, $da1f6dc1cffd4cb1$export$2e2bcd8739ae039)(this.#feedsListEl, {
            animation: 150,
            handle: ".sort-handler",
            onEnd: async (evt)=>{
                const feeds = Array.prototype.map.call(evt.to.querySelectorAll("li"), (el)=>{
                    return {
                        url: el.getAttribute("data-url"),
                        title: el.getAttribute("data-title") || ""
                    };
                });
                await (0, $b36f6cb20f27a9a6$export$a8ce8a4ec117f05e)(feeds, false);
            }
        });
    }
    disconnectedCallback() {
        this.#feedsListEl.removeEventListener("click", this.#handleActionsClick);
        this.#editBtn.removeEventListener("click", this.#handleEditRequest);
        this.#importBtn.removeEventListener("click", this.#handleImportRequest);
        this.#importAltBtn.removeEventListener("click", this.#handleImportRequest);
        this.#exportBtn.removeEventListener("click", this.#handleExportRequest);
        this.#searchInput.removeEventListener("input", this.#handleSearchInputDebounced);
        this.#searchClearBtn.removeEventListener("click", this.#handleSearchClear);
        this.#importDialog.removeEventListener("me-open", this.#handleImportDialogOpen);
        this.#exportDialog.removeEventListener("me-open", this.#handleExportDialogOpen);
        this.#exportDialog.removeEventListener("me-close", this.#handleExportDialogClose);
        this.removeEventListener("feeds-imported", this.#handleFeedsImported);
        document.removeEventListener("feeds-updated", this.#handleFeedsUpdateSuccess);
    }
    #searchFeeds = (searchValue = "")=>{
        const feedEls = this.#feedsListEl.querySelectorAll(`[data-url]`);
        if (feedEls.length === 0) return;
        feedEls.forEach((el)=>{
            const url = (el.getAttribute("data-url") || "").toLowerCase();
            const title = (el.getAttribute("data-title") || "").toLowerCase();
            const searchQuery = searchValue.trim().toLowerCase();
            el.hidden = !(url.includes(searchQuery) || title.includes(searchQuery));
        });
    };
    #debounceSearchFeeds = (0, $f7942db15ba0cc81$export$61fc7d43ac8f84b0)(this.#searchFeeds, 250);
    #handleSearchInputDebounced = (evt)=>{
        const value = evt.target.value;
        this.#searchClearBtn.classList.toggle("d-none", !value);
        return this.#debounceSearchFeeds(value);
    };
    #handleSearchClear = ()=>{
        this.#searchInput.value = "";
        this.#searchInput.dispatchEvent(new Event("input"));
    };
    #handleEditRequest = (evt)=>{
        this.#isEditable = !this.#isEditable;
        evt.currentTarget.classList.toggle("active");
        this.shadowRoot.querySelectorAll(".sort-handler, .delete-button").forEach((el)=>{
            el.hidden = !el.hidden;
        });
    };
    #handleImportRequest = ()=>{
        this.#importDialog.open = true;
    };
    #handleExportRequest = ()=>{
        this.#exportDialog.open = true;
    };
    #handleImportDialogOpen = ()=>{
        try {
            this.#importFeedsEl.shadowRoot.querySelector("a-tab-group").selectTabByIndex(0);
            this.#importFeedsEl.shadowRoot.querySelector("textarea").value = "";
        } catch  {
        // Fail silently
        }
    };
    #handleExportDialogOpen = async ()=>{
        const { value: feeds = [] } = await (0, $b36f6cb20f27a9a6$export$4890c08c4ffbd57b)();
        this.#exportFeedsEl.feeds = feeds;
        this.#exportFeedsEl.setAttribute("visible", "");
    };
    #handleExportDialogClose = ()=>{
        this.#exportFeedsEl.removeAttribute("visible");
    };
    #handleFeedsImported = ()=>{
        this.#importDialog.open = false;
    };
    #handleFeedsUpdateSuccess = (evt)=>{
        if (evt.detail.action === "delete") this.#removeFeed(evt.detail.feed);
        if (evt.detail.action === "create") {
            this.#addFeed(evt.detail.feed);
            if (this.#searchInput.value) {
                this.#searchInput.value = "";
                this.#searchFeeds("");
            }
        }
        if (evt.detail.action === "update") {
            const { url: url, title: title } = evt.detail.feed;
            const feedEl = this.#feedsListEl.querySelector(`[data-url="${url}"]`);
            if (feedEl) {
                const linkContent = feedEl.querySelector(".link-content");
                feedEl.setAttribute("data-title", title || "");
                if (linkContent) linkContent.innerHTML = title ? `${title}<br><small class="text-muted">${url}</small>` : url;
            }
        }
    };
    #handleActionsClick = (evt)=>{
        const target = evt.target;
        const deleteBtn = target.closest("button.delete-button");
        const linkEl = target.closest("a.link");
        if (!linkEl && !deleteBtn) return;
        const feedItem = target.closest("li");
        const feedUrl = feedItem.getAttribute("data-url");
        if (deleteBtn) {
            if (window.confirm(`Are you sure you want to delete feed "${feedUrl}"?`)) (0, $b36f6cb20f27a9a6$export$4e54c6fd9fa8b09b)(feedUrl);
        }
        if (linkEl) {
            evt.preventDefault();
            document.querySelector("feed-reader").feedUrl = feedUrl;
        }
    };
    #addFeed(feed) {
        const { url: url, title: title } = feed;
        const link = document.createElement("a");
        link.className = "link text-decoration-none d-flex align-items-center h-100";
        link.style.flex = "1";
        link.style.minWidth = 0;
        link.style.color = "inherit";
        link.href = url;
        const linkContent = document.createElement("div");
        linkContent.className = "text-truncate link-content";
        linkContent.innerHTML = title ? `${title}<br><small class="text-muted">${url}</small>` : url;
        const deleteButton = document.createElement("button");
        deleteButton.type = "button";
        deleteButton.hidden = !this.#isEditable;
        deleteButton.className = "delete-button btn btn-default text-danger p-0";
        deleteButton.style.lineHeight = "1";
        deleteButton.setAttribute("aria-label", "Delete feed");
        deleteButton.innerHTML = /* html */ `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-trash3-fill" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z"/>
      </svg>
    `;
        const listItem = document.createElement("li");
        listItem.className = "list-group-item p-0 d-flex justify-content-between align-items-center";
        listItem.style.height = "var(--list-item-height)";
        listItem.setAttribute("data-url", url || "");
        listItem.setAttribute("data-title", title || "");
        const sortHandler = document.createElement("div");
        sortHandler.hidden = !this.#isEditable;
        sortHandler.className = "sort-handler text-primary";
        sortHandler.setAttribute("aria-label", "Reorder feed");
        sortHandler.innerHTML = /* html */ `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20" height="20" aria-hidden="true">
        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M96 256h320M96 176h320M96 336h320"/>
      </svg>
    `;
        link.appendChild(linkContent);
        listItem.appendChild(sortHandler);
        listItem.appendChild(link);
        listItem.appendChild(deleteButton);
        this.#feedsListEl.appendChild(listItem);
        this.#toggleFeedsVisibility();
    }
    #removeFeed(feed) {
        const listItem = this.#feedsListEl.querySelector(`[data-url="${feed.url}"]`);
        listItem && listItem.remove();
        this.#toggleFeedsVisibility();
    }
    async #toggleFeedsVisibility() {
        const { value: feeds = [] } = await (0, $b36f6cb20f27a9a6$export$4890c08c4ffbd57b)();
        this.#feedsContainerEl.classList.toggle("d-none", feeds.length === 0);
        this.#noFeedsDisclaimerEl.classList.toggle("d-none", feeds.length > 0);
    }
}
if (!window.customElements.get("feeds-list")) window.customElements.define("feeds-list", $d02789f57ae99481$var$FeedsList);



const $0acd7cf489ccbd45$var$cache = new Map();
const $0acd7cf489ccbd45$export$5b107dfb127cada8 = async (url, requestOptions = {})=>{
    const cachedFeed = $0acd7cf489ccbd45$var$cache.get(url);
    if (cachedFeed) return cachedFeed;
    const res = await fetch("https://api.rss2json.com/v1/api.json?rss_url=" + url, requestOptions);
    if (!res.ok) throw new Error("Error fetching data");
    const json = await res.json();
    $0acd7cf489ccbd45$var$cache.set(url, json);
    return json;
};



let $9af02a843127b0d7$var$controller;
const $9af02a843127b0d7$var$styles = /* css */ `
  :host {
    display: block;
  }

  img[src=""] {
    display: none !important;
  }

  .thumbnail {
    display: block;
    object-fit: cover;
    min-width: 90px;
    width: 90px;
  }

  @media (min-width: 500px) {
    .thumbnail {
      min-width: 120px;
      width: 120px;
    }
  }

  .feed-description-viewer img,
  .feed-description-viewer video {
    max-width: 100%;
    height: auto;
  }

  details summary {
    transition: margin 0.1s ease-out;
  }

  details[open] summary {
    margin-bottom: 0.75rem;
  }

  details:not([open]):not(.card details):last-child summary {
    margin-bottom: 1rem;
  }

  #spinner,
  #error {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    width: 100%;
    height: 100%;
    padding: 1rem;
    text-align: center;
    color: var(--body-color);
  }

  #feedsReaderModal {
    --me-border-radius: 0;
    --body-max-width: 1200px;
  }

  @supports (color: rgb(from white r g b)) {
    #feedsReaderModal {
      --me-background-color: rgb(from var(--body-bg) r g b / 0.75);
    }
  }

  #feedsReaderModal::part(base) {
    backdrop-filter: blur(4px);
  }

  #feedsReaderModal::part(header) {
    gap: 1rem;
    width: 100%;
    max-width: var(--body-max-width);
    margin: 0 auto;
    justify-content: space-between;
  }

  #feedsReaderModal::part(title) {
    min-width: 0;
  }

  #feedsReaderModal .modal-body {
    position: relative;
    max-width: var(--body-max-width);
    margin: 0 auto;
    min-height: 100%;
  }

  #feedsViewer {
    padding: 0 1rem;
  }

  @media screen and (max-width: 1200px) {
    #feedsViewer {
      padding: 0;
    }
  }

  @media (prefers-color-scheme: dark) {
    #feedsReaderModal::part(header) {
      border-color: var(--bs-gray-700);
    }
  }
`;
const $9af02a843127b0d7$var$template = document.createElement("template");
$9af02a843127b0d7$var$template.innerHTML = /* html */ `
  <style>${$9af02a843127b0d7$var$styles}</style>

  <modal-element fullscreen no-animations static-backdrop id="feedsReaderModal">
    <h2 slot="header" id="feedTitle" class="h5 mb-0 text-truncate">

    </h2>

    <div class="modal-body">
      <div id="spinner" class="d-none">
        <span class="spinner-border" aria-hidden="true"></span>
        <span role="status">Please wait...</span>
      </div>

      <div id="error" class="d-none">
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="currentColor" viewBox="0 0 16 16">
          <path d="m9.97 4.88.953 3.811C10.159 8.878 9.14 9 8 9c-1.14 0-2.158-.122-2.923-.309L6.03 4.88C6.635 4.957 7.3 5 8 5s1.365-.043 1.97-.12zm-.245-.978L8.97.88C8.718-.13 7.282-.13 7.03.88L6.275 3.9C6.8 3.965 7.382 4 8 4c.618 0 1.2-.036 1.725-.098zm4.396 8.613a.5.5 0 0 1 .037.96l-6 2a.5.5 0 0 1-.316 0l-6-2a.5.5 0 0 1 .037-.96l2.391-.598.565-2.257c.862.212 1.964.339 3.165.339s2.303-.127 3.165-.339l.565 2.257 2.391.598z"/>
        </svg>
        There was an error while fetching the feed.
      </div>

      <div id="feedsViewer"></div>
    </div>
  </modal-element>
`;
class $9af02a843127b0d7$var$FeedReader extends HTMLElement {
    #spinnerEl = null;
    #dialogEl = null;
    #modalTitle = null;
    #feedsViewer = null;
    #errorEl = null;
    constructor(){
        super();
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: "open"
            });
            this.shadowRoot.appendChild($9af02a843127b0d7$var$template.content.cloneNode(true));
        }
        this.#spinnerEl = this.shadowRoot.getElementById("spinner");
        this.#dialogEl = this.shadowRoot.querySelector("modal-element");
        this.#modalTitle = this.#dialogEl.querySelector("#feedTitle");
        this.#feedsViewer = this.shadowRoot.getElementById("feedsViewer");
        this.#errorEl = this.shadowRoot.getElementById("error");
        this.shadowRoot.adoptedStyleSheets = (0, $053c683f8862b85c$export$4b9cd30c41328fdd);
    }
    static get observedAttributes() {
        return [
            "feed-url"
        ];
    }
    attributeChangedCallback(name) {
        if (name === "feed-url") this.feedUrl ? this.#openFeed(this.feedUrl) : this.#closeFeed();
    }
    connectedCallback() {
        this.#dialogEl.addEventListener("me-close", this.#handleFeedClose);
    }
    disconnectedCallback() {
        this.#dialogEl.removeEventListener("me-close", this.#handleFeedClose);
    }
    get feedUrl() {
        return this.getAttribute("feed-url");
    }
    set feedUrl(value) {
        if (value) this.setAttribute("feed-url", value);
        else this.removeAttribute("feed-url");
    }
    #openFeed(feedUrl) {
        this.#dialogEl.open = true;
        this.#renderFeed(feedUrl);
    }
    #closeFeed() {
        this.#dialogEl.open = false;
    }
    #handleFeedClose = ()=>{
        $9af02a843127b0d7$var$controller && $9af02a843127b0d7$var$controller.abort();
        this.#resetDialogContent();
        this.feedUrl = null;
    };
    #resetDialogContent() {
        this.#feedsViewer.querySelectorAll(".card").forEach((el)=>el.remove());
        this.#modalTitle.innerHTML = "";
        this.#spinnerEl.classList.add("d-none");
        this.#errorEl.classList.add("d-none");
    }
    async #renderFeed(feedUrl) {
        this.#spinnerEl.classList.remove("d-none");
        $9af02a843127b0d7$var$controller = new AbortController();
        try {
            const data = await (0, $0acd7cf489ccbd45$export$5b107dfb127cada8)(feedUrl, {
                signal: $9af02a843127b0d7$var$controller.signal
            });
            const { value: feeds = [] } = await (0, $b36f6cb20f27a9a6$export$4890c08c4ffbd57b)();
            const currentFeed = feeds.find((feed)=>feed.url === feedUrl);
            // Now that feed's title is available, save it to storage.
            if (currentFeed && !currentFeed.title) await (0, $b36f6cb20f27a9a6$export$4b77448646caf424)({
                url: feedUrl,
                title: data.feed.title || ""
            });
            this.#modalTitle.textContent = data.feed.title || feedUrl;
            data.items.forEach((item)=>{
                this.#feedsViewer.insertAdjacentHTML("beforeend", this.#feedsReaderTemplate(item));
            });
        } catch (error) {
            if (error.name !== "AbortError") {
                console.error(error);
                this.#modalTitle.textContent = "";
                this.#errorEl.classList.remove("d-none");
            }
        } finally{
            this.#spinnerEl.classList.add("d-none");
        }
    }
    #feedsReaderTemplate(item) {
        const { link: link, title: title, description: description, author: author, pubDate: pubDate, thumbnail: thumbnail } = item;
        let formattedDate = "";
        try {
            formattedDate = new Intl.DateTimeFormat("en-US", {
                dateStyle: "medium"
            }).format(new Date(pubDate));
        } catch  {
            formattedDate = "-";
        }
        return /* html */ `
      <div class="card mb-3">
        <div class="card-body">
          <a href="${link}" target="_blank" rel="noreferrer noopener" class="d-flex justify-content-between gap-3 text-decoration-none" style="color: inherit;">
            <div style="min-width: 0;">
              <h5 class="card-title h6">${title}</h5>
              <p class="text-muted text-truncate"><small>${formattedDate} ${author ? `&bull; ${author}` : ""}</small></p>
            </div>

            <img src="${thumbnail}" alt="${title}" width="120" height="70" class="thumbnail rounded" loading="lazy" />
          </a>

          <details>
            <summary>Read more...</summary>
            <div class="feed-description-viewer">
              ${description}
            </div>
          </details>
        </div>
      </div>
    `;
    }
}
if (!window.customElements.get("feed-reader")) window.customElements.define("feed-reader", $9af02a843127b0d7$var$FeedReader);


document.adoptedStyleSheets = (0, $053c683f8862b85c$export$4b9cd30c41328fdd);

})();
//# sourceMappingURL=index.d4146a80.js.map
